/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var Colors, Computer, Page, Root;

	__webpack_require__(10);

	__webpack_require__(29);

	__webpack_require__(11);

	__webpack_require__(12);

	__webpack_require__(4);

	__webpack_require__(2);

	__webpack_require__(9);

	__webpack_require__(1);

	__webpack_require__(16);

	__webpack_require__(7);

	__webpack_require__(5);

	__webpack_require__(15);

	__webpack_require__(14);

	__webpack_require__(8);

	window.base_text = {
	  fontSize: 24,
	  fontWeight: 400
	};

	window.light_base_text = _.extend({}, base_text, {
	  fontWeight: 300
	});

	window.small_text = _.extend({}, base_text, {
	  fontSize: 20,
	  fontWeight: browser.high_density_display ? 300 : 400
	});

	window.h1 = _.extend({}, base_text, {
	  fontSize: 42,
	  fontWeight: 800,
	  color: 'white'
	});

	window.h2 = _.extend({}, base_text, {
	  fontSize: 36,
	  fontWeight: 300
	});

	window.strong = _.extend({}, base_text, {
	  fontWeight: 600
	});

	window.focus_color = function() {
	  return customization('focus_color') || focus_blue;
	};

	window.primary_color = function() {
	  var c;
	  c = fetch('colors');
	  return c.primary_color;
	};

	window.seattle_salmon = '#df6264';

	Colors = ReactiveComponent({
	  displayName: 'Colors',
	  render: function() {
	    var color, colors, loc, logo_color;
	    loc = fetch('location');
	    colors = fetch('colors');
	    logo_color = 'white';
	    color = seattle_salmon;
	    switch (loc.url) {
	      case '/':
	        color = seattle_salmon;
	        break;
	      case '/tour':
	        color = '#93B344';
	        break;
	      case '/examples/strategic_planning':
	        color = '#647931';
	        break;
	      case '/examples/decentralized_decisions':
	        color = '#205A83';
	        break;
	      case '/examples':
	      case '/examples/public_engagement':
	        color = '#96367E';
	        break;
	      case '/pricing':
	        color = '#6F3AB0';
	        break;
	      case '/contact':
	        color = '#B03A88';
	        break;
	      case '/create_forum':
	        color = '#65B08C';
	        break;
	      case '/metrics':
	        color = 'white';
	        logo_color = seattle_salmon;
	    }
	    if (colors.primary_color !== color) {
	      colors.primary_color = color;
	      colors.logo_color = logo_color;
	      save(colors);
	    }
	    return SPAN(null);
	  }
	});

	__webpack_require__(26);

	__webpack_require__(19);

	__webpack_require__(23);

	__webpack_require__(20);

	__webpack_require__(17);

	__webpack_require__(25);

	__webpack_require__(18);

	__webpack_require__(24);

	__webpack_require__(27);

	__webpack_require__(22);

	__webpack_require__(21);

	Page = ReactiveComponent({
	  displayName: "Page",
	  mixins: [AccessControlled],
	  render: function() {
	    var footer_height, loc;
	    loc = fetch('location');
	    footer_height = fetch('footer').height;
	    return DIV({
	      style: {
	        backgroundColor: primary_color(),
	        transition: 'background-color 500ms ease',
	        minHeight: '100%'
	      }
	    }, loc.query_params.play_demo ? Video({
	      playing: true
	    }) : Header(), (function() {
	      if (loc.url.indexOf('/examples') > -1) {
	        return ExamplesPage();
	      } else {
	        switch (loc.url) {
	          case '/metrics':
	            return Metrics();
	          case '/':
	            return LandingPage();
	          case '/tour':
	            return Tour();
	          case '/pricing':
	            return Pricing();
	          case '/contact':
	            return Contact();
	          case '/create_forum':
	            return CustomerSignup();
	          case '/privacy_policy':
	            return PrivacyPolicy();
	          case '/terms_of_service':
	            return TermsOfService();
	        }
	      }
	    })(), Footer());
	  }
	});

	Computer = ReactiveComponent({
	  displayName: 'Computer',
	  render: function() {
	    var doc, title;
	    doc = fetch('document');
	    title = 'Consider.it';
	    if (doc.title !== title) {
	      doc.title = title;
	      save(doc);
	    }
	    return SPAN(null);
	  }
	});

	window.big_button = function() {
	  return {
	    backgroundColor: primary_color(),
	    boxShadow: "0 4px 0 0 black",
	    fontWeight: 700,
	    color: 'white',
	    padding: '8px 60px',
	    display: 'inline-block',
	    fontSize: 24,
	    border: 'none',
	    borderRadius: 8
	  };
	};

	window.BIG_BUTTON = function(text, opts) {
	  opts.style || (opts.style = {});
	  _.defaults(opts.style, big_button());
	  return BUTTON({
	    style: opts.style,
	    onClick: opts.onClick,
	    onKeyPress: function(e) {
	      if (e.which === 13 || e.which === 32) {
	        e.preventDefault();
	        return opts.onClick(e);
	      }
	    }
	  }, text);
	};

	Root = ReactiveComponent({
	  displayName: "Root",
	  onTouchMove: function() {
	    return window.is_swipping = true;
	  },
	  onTouchEnd: function() {
	    return window.is_swipping = false;
	  },
	  render: function() {
	    return DIV(null, STYLE({
	      dangerouslySetInnerHTML: {
	        __html: "#content, #content input, #content button, #content textarea {\n    font-family: 'Avenir Next W01', 'Avenir Next', 'Lucida Grande', 'Lucida Sans Unicode', 'Helvetica Neue', Helvetica, Verdana, sans-serif;\n}"
	      }
	    }), BrowserLocation(), BrowserHacks(), Page(), Tooltip({
	      style: {
	        color: 'black',
	        maxWidth: 500,
	        padding: '16px 24px'
	      }
	    }), Computer(), Colors());
	  }
	});

	window.Saas = Root;

	__webpack_require__(13);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var css_as_str, el, focus_shadow, height_cache, newest_in_cluster_on_load, size_cache, width_cache,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
	  hasProp = {}.hasOwnProperty;

	__webpack_require__(28);

	__webpack_require__(6);

	window.GoogleTranslate = ReactiveComponent({
	  displayName: 'GoogleTranslate',
	  render: function() {
	    var homepage, loc, style;
	    loc = fetch('location');
	    homepage = loc.url === '/';
	    style = customization('google_translate_style') && homepage ? customization('google_translate_style') : _.defaults({}, this.props.style, {
	      textAlign: 'center',
	      marginBottom: 10
	    });
	    return DIV({
	      key: "google_translate_element_" + this.local.key,
	      id: "google_translate_element_" + this.local.key,
	      style: style
	    });
	  },
	  insertTranslationWidget: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    return new google.translate.TranslateElement({
	      pageLanguage: subdomain.lang,
	      layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
	      multilanguagePage: true
	    }, "google_translate_element_" + this.local.key);
	  },
	  componentDidMount: function() {
	    return this.int = setInterval((function(_this) {
	      return function() {
	        var ref;
	        if ((typeof google !== "undefined" && google !== null ? (ref = google.translate) != null ? ref.TranslateElement : void 0 : void 0) != null) {
	          _this.insertTranslationWidget();
	          return clearInterval(_this.int);
	        }
	      };
	    })(this), 20);
	  },
	  componentWillUnmount: function() {
	    return clearInterval(this.int);
	  }
	});

	window.pad = function(num, len) {
	  var dec, i, str;
	  str = num;
	  dec = str.split('.');
	  i = 0;
	  while (i < len - dec[0].toString().length) {
	    dec[0] = "0" + dec[0];
	    i += 1;
	  }
	  return dec[0] + (dec.length > 0 ? '.' + dec[1] : '');
	};

	window.back_to_homepage_button = function(style) {
	  var hash, homepage, loc;
	  loc = fetch('location');
	  homepage = loc.url === '/';
	  hash = loc.url.split('/')[1].replace('-', '_');
	  return NAV({
	    role: 'navigation'
	  }, A({
	    className: 'back_to_homepage',
	    title: 'back to homepage',
	    key: 'back_to_homepage_button',
	    href: "/#" + hash,
	    style: _.defaults({}, style, {
	      fontSize: 43,
	      visibility: homepage || !customization('has_homepage') ? 'hidden' : 'visible',
	      color: 'black'
	    })
	  }, '<'));
	};

	for (el in React.DOM) {
	  window[el.toUpperCase()] = React.DOM[el];
	}

	window.styles = "";

	window.TRANSITION_SPEED = 700;

	window.LIVE_UPDATE_INTERVAL = 3 * 60 * 1000;

	setInterval(function() {
	  var dependent_keys, key, proposals;
	  dependent_keys = [];
	  proposals = false;
	  for (key in arest.components_4_key.hash) {
	    if (key[0] === '/' && arest.components_4_key.get(key).length > 0 && !key.match(/\/(user|opinion|point|proposals)\//)) {
	      if (key.match(/\/proposal\//)) {
	        proposals = true;
	      } else if (key !== '/current_user' || fetch('/current_user').logged_in) {
	        arest.serverFetch(key);
	      }
	    }
	  }
	  if (proposals) {
	    return arest.serverFetch('/proposals');
	  }
	}, LIVE_UPDATE_INTERVAL);

	window.POINT_MOUTH_WIDTH = 17;

	window.FB_SHARE = ReactiveComponent({
	  displayName: 'FB_SHARE',
	  render: function() {
	    return IFRAME({
	      src: "https://www.facebook.com/plugins/share_button.php?href=" + (encodeURI(this.props.href)) + "&layout=button&size=large&mobile_iframe=false&appId=" + this.props.appId + "&width=73&height=28",
	      width: this.props.width || "73",
	      height: this.props.height || "28",
	      style: {
	        border: 'none',
	        overflow: 'hidden'
	      },
	      scrolling: "no",
	      frameborder: "0",
	      allowTransparency: "true"
	    });
	  }
	});

	window.TWEET = ReactiveComponent({
	  displayName: 'Tweet',
	  render: function() {
	    var j, len1, ref, url, url_param;
	    url = "https://platform.twitter.com/widgets/tweet_button.html?size=l&count=none&id=twitter-widget-0&lang=en";
	    ref = ['hashtags', 'original_referer', 'related', 'text', 'url'];
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      url_param = ref[j];
	      if (this.props[url_param]) {
	        if (url_param === 'url') {
	          this.props[url_param] = encodeURI(this.props[url_param]);
	        }
	        url += "&" + url_param + "=" + this.props[url_param];
	      }
	    }
	    return IFRAME({
	      src: url,
	      scrolling: "no",
	      frameBorder: "0",
	      allowTransparency: "true",
	      className: "twitter-share-button twitter-tweet-button twitter-share-button twitter-count-none",
	      style: {
	        width: 80,
	        height: 28
	      }
	    });
	  }
	});

	window.getCoords = function(el) {
	  var docEl, offset, rect;
	  rect = el.getBoundingClientRect();
	  docEl = document.documentElement;
	  offset = {
	    top: rect.top + window.pageYOffset - docEl.clientTop,
	    left: rect.left + window.pageXOffset - docEl.clientLeft
	  };
	  return _.extend(offset, {
	    cx: offset.left + rect.width / 2,
	    cy: offset.top + rect.height / 2,
	    right: offset.left + rect.width,
	    bottom: offset.top + rect.height
	  });
	};

	window.asset = function(name) {
	  var a, app;
	  app = fetch('/application');
	  if (app.app != null) {
	    a = (app.asset_host || '') + "/images/" + name;
	  } else {
	    a = (window.asset_host || '') + "/images/" + name;
	  }
	  return a;
	};

	window.opinionsForProposal = function(proposal) {
	  var opinions;
	  opinions = fetch(proposal).opinions || [];
	  return opinions;
	};

	window.get_all_clusters = function() {
	  var all_clusters, always_show, p, proposals;
	  proposals = fetch('/proposals');
	  always_show = customization('homepage_lists_to_always_show');
	  all_clusters = (function() {
	    var j, len1, ref, results;
	    ref = proposals.proposals;
	    results = [];
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      p = ref[j];
	      results.push((p.cluster || 'Proposals').trim());
	    }
	    return results;
	  })();
	  all_clusters = all_clusters.concat(always_show);
	  all_clusters = _.uniq(all_clusters);
	  return all_clusters;
	};

	newest_in_cluster_on_load = {};

	window.clustered_proposals = function(keep_as_map) {
	  var all_clusters, cluster, clusters, homepage_list_order, j, len1, len2, len3, m, n, ordered_clusters, proposal, proposals, ref, ref1, sort, time;
	  proposals = fetch('/proposals');
	  homepage_list_order = customization('homepage_list_order');
	  clusters = {};
	  all_clusters = get_all_clusters();
	  if (Object.keys(newest_in_cluster_on_load).length === 0) {
	    ref = proposals.proposals;
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      proposal = ref[j];
	      cluster = (proposal.cluster || 'Proposals').trim();
	      time = new Date(proposal.created_at).getTime();
	      if (!newest_in_cluster_on_load[cluster] || time > newest_in_cluster_on_load[cluster]) {
	        newest_in_cluster_on_load[cluster] = time;
	      }
	    }
	  }
	  for (m = 0, len2 = all_clusters.length; m < len2; m++) {
	    cluster = all_clusters[m];
	    sort = homepage_list_order.indexOf(cluster);
	    if (sort < 0) {
	      if (newest_in_cluster_on_load[cluster]) {
	        sort = homepage_list_order.length + ((new Date()).getTime() - newest_in_cluster_on_load[cluster]);
	      } else {
	        sort = 9999999999999;
	      }
	    }
	    clusters[cluster] = {
	      key: "list/" + cluster,
	      name: cluster,
	      proposals: [],
	      list_is_archived: customization('list_is_archived', "list/" + cluster),
	      sort_order: sort
	    };
	  }
	  ref1 = proposals.proposals;
	  for (n = 0, len3 = ref1.length; n < len3; n++) {
	    proposal = ref1[n];
	    cluster = (proposal.cluster || 'Proposals').trim();
	    clusters[cluster].proposals.push(proposal);
	  }
	  if (keep_as_map) {
	    return clusters;
	  }
	  ordered_clusters = _.values(clusters);
	  ordered_clusters.sort(function(a, b) {
	    return a.sort_order - b.sort_order;
	  });
	  return ordered_clusters;
	};

	window.clustered_proposals_with_tabs = function() {
	  var all_clusters, cluster, cluster_key, clusters, fails_filter, filter, homepage_tabs, in_others, index, j, len1, ref, ref1, ref2, ref3, to_remove;
	  all_clusters = clustered_proposals();
	  homepage_tabs = fetch('homepage_tabs');
	  if (homepage_tabs.filter != null) {
	    to_remove = [];
	    ref = all_clusters || [];
	    for (index = j = 0, len1 = ref.length; j < len1; index = ++j) {
	      cluster = ref[index];
	      cluster_key = "list/" + cluster.name;
	      fails_filter = (homepage_tabs.filter != null) && (homepage_tabs.clusters !== '*' && !(ref1 = cluster.name, indexOf.call(homepage_tabs.clusters, ref1) >= 0));
	      if (fails_filter && (indexOf.call(homepage_tabs.clusters, '*') >= 0)) {
	        in_others = [];
	        ref2 = customization('homepage_tabs');
	        for (filter in ref2) {
	          clusters = ref2[filter];
	          in_others = in_others.concat(clusters);
	        }
	        fails_filter && (fails_filter = (ref3 = cluster.name, indexOf.call(in_others, ref3) >= 0));
	      }
	      if (fails_filter) {
	        to_remove.push(cluster);
	      }
	    }
	    all_clusters = _.difference(all_clusters, to_remove);
	  }
	  return all_clusters;
	};

	window.namespaced_key = function(base_key, base_object) {
	  var namespace_key;
	  namespace_key = fetch(base_object).key;
	  if (namespace_key[0] === '/') {
	    namespace_key = namespace_key.substring(1, namespace_key.length);
	  }
	  return namespace_key + "_" + base_key;
	};

	window.proposal_url = (function(_this) {
	  return function(proposal) {
	    var result, subdomain;
	    proposal = fetch(proposal);
	    result = '/' + proposal.slug;
	    subdomain = fetch('/subdomain');
	    if (subdomain.name === 'homepage') {
	      subdomain = fetch("/subdomain/" + proposal.subdomain_id);
	      result = ("https://" + subdomain.host_with_port) + result;
	    }
	    if (TWO_COL() || (!customization('show_crafting_page_first', proposal) || !proposal.active) || (!customization('discussion_enabled', proposal))) {
	      result += '?results=true';
	    }
	    return result;
	  };
	})(this);

	window.isNeutralOpinion = function(stance) {
	  return Math.abs(stance) < 0.05;
	};

	window.on_ajax_error = function() {
	  var root;
	  (root = fetch('root')).server_error = true;
	  return save(root);
	};

	window.on_client_error = function(e) {
	  if (navigator.userAgent.indexOf('PhantomJS') >= 0) {
	    return;
	  }
	  return save({
	    key: '/new/client_error',
	    stack: e.stack,
	    message: e.message || e.description,
	    name: e.name,
	    line_number: e.lineNumber,
	    column_number: e.columnNumber
	  });
	};

	window.writeToLog = function(entry) {
	  _.extend(entry, {
	    key: '/new/log',
	    where: fetch('location').url
	  });
	  return save(entry);
	};

	window.prettyDate = function(time) {
	  var date, day_diff, diff, r, subdomain;
	  subdomain = fetch('/subdomain');
	  date = new Date(time);
	  diff = ((new Date()).getTime() - date.getTime()) / 1000;
	  day_diff = Math.floor(diff / 86400);
	  if (isNaN(day_diff) || day_diff < 0) {
	    return;
	  }
	  if (subdomain.lang !== 'en') {
	    return (date.getMonth() + 1) + "/" + (date.getDay() + 1) + "/" + (date.getFullYear());
	  }
	  r = day_diff === 0 && (diff < 60 && "just now" || diff < 120 && "1 minute ago" || diff < 3600 && Math.floor(diff / 60) + " minutes ago" || diff < 7200 && "1 hour ago" || diff < 86400 && Math.floor(diff / 3600) + " hours ago") || day_diff === 1 && "Yesterday" || day_diff < 7 && day_diff + " days ago" || day_diff < 31 && Math.ceil(day_diff / 7) + " weeks ago" || ((date.getMonth() + 1) + "/" + (date.getDay() + 1) + "/" + (date.getFullYear()));
	  r = r.replace('1 days ago', '1 day ago').replace('1 weeks ago', '1 week ago').replace('1 years ago', '1 year ago');
	  return r;
	};

	window.shorten = function(str, max_length) {
	  max_length || (max_length = 70);
	  return "" + (str.substring(0, max_length)) + (str.length > max_length ? '...' : '');
	};

	window.inRange = function(val, min, max) {
	  return val <= max && val >= min;
	};

	window.capitalize = function(string) {
	  return string.charAt(0).toUpperCase() + string.substring(1);
	};

	window.capitalize_each_word = function(str) {
	  return str.replace(/\b\w/g, function(l) {
	    return l.toUpperCase();
	  });
	};

	window.L = window.LOADING_INDICATOR = DIV(null, 'Loading...');

	window.shared_local_key = function(key_or_object) {
	  var key;
	  key = key_or_object.key || key_or_object;
	  if (key[0] === '/') {
	    key = key.substring(1, key.length);
	    return key + "/shared";
	  } else {
	    return key;
	  }
	};

	window.reset_key = function(obj_or_key, updates) {
	  var k, v;
	  updates = updates || {};
	  if (!obj_or_key.key) {
	    obj_or_key = fetch(obj_or_key);
	  }
	  for (k in obj_or_key) {
	    if (!hasProp.call(obj_or_key, k)) continue;
	    v = obj_or_key[k];
	    if (k !== 'key') {
	      delete obj_or_key[k];
	    }
	  }
	  _.extend(obj_or_key, updates);
	  return save(obj_or_key);
	};

	window.safe_string = function(user_content) {
	  var hyperlink_pattern;
	  user_content = user_content.replace(/(<li>|<br\s?\/?>|<p>)/g, '\n');
	  user_content = user_content.replace(/(<([^>]+)>)/ig, "");
	  hyperlink_pattern = /(^|[\s\n])((?:https?):\/\/[\-A-Z0-9+\u0026\u2019@#\/%?=()\[\]\-\$&\*~_|!:,.;']*[\-A-Z0-9+\u0026@#\/%=~()_|])/gi;
	  user_content = user_content.replace(hyperlink_pattern, "$1(*-&)link:$2(*-&)");
	  return user_content;
	};

	window.splitParagraphs = function(user_content, append) {
	  var idx, j, len1, para, paragraphs, pidx, results, text;
	  if (!user_content) {
	    return SPAN(null);
	  }
	  user_content = safe_string(user_content);
	  paragraphs = user_content.split(/(?:\r?\n)/g);
	  results = [];
	  for (pidx = j = 0, len1 = paragraphs.length; j < len1; pidx = ++j) {
	    para = paragraphs[pidx];
	    results.push(P({
	      key: "para-" + pidx
	    }, (function() {
	      var len2, m, ref, results1;
	      ref = para.split('(*-&)');
	      results1 = [];
	      for (idx = m = 0, len2 = ref.length; m < len2; idx = ++m) {
	        text = ref[idx];
	        if (text.substring(0, 5) === 'link:') {
	          results1.push(A({
	            key: idx,
	            href: text.substring(5, text.length),
	            target: '_blank'
	          }, text.substring(5, text.length)));
	        } else {
	          results1.push(SPAN({
	            key: idx
	          }, text));
	        }
	      }
	      return results1;
	    })(), append && pidx === paragraphs.length - 1 ? append : void 0));
	  }
	  return results;
	};

	width_cache = {};

	window.widthWhenRendered = function(str, style) {
	  var $el, key, width;
	  key = JSON.stringify(_.extend({
	    str: str
	  }, style));
	  if (!(key in width_cache)) {
	    _.defaults(style, {
	      display: 'inline-block'
	    });
	    $el = $("<span id='width_test'><span>" + str + "</span></span>").css(style);
	    $('#content').append($el);
	    width = $('#width_test span').width();
	    $('#width_test').remove();
	    width_cache[key] = width;
	  }
	  return width_cache[key];
	};

	height_cache = {};

	window.heightWhenRendered = function(str, style) {
	  var $el, height, key;
	  key = JSON.stringify(_.extend({
	    str: str
	  }, style));
	  if (!(key in height_cache)) {
	    $el = $("<div id='height_test'>" + str + "</div>").css(style);
	    $('#content').append($el);
	    height = $('#height_test').height();
	    $('#height_test').remove();
	    height_cache[key] = height;
	  }
	  return height_cache[key];
	};

	size_cache = {};

	window.sizeWhenRendered = function(str, style) {
	  var h, k, key, main, test, v, w;
	  main = document.getElementById('content');
	  if (!main) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	  style || (style = {});
	  style.str = str;
	  key = JSON.stringify(style);
	  delete style.str;
	  if (!(key in size_cache)) {
	    style.display || (style.display = 'inline-block');
	    test = document.createElement("div");
	    test.innerHTML = "<div>" + str + "</div>";
	    for (k in style) {
	      v = style[k];
	      key = k.replace(/([A-Z])/g, '-$1').toLowerCase();
	      if (key === 'font-size' || key === 'max-width' || key === 'max-height') {
	        test.style[key] = v + "px";
	      } else {
	        test.style[key] = v;
	      }
	    }
	    main.appendChild(test);
	    h = test.offsetHeight;
	    w = test.offsetWidth;
	    main.removeChild(test);
	    size_cache[key] = {
	      width: w,
	      height: h
	    };
	  }
	  return size_cache[key];
	};

	window.translateStanceToPixelX = function(stance, width) {
	  return (stance + 1) / 2 * width;
	};

	window.translatePixelXToStance = function(pixel_x, width) {
	  return 2 * (pixel_x / width) - 1;
	};

	window.closest = function(node, check) {
	  if (!node || node === document) {
	    return false;
	  } else {
	    return check(node) || closest(node.parentNode, check);
	  }
	};

	window.location_origin = function() {
	  if (!window.location.origin) {
	    return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	  } else {
	    return window.location.origin;
	  }
	};

	window.parseURL = function(url) {
	  var i, parser, pathname, queries, searchObject, split;
	  parser = document.createElement('a');
	  parser.href = url;
	  pathname = parser.pathname || '/';
	  if (pathname[0] !== '/') {
	    pathname = "/" + pathname;
	  }
	  searchObject = {};
	  queries = parser.search.replace(/^\?/, '').split('&');
	  i = 0;
	  while (i < queries.length) {
	    if (queries[i].length > 0) {
	      split = queries[i].split('=');
	      searchObject[split[0]] = split[1];
	    }
	    i++;
	  }
	  return {
	    protocol: parser.protocol,
	    host: parser.host,
	    hostname: parser.hostname,
	    port: parser.port,
	    pathname: pathname,
	    search: parser.search,
	    searchObject: searchObject,
	    hash: parser.hash
	  };
	};

	window.css = {};

	css_as_str = function(attrs) {
	  return _.keys(attrs).map(function(p) {
	    return p + ": " + attrs[p];
	  }).join(';') + ';';
	};

	css.crossbrowserify = function(props, as_str) {
	  var j, len1, len2, len3, len4, len5, len6, m, n, o, prefix, prefixes, q, s;
	  if (as_str == null) {
	    as_str = false;
	  }
	  prefixes = ['-webkit-', '-ms-', '-mox-', '-o-'];
	  if (props.transform) {
	    for (j = 0, len1 = prefixes.length; j < len1; j++) {
	      prefix = prefixes[j];
	      props[prefix + "transform"] = props.transform;
	    }
	  }
	  if (props.transformOrigin) {
	    for (m = 0, len2 = prefixes.length; m < len2; m++) {
	      prefix = prefixes[m];
	      props[prefix + "transform-origin"] = props.transform;
	    }
	  }
	  if (props.flex) {
	    for (n = 0, len3 = prefixes.length; n < len3; n++) {
	      prefix = prefixes[n];
	      props[prefix + "flex"] = props.flex;
	    }
	  }
	  if (props.flexDirection) {
	    for (o = 0, len4 = prefixes.length; o < len4; o++) {
	      prefix = prefixes[o];
	      props[prefix + "flex-direction"] = props.flexDirection;
	    }
	  }
	  if (props.justifyContent) {
	    for (q = 0, len5 = prefixes.length; q < len5; q++) {
	      prefix = prefixes[q];
	      props[prefix + "justify-content"] = props.justifyContent;
	    }
	  }
	  if (props.display === 'flex') {
	    props.display = 'display: table-cell; -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex';
	  }
	  if (props.transition) {
	    for (s = 0, len6 = prefixes.length; s < len6; s++) {
	      prefix = prefixes[s];
	      props[prefix + "transition"] = props.transition.replace("transform", prefix + "transform");
	    }
	  }
	  if (props.userSelect) {
	    _.extend(props, {
	      MozUserSelect: props.userSelect,
	      WebkitUserSelect: props.userSelect,
	      msUserSelect: props.userSelect
	    });
	  }
	  if (as_str) {
	    return css_as_str(props);
	  } else {
	    return props;
	  }
	};

	css.grayscale = function(props) {
	  if (browser.is_mobile) {
	    console.log("CAUTION: grayscale filter on mobile can cause crashes");
	  }
	  _.extend(props, {
	    WebkitFilter: 'grayscale(100%)',
	    filter: 'grayscale(100%)'
	  });
	  return props;
	};

	css.grab_cursor = function(selector) {
	  return selector + " {\n  cursor: move;\n  cursor: ew-resize;\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n} " + selector + ":active {\n  cursor: move;\n  cursor: ew-resize;\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n}";
	};

	window.cssTriangle = function(direction, color, width, height, style) {
	  var border_color, border_width;
	  style = style || {};
	  switch (direction) {
	    case 'top':
	      border_width = "0 " + (width / 2) + "px " + height + "px " + (width / 2) + "px";
	      border_color = "transparent transparent " + color + " transparent";
	      break;
	    case 'bottom':
	      border_width = height + "px " + (width / 2) + "px 0 " + (width / 2) + "px";
	      border_color = color + " transparent transparent transparent";
	      break;
	    case 'left':
	      border_width = (height / 2) + "px " + width + "px " + (height / 2) + "px 0";
	      border_color = "transparent " + color + " transparent transparent";
	      break;
	    case 'right':
	      border_width = (height / 2) + "px 0 " + (height / 2) + "px " + width + "px";
	      border_color = "transparent transparent transparent " + color;
	  }
	  _.defaults(style, {
	    width: 0,
	    height: 0,
	    borderStyle: 'solid',
	    borderWidth: border_width,
	    borderColor: border_color
	  });
	  return style;
	};

	window.slugify = function(text) {
	  return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
	};

	focus_shadow = 'inset 0 0 2px rgba(0,0,0,.3), 0 0 2px rgba(0,0,0,.3)';

	window.styles += "/* RESET\n * Eric Meyer's Reset CSS v2.0 (http://meyerweb.com/eric/tools/css/reset/)\n * http://cssreset.com\n */\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  line-height: 1.4; }\n\n\n#content .fa {\n  font-family: FontAwesome;  \n}\n\nbody, html {\n  height: 100%;\n}\nbutton {\n  line-height: 1.4;\n}\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #cccccc;\n  margin: 0;\n  padding: 0; }\n\nbody {\n  min-height: 100%; }\n\nol, ul {\n  list-style: none;\n  list-style-position: inside; }\n\nblockquote, q {\n  quotes: none; }\n\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: '';\n  content: none; }\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\n\ntd, th {vertical-align: top;}\n\nh1, h2, h3, h4, h5, h6, strong {\n  font-weight: bold; }\n\nem, i {\n  font-style: italic; }\n\nb, strong { font-weight: bold; }\n\n/* ELEMENT DEFAULTS */\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box; }\n\na {\n  color: inherit;\n  cursor: pointer;\n  text-decoration: none; }\n  a:focus {\n  }\n  a:active {\n  }  \n  a img {\n    border: none; }\n\n:focus {\n}\n.button, button, input[type='submit'] {\n  cursor: pointer;\n  text-align: center; \n  font-size: inherit;\n} .button:focus, button:focus, input[type='submit']:focus {\n} .button:active:focus, button:active:focus, input[type='submit']:active:focus{\n}\n\n\ntable {\n  border-collapse: separate; }\n\nul {\n  margin: 0;\n  list-style-type: disc; }\n\nol {\n  margin: 0;\n  list-style-type: decimal; }\n\nblockquote {\n  quotes: '\"' '\"' \"'\" \"'\"; }\n  blockquote:before {\n    content: open-quote;}\n  blockquote:after {\n    content: close-quote;}\n";

	window.styles += "\nbody, h1, h2, h3, h4, h5, h6 {\n  color: black; }\n\nhtml[lang='cs'] body, html[lang='cs'] input, html[lang='cs'] button, html[lang='cs'] textarea {\n  font-family: Helvetica, Verdana, Arial, 'Lucida Grande', 'Lucida Sans Unicode', sans-serif; }\n\n\n.hidden {\n  position:absolute;\n  left:-10000px;\n  top:auto;\n  width:1px;\n  height:1px;\n  overflow:hidden;}\n\na.skip:active, \na.skip:focus, \na.skip:hover {\n    position: fixed;\n    left: 0; \n    top: 0;\n    width: auto; \n    height: auto; \n    overflow: visible; \n}\n\n\n.content {\n  position: relative;\n  font-size: 16px;\n  color: black;\n  min-height: 100%; }\n\n\n.flipped {\n  -moz-transform: scaleX(-1);\n  -o-transform: scaleX(-1);\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: 'FlipH'; }\n\n.primary_button, .primary_cancel_button {\n  border-radius: 16px;\n  text-align: center;\n  padding: 3px;\n  cursor: pointer; }\n\n.primary_button {\n  color: white;\n  font-size: 29px;\n  margin-top: 14px;\n  box-shadow: 0px 1px 0px black;\n  border: none;\n  padding: 8px 36px; }\n\n.primary_button.disabled {\n  background-color: #eeeeee;\n  color: #cccccc;\n  box-shadow: none;\n  border: none;\n  cursor: wait; }\n\n.primary_cancel_button {\n  color: #888888;\n  margin-top: 0.5em; }\n\n.cancel_opinion_button {\n  float: right;\n  background: transparent;\n  border: none;\n  margin-top: 0.5em; }\n\nbutton.primary_button, input[type='submit'] {\n  display: inline-block; }\n\nselect.unstyled:not([multiple]){\n    -webkit-appearance:none;\n    -moz-appearance:none;\n    background-position:right 50%;\n    background-repeat:no-repeat;\n    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDZFNDEwNjlGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDZFNDEwNkFGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0NkU0MTA2N0Y3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0NkU0MTA2OEY3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuGsgwQAAAA5SURBVHjaYvz//z8DOYCJgUxAf42MQIzTk0D/M+KzkRGPoQSdykiKJrBGpOhgJFYTWNEIiEeAAAMAzNENEOH+do8AAAAASUVORK5CYII=);\n    padding: .5em;\n    padding-right:1.5em;\n    border-radius: 16px;\n}\n";


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var addEventListener, location, old_A, popstate_event, ref, relativeURLFromLocation, relativeURLFromStatebus,
	  hasProp = {}.hasOwnProperty;

	__webpack_require__(1);

	__webpack_require__(4);

	window.loadPage = function(url, query_params) {
	  var hash, k, loc, ref, url_parts, v;
	  loc = fetch('location');
	  loc.query_params = query_params || {};
	  url_parts = parseURL("" + (location_origin()) + url);
	  ref = url_parts.searchObject;
	  for (k in ref) {
	    v = ref[k];
	    if (k.length > 0) {
	      loc.query_params[k] = v;
	    }
	  }
	  loc.query_params = url_parts.searchObject;
	  if (loc.query_params.u) {
	    delete loc.query_params.u;
	  }
	  if (loc.query_params.t) {
	    delete loc.query_params.t;
	  }
	  hash = url_parts.hash;
	  if (hash && hash.length > 0) {
	    hash = hash.substring(1);
	    loc.seek_to_hash = hash;
	  }
	  loc.url = url_parts.pathname;
	  loc.hash = hash;
	  return save(loc);
	};

	old_A = A;

	window.A = React.createClass({
	  render: function() {
	    var props;
	    props = this.props;
	    if (this.props.href) {
	      this._onclick = this.props.onClick || (function() {
	        return null;
	      });
	      if (browser.is_mobile) {
	        this.props.onTouchEnd = (function(_this) {
	          return function(e) {
	            if (!is_swipping) {
	              return _this.handleClick(e);
	            }
	          };
	        })(this);
	        if (browser.is_android_browser) {
	          this.props.onClick = function(e) {
	            e.preventDefault();
	            return e.stopPropagation();
	          };
	        }
	      } else {
	        this.props.onClick = this.handleClick;
	      }
	    }
	    return old_A(props, props.children);
	  },
	  handleClick: function(event) {
	    var href, is_external_link, is_mailto, node, opened_in_new_tab;
	    node = this.getDOMNode();
	    href = node.getAttribute('href');
	    is_external_link = href.indexOf('//') > -1;
	    is_mailto = href.toLowerCase().indexOf('mailto') > -1;
	    opened_in_new_tab = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
	    if (!is_external_link && !opened_in_new_tab && !is_mailto && !node.getAttribute('data-nojax')) {
	      event.preventDefault();
	      event.stopPropagation();
	      loadPage(href);
	      this._onclick(event);
	      if (!this.getDOMNode().getAttribute('data-no-scroll')) {
	        window.scrollTo(0, 0);
	      }
	      return false;
	    } else {
	      return this._onclick(event);
	    }
	  }
	});

	window.BrowserLocation = ReactiveComponent({
	  displayName: 'BrowserLocation',
	  render: function() {
	    var doc, loc, new_location, title;
	    loc = fetch('location');
	    doc = fetch('document');
	    title = doc.title || document.title;
	    if (doc.title && document.title !== doc.title) {
	      document.title = doc.title;
	    }
	    new_location = relativeURLFromStatebus();
	    if (this.last_location !== new_location) {
	      if (relativeURLFromLocation() !== new_location) {
	        history.pushState(loc.query_params, title, new_location);
	      }
	      this.last_location = new_location;
	      writeToLog({
	        what: 'changing url',
	        where: loc.url
	      });
	    }
	    return SPAN(null);
	  },
	  componentDidUpdate: function() {
	    var int, loc;
	    loc = fetch('location');
	    if (loc.seek_to_hash) {
	      loc.seek_to_hash = false;
	      save(loc);
	      return int = setInterval(function() {
	        var docks, e, el, noop, seek_below;
	        el = null;
	        try {
	          el = document.querySelector("#" + loc.hash);
	        } catch (error) {
	          e = error;
	          noop = 1;
	        }
	        el || (el = document.querySelector("[name=\"" + loc.hash + "\"]") || document.querySelector("#p" + loc.hash));
	        if (el) {
	          docks = fetch('docking_station');
	          seek_below = docks.y_stack || 50;
	          $(window).scrollTop(getCoords(el).top - seek_below);
	          el.focus();
	          return clearInterval(int);
	        }
	      }, 100);
	    }
	  }
	});

	relativeURLFromLocation = function() {
	  var loc, ref, ref1, search;
	  search = (ref = location.search) != null ? ref.replace(/\%2[fF]/g, '/') : void 0;
	  loc = (ref1 = location.pathname) != null ? ref1.replace(/\%20/g, ' ') : void 0;
	  return "" + loc + search + location.hash;
	};

	relativeURLFromStatebus = function() {
	  var k, loc, query_params, ref, relative_url, v;
	  loc = fetch('location');
	  relative_url = loc.url;
	  if (_.keys(loc.query_params).length > 0) {
	    query_params = (function() {
	      var ref, results;
	      ref = loc.query_params;
	      results = [];
	      for (k in ref) {
	        if (!hasProp.call(ref, k)) continue;
	        v = ref[k];
	        results.push(k + "=" + v);
	      }
	      return results;
	    })();
	    relative_url += "?" + (query_params.join('&'));
	  }
	  if (((ref = loc.hash) != null ? ref.length : void 0) > 0) {
	    relative_url += "#" + loc.hash;
	  }
	  return relative_url;
	};

	location = window.history.location || window.location;

	ref = window.addEventListener ? ['addEventListener', 'popstate'] : ['attachEvent', 'onpopstate'], addEventListener = ref[0], popstate_event = ref[1];

	window[addEventListener](popstate_event, function(ev) {
	  return loadPage(relativeURLFromLocation());
	});

	loadPage(relativeURLFromLocation());


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var customization_value, db_customization_loaded;

	window.customizations = {};

	window._ = _;

	db_customization_loaded = {};

	window.load_customization = function(subdomain_name, obj) {
	  var error;
	  db_customization_loaded[subdomain_name] = obj;
	  try {
	    new Function(obj)();
	    customizations[subdomain_name] || (customizations[subdomain_name] = {});
	    return _.extend(customizations[subdomain_name], window.customization_obj);
	  } catch (error1) {
	    error = error1;
	    return console.error(error);
	  }
	};

	window.customization = function(field, object_or_key) {
	  var chain_of_configs, cluster_key, config, i, key, len, proposal, ref, subdomain, subdomain_config, subdomain_name, value;
	  if (!!object_or_key && (object_or_key.key == null)) {
	    object_or_key = fetch(object_or_key);
	  }
	  if (object_or_key && object_or_key.subdomain_id) {
	    subdomain = fetch("/subdomain/" + object_or_key.subdomain_id);
	  } else {
	    subdomain = fetch('/subdomain');
	  }
	  subdomain_name = (ref = subdomain.name) != null ? ref.toLowerCase() : void 0;
	  if ((subdomain.customization_obj != null) && subdomain.customization_obj !== db_customization_loaded[subdomain_name]) {
	    load_customization(subdomain_name, subdomain.customization_obj);
	  }
	  key = object_or_key ? object_or_key.key ? object_or_key.key : object_or_key : null;
	  chain_of_configs = [];
	  if (customizations[subdomain_name] != null) {
	    subdomain_config = customizations[subdomain_name];
	    if (key) {
	      if (subdomain_config[key] != null) {
	        chain_of_configs.push(subdomain_config[key]);
	      }
	      if (key.match(/\/proposal\//)) {
	        proposal = object_or_key;
	        cluster_key = "list/" + proposal.cluster;
	        if (subdomain_config[cluster_key] != null) {
	          chain_of_configs.push(subdomain_config[cluster_key]);
	        }
	      }
	    }
	    chain_of_configs.push(subdomain_config);
	  }
	  chain_of_configs.push(customizations['default']);
	  value = void 0;
	  for (i = 0, len = chain_of_configs.length; i < len; i++) {
	    config = chain_of_configs[i];
	    value = customization_value(field, config);
	    if (value != null) {
	      break;
	    }
	  }
	  return value;
	};

	customization_value = function(field, config) {
	  var b, brackets, f, fields, i, idx, j, len, len1, val;
	  val = config;
	  fields = field.split('.');
	  for (idx = i = 0, len = fields.length; i < len; idx = ++i) {
	    f = fields[idx];
	    if (f.indexOf('[') > 0) {
	      brackets = f.match(/\[(.*?)\]/g);
	      f = f.substring(0, f.indexOf('['));
	    }
	    if ((val[f] != null) || idx === fields.length - 1) {
	      val = val[f];
	      if ((brackets != null ? brackets.length : void 0) > 0) {
	        for (j = 0, len1 = brackets.length; j < len1; j++) {
	          b = brackets[j];
	          f = b.substring(2, b.length - 2);
	          if ((val != null) && (val[f] != null)) {
	            val = val[f];
	          } else {
	            return void 0;
	          }
	        }
	      }
	    } else {
	      return void 0;
	    }
	  }
	  return val;
	};

	__webpack_require__(6);

	__webpack_require__(7);

	__webpack_require__(2);

	__webpack_require__(1);

	customizations["default"] = {
	  discussion_enabled: true,
	  homepage_show_search_and_sort: false,
	  list_show_new_button: true,
	  homepage_show_new_proposal_button: true,
	  show_crafting_page_first: false,
	  show_histogram_on_crafting: true,
	  show_proposal_meta_data: true,
	  slider_regions: null,
	  show_proposal_scores: true,
	  show_proposer_icon: false,
	  collapse_proposal_description_at: false,
	  list_is_archived: false,
	  auth_footer: false,
	  auth_require_pledge: false,
	  has_homepage: true,
	  homepage_list_order: [],
	  homepage_lists_to_always_show: [],
	  font: "'Avenir Next W01', 'Avenir Next', 'Lucida Grande', 'Lucida Sans Unicode', 'Helvetica Neue', Helvetica, Verdana, sans-serif",
	  auth_questions: []
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var is_android_browser, rxaosp,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	rxaosp = window.navigator.userAgent.match(/Android.*AppleWebKit\/([\d.]+)/);

	is_android_browser = !!(rxaosp && rxaosp[1] < 537);

	window.browser = {
	  is_android_browser: is_android_browser,
	  is_opera_mini: !!navigator.userAgent.match(/Opera Mini/),
	  is_ie9: !!(document.documentMode && document.documentMode === 9),
	  is_iOS: !!navigator.platform.match(/(iPad|iPhone)/),
	  touch_enabled: indexOf.call(document, 'ontouchend') >= 0,
	  high_density_display: (window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), \nonly screen and (min-resolution: 1.3dppx), \nonly screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), \nonly screen and (-o-min-device-pixel-ratio: 2.6/2), \nonly screen and (min--moz-device-pixel-ratio: 1.3), \nonly screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3),
	  is_mobile: is_android_browser || navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)
	};

	window.BrowserHacks = ReactiveComponent({
	  displayName: 'BrowserHacks',
	  render: function() {
	    var browser;
	    browser = fetch('browser');
	    if (browser.is_opera_mini) {
	      return DIV({
	        style: {
	          backgroundColor: 'red',
	          padding: 10,
	          textAlign: 'center',
	          color: 'white',
	          fontSize: 24
	        }
	      }, "This website does not work well with ", browser.is_android_browser ? 'the Android Browser' : 'Opera Mini', ". Please use ", A({
	        href: "https://play.google.com/store/apps/details?id=com.android.chrome&hl=en",
	        style: {
	          color: 'white',
	          textDecoration: 'underline'
	        }
	      }, 'Chrome for Android'), ' if you experience difficulty. Thanks, and sorry for the inconvenience!');
	    } else {
	      return SCRIPT({
	        type: 'text/javascript',
	        src: '//browser-update.org/update.js'
	      });
	    }
	  }
	});


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);

	__webpack_require__(8);

	window.Bubblemouth = function(props) {
	  var apex, bubblemouth_path, cx, full_width, id, qx1, qx2, qy1, qy2, ref, ref1, ref2, ref3, ref4, skew_x, skew_y, svg_h, svg_w, x1, x2, x3, x_pad, y1, y2, y3;
	  _.defaults(props, {
	    svg_w: 85,
	    svg_h: 100,
	    skew_x: 15,
	    skew_y: 80,
	    apex_xfrac: .5,
	    fill: 'white',
	    stroke: focus_color(),
	    stroke_width: 10,
	    dash_array: "none",
	    box_shadow: null
	  });
	  full_width = props.svg_w + 4 * props.skew_x * Math.max(.5, Math.abs(.5 - props.apex_xfrac));
	  _.defaults(props, {
	    width: full_width,
	    height: props.svg_h
	  });
	  apex = props.apex_xfrac;
	  svg_w = props.svg_w;
	  svg_h = props.svg_h;
	  skew_x = props.skew_x;
	  skew_y = props.skew_y;
	  cx = skew_x + svg_w / 2;
	  ref = [skew_x - apex * skew_x, svg_h], x1 = ref[0], y1 = ref[1];
	  ref1 = [skew_x + apex * svg_w, 0], x2 = ref1[0], y2 = ref1[1];
	  ref2 = [x1 + svg_w + skew_x, svg_h], x3 = ref2[0], y3 = ref2[1];
	  ref3 = [-skew_x + apex * (cx + 2 * skew_x), skew_y], qx1 = ref3[0], qy1 = ref3[1];
	  ref4 = [qx1 + cx, skew_y], qx2 = ref4[0], qy2 = ref4[1];
	  bubblemouth_path = "M  " + x1 + "  " + y1 + "\nQ " + qx1 + " " + qy1 + "\n   " + x2 + "  " + y2 + "\nQ " + qx2 + " " + qy2 + "\n   " + x3 + "  " + y3 + "\n";
	  id = "x" + (md5(JSON.stringify(props))) + "-" + ((Math.random() * 100000).toFixed(0));
	  x_pad = 0;
	  if (props.box_shadow) {
	    x_pad = (props.box_shadow.dx || 0) + (props.box_shadow.stdDeviation || 0);
	  }
	  return SVG({
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    width: props.width,
	    height: props.height,
	    viewBox: x_pad + " 0 " + full_width + " " + svg_h,
	    preserveAspectRatio: "none",
	    style: props.style ? props.style : void 0
	  }, DEFS(null, CLIPPATH({
	    id: id
	  }, PATH({
	    strokeWidth: props.stroke_width * 2,
	    d: bubblemouth_path
	  })), props.box_shadow ? svg.dropShadow(_.extend(props.box_shadow, {
	    id: id + "-shadow"
	  })) : void 0), props.box_shadow ? PATH({
	    key: 'shadow',
	    fill: props.fill,
	    style: {
	      filter: "url(#" + id + "-shadow)"
	    },
	    d: bubblemouth_path
	  }) : void 0, PATH({
	    key: 'stroke',
	    fill: props.fill,
	    stroke: props.stroke,
	    strokeWidth: props.stroke_width * 2,
	    clipPath: "url(#" + id + ")",
	    strokeDasharray: props.dash_array,
	    d: bubblemouth_path
	  }));
	};


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var golden_ratio_conjugate;

	window.focus_blue = '#2478CC';

	window.logo_red = "#B03A44";

	window.default_avatar_in_histogram_color = '#999';

	window.considerit_gray = '#f6f7f9';

	window.parseCssRgb = function(css_color_str) {
	  var rgb, test;
	  test = document.createElement('div');
	  test.style.color = css_color_str;
	  css_color_str = test.style.color;
	  if (css_color_str === 'transparent') {
	    return {
	      r: 0,
	      g: 0,
	      b: 0,
	      a: 0
	    };
	  } else {
	    rgb = /^rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+),?\s*([\.\d]+)?\s*\)$/i.exec(css_color_str);
	    if (rgb) {
	      return {
	        r: parseInt(rgb[1]),
	        g: parseInt(rgb[2]),
	        b: parseInt(rgb[3]),
	        a: rgb.length > 4 && (rgb[4] != null) ? parseFloat(rgb[4]) : 1
	      };
	    } else {
	      console.error("Color " + css_color_str + " could not be parsed");
	      return {
	        r: 0,
	        g: 0,
	        b: 0
	      };
	    }
	  }
	};

	window.parseCssHsl = function(css_color_str) {
	  var rgb;
	  rgb = parseCssRgb(css_color_str);
	  return rgb2hsl(rgb);
	};

	window.rgb2hsl = function(rgb) {
	  var b, d, g, h, l, max, min, r, s;
	  r = rgb.r / 255;
	  g = rgb.g / 255;
	  b = rgb.b / 255;
	  max = Math.max(r, g, b);
	  min = Math.min(r, g, b);
	  l = (max + min) / 2;
	  if (max === min) {
	    h = s = 0;
	  } else {
	    d = max - min;
	    s = (l > 0.5 ? d / (2 - max - min) : d / (max + min));
	    switch (max) {
	      case r:
	        h = (g - b) / d + (g < b ? 6 : 0);
	        break;
	      case g:
	        h = (b - r) / d + 2;
	        break;
	      case b:
	        h = (r - g) / d + 4;
	    }
	    h /= 6;
	  }
	  return {
	    h: h,
	    s: s,
	    l: l
	  };
	};

	window.hsv2rgb = function(h, s, v) {
	  var b, f, g, h_i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, t;
	  h_i = Math.floor(h * 6);
	  f = h * 6 - h_i;
	  p = v * (1 - s);
	  q = v * (1 - f * s);
	  t = v * (1 - (1 - f) * s);
	  if (h_i === 0) {
	    ref = [v, t, p], r = ref[0], g = ref[1], b = ref[2];
	  }
	  if (h_i === 1) {
	    ref1 = [q, v, p], r = ref1[0], g = ref1[1], b = ref1[2];
	  }
	  if (h_i === 2) {
	    ref2 = [p, v, t], r = ref2[0], g = ref2[1], b = ref2[2];
	  }
	  if (h_i === 3) {
	    ref3 = [p, q, v], r = ref3[0], g = ref3[1], b = ref3[2];
	  }
	  if (h_i === 4) {
	    ref4 = [t, p, v], r = ref4[0], g = ref4[1], b = ref4[2];
	  }
	  if (h_i === 5) {
	    ref5 = [v, p, q], r = ref5[0], g = ref5[1], b = ref5[2];
	  }
	  return "rgb(" + (Math.round(r * 256)) + ", " + (Math.round(g * 256)) + ", " + (Math.round(b * 256)) + ")";
	};

	window.addOpacity = function(color, opacity) {
	  var c;
	  c = parseCssRgb(color);
	  return "rgba(" + c.r + "," + c.g + "," + c.b + "," + opacity;
	};

	golden_ratio_conjugate = 0.618033988749895;

	window.getNiceRandomHues = function(num, seed) {
	  var h, hues, i;
	  h = seed || .5;
	  hues = [];
	  i = num;
	  while (i > 0) {
	    hues.push(h % 1);
	    h += golden_ratio_conjugate;
	    i -= 1;
	  }
	  return hues;
	};


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	window.drawLogo = function(opts) {
	  var height, width;
	  opts = _.defaults(opts, {
	    main_text_color: 'white',
	    o_text_color: logo_red,
	    line_color: 'white',
	    i_dot_x: 252.25,
	    height: 60
	  });
	  opts.width || (opts.width = opts.height * 284 / 60);
	  height = opts.height;
	  width = opts.width;
	  return SVG({
	    id: 'considerit_logo',
	    width: width,
	    height: height,
	    viewBox: "0 0 284 60",
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, TITLE({
	    id: 'considerit_logo_title'
	  }, 'Considerit Logo'), DEFS(null, CLIPPATH({
	    id: 'logo_clip'
	  }, RECT({
	    x: 0,
	    y: 0,
	    width: 284,
	    height: 45
	  })), FILTER({
	    id: "logo_shadow",
	    x: "-50%",
	    y: "-50%",
	    width: "200%",
	    height: "200%",
	    filterUnits: "objectBoundingBox"
	  }, FEOFFSET({
	    dx: "0",
	    dy: "1",
	    "in": "SourceAlpha",
	    result: "shadowOffsetOuter1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "1",
	    "in": "shadowOffsetOuter1",
	    result: "shadowBlurOuter1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
	    type: "matrix",
	    "in": "shadowBlurOuter1",
	    result: "shadowMatrixOuter1"
	  }), FEMERGE(null, FEMERGENODE({
	    "in": "shadowMatrixOuter1"
	  }), FEMERGENODE({
	    "in": "SourceGraphic"
	  })))), G({
	    filter: opts.box_shadow ? 'url(#logo_shadow)' : void 0
	  }, opts.draw_line ? LINE({
	    id: 'underline',
	    x1: 8,
	    y1: 55,
	    x2: 284,
	    y2: 55,
	    stroke: opts.line_color,
	    strokeWidth: 1
	  }) : void 0, PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M18.2811874,48.356 \nC24.1163223,48.3559999 28.0501221,47.5510218 32.5084274,43.599315 \nC32.9673706,43.1801946 33.0984972,42.4018281 32.5739907,41.9827077 \nL30.2137104,37.099623 \nC29.8203305,36.740377 29.0991341,36.6805026 28.5746276,37.099623 \nC25.8209684,39.1353508 22.4772394,40.5124608 18.5434406,40.5124607 \nC14.4641389,40.5124606 9.32086755,37.716503 9.32086787,29.1762513 \nC9.32086836,20.6359996 15.4629989,17.6360006 18.2811869,17.6360001 \nC22.4641385,17.636 25.4641379,19.6359996 27.5746276,21.2528796 \nC28.0991341,21.7318743 28.7547672,21.7318743 29.2137104,21.2528796 \nL32.5739907,17.001801 \nC33.0984972,16.5228062 33.0984972,15.804314 32.5084274,15.3253193 \nC28.0501221,11.6729842 24.903082,10.236 18.2811874,10.236 \nC8.41026668,10.236 0.0764406792,17.8200837 0.0764406792,29.3558743 \nC0.0764406792,40.2729625 8.41026668,48.3560001 18.2811874,48.356 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M38.1601385,33.164 \nC38.1601385,41.444 44.7841385,48.356 52.9201385,48.356 \nC61.0561385,48.356 67.6801385,41.444 67.6801385,33.164 \nC67.6801385,25.028 61.0561385,18.116 52.9201385,18.116 \nC44.7841385,18.116 38.1601385,25.028 38.1601385,33.164 \nC38.1601385,33.164 38.1601385,25.028 38.1601385,33.164 \nZ\nM46.0081385,33.164 \nC46.0081385,29.132 49.0321385,25.892 52.9201385,25.892 \nC56.7361385,25.892 59.8321385,29.132 59.8321385,33.164 \nC59.8321385,37.268 56.7361385,40.58 52.9201385,40.58 \nC49.0321385,40.58 46.0081385,37.268 46.0081385,33.164 \nC46.0081385,33.164 46.0081385,37.268 46.0081385,33.164 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M74.0881385,46.268 \nC74.0881385,46.988 74.7361385,47.636 75.4561385,47.636 \nL80.7841385,47.636 \nC82.1521385,47.636 82.5841385,47.276 82.5841385,46.268 \nL82.5841385,30.428 \nC83.3041385,28.484 85.6081385,25.892 89.3521385,25.892 \nC92.8081385,25.892 94.7521385,28.268 94.7521385,32.012 \nL94.7521385,46.268 \nC94.7521385,46.988 95.3281385,47.636 96.1201385,47.636 \nL102.024139,47.636 \nC102.744139,47.636 103.392139,46.988 103.392139,46.268 \nL103.392139,32.444 \nC103.392139,24.956 99.7201385,18.116 90.5761385,18.116 \nC85.0321385,18.116 81.5041385,21.212 80.4241385,22.364 \nL79.4161385,19.7 \nC79.2001385,19.196 78.8401385,18.836 78.1921385,18.836 \nL75.4561385,18.836 \nC74.7361385,18.836 74.0881385,19.412 74.0881385,20.204 \nC74.0881385,20.204 74.0881385,19.412 74.0881385,20.204 \nL74.0881385,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M110.304139,45.692 \nC111.816139,46.844 115.128139,48.356 119.880139,48.356 \nC127.152139,48.356 131.328139,44.324 131.328139,39.572 \nC131.328139,33.956 127.152139,31.58 121.608139,29.42 \nC118.944139,28.34 117.648139,27.908 117.648139,26.612 \nC117.648139,25.676 118.368139,24.956 120.096139,24.956 \nC122.832139,24.956 126.072139,26.468 126.072139,26.468 \nC126.648139,26.684 127.440139,26.612 127.800139,25.964 \nL129.600139,22.292 \nC129.960139,21.572 129.600139,20.78 128.952139,20.348 \nC127.440139,19.34 124.344139,18.116 120.096139,18.116 \nC112.752139,18.116 109.512139,22.22 109.512139,26.612 \nC109.512139,31.004 112.104139,33.956 117.648139,36.116 \nC121.464139,37.628 122.472139,38.42 122.472139,39.716 \nC122.472139,40.94 121.464139,41.516 120.024139,41.516 \nC116.712139,41.516 113.472139,39.788 113.472139,39.788 \nC112.824139,39.428 112.104139,39.572 111.816139,40.292 \nL109.872139,44.18 \nC109.584139,44.756 109.872139,45.332 110.304139,45.692 \nC110.304139,45.692 109.872139,45.332 110.304139,45.692 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M137.664139,46.268 \nC137.664139,46.988 138.312139,47.636 139.032139,47.636 \nL145.008139,47.636 \nC145.728139,47.636 146.376139,46.988 146.376139,46.268 \nL146.376139,20.204 \nC146.376139,19.412 145.728139,18.836 145.008139,18.836 \nL139.032139,18.836 \nC138.312139,18.836 137.664139,19.412 137.664139,20.204 \nC137.664139,20.204 137.664139,19.412 137.664139,20.204 \nL137.664139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M166.680139,48.356 \nC172.728139,48.356 176.112139,44.036 176.112139,44.036 \nL176.832139,46.268 \nC177.048139,47.06 177.552139,47.636 178.200139,47.636 \nL181.008139,47.636 \nC181.728139,47.636 182.376139,46.988 182.376139,46.268 \nL182.376139,1.604 \nC182.376139,0.884 181.728139,0.236 181.008139,0.236 \nL174.888139,0.236 \nC174.168139,0.236 173.520139,0.884 173.520139,1.604 \nL173.520139,19.412 \nC172.224139,18.908 169.992139,18.116 167.112139,18.116 \nC158.544139,18.116 152.856139,24.812 152.856139,33.236 \nC152.856139,41.516 158.832139,48.356 166.680139,48.356 \nZ \nM161.208139,33.236 \nC161.208139,29.204 164.160139,25.892 168.192139,25.892 \nC171.792139,25.892 173.808139,27.548 173.808139,27.548 \nL173.808139,35.9 \nC173.304139,37.628 171.576139,40.58 167.760139,40.58 \nC163.944139,40.58 161.208139,37.268 161.208139,33.236 \nC161.208139,33.236 161.208139,37.268 161.208139,33.236 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M188.856139,33.236 \nC188.856139,41.516 194.976139,48.356 203.616139,48.356 \nC208.296139,48.356 211.968139,46.628 214.344139,44.396 \nC215.064139,43.82 214.920139,43.028 214.416139,42.524 \nL211.464139,39.14 \nC210.960139,38.564 210.312139,38.708 209.592139,39.14 \nC208.296139,40.076 206.208139,40.94 203.976139,40.94 \nC199.800139,40.94 197.280139,37.628 197.064139,34.676 \nL215.496139,34.676 \nC216.144139,34.676 216.792139,34.172 216.864139,33.452 \nC216.936139,32.948 217.008139,32.012 217.008139,31.508 \nC217.008139,23.732 210.960139,18.116 203.544139,18.116 \nC194.976139,18.116 188.856139,25.1 188.856139,33.236 \nC188.856139,33.236 188.856139,25.1 188.856139,33.236 \nZ \nM197.712139,29.636 \nC198.072139,26.9 200.448139,24.74 203.328139,24.74 \nC206.064139,24.74 208.368139,26.972 208.584139,29.636 \nC208.584139,29.636 208.368139,26.972 208.584139,29.636 \nL197.712139,29.636 \nZ           "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M223.056139,46.268 \nC223.056139,46.988 223.704139,47.636 224.424139,47.636 \nL229.968139,47.636 \nC230.976139,47.636 231.624139,47.276 231.624139,46.268 \nL231.624139,28.844 \nC232.128139,27.836 233.856139,25.892 236.736139,25.892 \nC237.528139,25.892 238.608139,26.252 238.824139,26.324 \nC239.400139,26.612 240.120139,26.324 240.480139,25.676 \nL243.144139,20.996 \nC244.008139,19.196 240.984139,18.116 237.600139,18.116 \nC233.136139,18.116 230.472139,21.14 229.464139,22.58 \nL228.456139,19.772 \nC228.240139,19.196 227.808139,18.836 227.160139,18.836 \nL224.424139,18.836 \nC223.704139,18.836 223.056139,19.412 223.056139,20.204 \nC223.056139,20.204 223.056139,19.412 223.056139,20.204 \nL223.056139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M247.608139,46.268 \nC247.608139,46.988 248.256139,47.636 248.976139,47.636 \nL254.952139,47.636 \nC255.672139,47.636 256.320139,46.988 256.320139,46.268 \nL256.320139,20.204 \nC256.320139,19.412 255.672139,18.836 254.952139,18.836 \nL248.976139,18.836 \nC248.256139,18.836 247.608139,19.412 247.608139,20.204 \nC247.608139,20.204 247.608139,19.412 247.608139,20.204 \nL247.608139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M266.472139,39.068 \nC266.472139,44.9 268.920139,48.356 274.464139,48.356 \nC277.992139,48.356 282.672139,46.7 283.032139,46.484 \nC283.752139,46.196 284.112139,45.476 283.824139,44.756 \nL282.384139,40.22 \nC282.168139,39.5 281.592139,39.14 280.800139,39.428 \nC280.008139,39.716 278.496139,40.22 277.272139,40.22 \nC276.120139,40.22 275.040139,39.932 275.040139,37.916 \nL275.040139,26.396 \nL281.376139,26.396 \nC282.168139,26.396 282.744139,25.748 282.744139,25.028 \nL282.744139,20.204 \nC282.744139,19.412 282.168139,18.836 281.376139,18.836 \nL275.040139,18.836 \nL275.040139,10.772 \nC275.040139,10.052 274.464139,9.404 273.744139,9.404 \nL267.840139,9.476 \nC267.120139,9.476 266.472139,10.124 266.472139,10.844 \nL266.472139,18.836 \nL264.024139,18.836 \nC263.304139,18.836 262.728139,19.412 262.728139,20.204 \nL262.728139,25.028 \nC262.728139,25.748 263.304139,26.396 264.024139,26.396 \nL266.472139,26.396 \nL266.472139,39.068 \nZ"
	  }), CIRCLE({
	    id: 'i_dot',
	    style: {
	      transition: 'fill 500ms'
	    },
	    fill: opts.o_text_color,
	    cx: opts.i_dot_x,
	    cy: "55",
	    r: "4.25",
	    style: opts.transition ? css.crossbrowserify({
	      transition: 'cx 1000ms'
	    }) : void 0
	  })));
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	window.svg = {
	  setSize: function(base_width, base_height, props) {
	    if (props.width && (props.height == null)) {
	      return props.height = props.width * base_height / base_width;
	    } else if (props.height && (props.width == null)) {
	      return props.width = props.height * base_width / base_height;
	    }
	  },
	  dropShadow: function(props) {
	    return FILTER({
	      id: props.id
	    }, FEOFFSET({
	      "in": "SourceAlpha",
	      dx: props.dx,
	      dy: props.dy,
	      result: "offsetblur"
	    }), FEGAUSSIANBLUR({
	      "in": 'offsetblur',
	      stdDeviation: props.stdDeviation,
	      result: 'blur2'
	    }), FECOLORMATRIX({
	      "in": 'blur2',
	      result: 'color',
	      type: 'matrix',
	      values: "0 0 0 0  0\n0 0 0 0  0 \n0 0 0 0  0 \n0 0 0 " + props.opacity + " 0"
	    }), FEMERGE(null, FEMERGENODE({
	      "in": 'color'
	    }), FEMERGENODE({
	      "in": 'SourceGraphic'
	    })));
	  },
	  innerbevel: function(props) {
	    var idx, shadow;
	    return FILTER({
	      id: props.id,
	      x0: "-50%",
	      y0: "-50%",
	      width: "200%",
	      height: "200%"
	    }, (function() {
	      var i, len, ref, results;
	      ref = props.shadows;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        shadow = ref[idx];
	        results.push([
	          FEGAUSSIANBLUR({
	            "in": 'SourceAlpha',
	            stdDeviation: shadow.stdDeviation,
	            result: "blur" + idx
	          }), FEOFFSET({
	            dy: shadow.dy,
	            dx: shadow.dx
	          }), FECOMPOSITE({
	            in2: 'SourceAlpha',
	            operator: "arithmetic",
	            k2: "-1",
	            k3: "1",
	            result: "shadowDiff"
	          }), FEFLOOD({
	            floodColor: shadow.color,
	            floodOpacity: shadow.opacity
	          }), FECOMPOSITE({
	            in2: "shadowDiff",
	            operator: "in"
	          }), FECOMPOSITE({
	            in2: idx === 0 ? 'SourceGraphic' : "result" + (idx - 1),
	            operator: "over",
	            result: "result" + idx
	          })
	        ]);
	      }
	      return results;
	    })());
	  }
	};


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);

	window.Tooltip = ReactiveComponent({
	  displayName: 'Tooltip',
	  render: function() {
	    var coords, size, style, tip, tooltip;
	    tooltip = fetch('tooltip');
	    if (!tooltip.coords) {
	      return SPAN(null);
	    }
	    coords = tooltip.coords;
	    tip = tooltip.tip;
	    style = _.defaults({}, this.props.style || {}, {
	      fontSize: 16,
	      padding: '4px 8px',
	      borderRadius: 8,
	      pointerEvents: 'none',
	      zIndex: 9999,
	      color: '#777',
	      backgroundColor: '#f6f6f6',
	      position: 'absolute',
	      boxShadow: '0 1px 1px rgba(0,0,0,.2)',
	      borderBottom: '1px solid #eee'
	    });
	    size = sizeWhenRendered(tip, style);
	    if (tooltip.top || (tooltip.top == null)) {
	      _.extend(style, {
	        top: coords.top - size.height - 9,
	        left: coords.left - size.width / 2
	      });
	    } else {
	      _.extend(style, {
	        top: coords.top + 9 + 20,
	        left: coords.left - size.width / 2
	      });
	    }
	    return DIV({
	      id: 'tooltip',
	      role: "tooltip",
	      style: style,
	      dangerouslySetInnerHTML: {
	        __html: tip
	      }
	    });
	  }
	});


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	(function () {

	    // ****************
	    // Public API
	    var cache = {}
	    function fetch(url, defaults) {
	        //if (window.watch && watch(url)) console.trace()

	        if (!url) return null
	        if (url.key) url = url.key   // If user passes key as object

	        window.record_dependence && record_dependence(url)

	        // Return the cached version if it exists
	        if (cache[url]) return cache[url]

	        // Else, start a serverFetch in the background and return stub.
	        if (url[0] === '/')
	            server_fetch(url)

	        update_cache(extend({key: url}, defaults))
	        return cache[url]
	    }

	    /*  Updates cache and saves to server.
	     *  You can pass a callback that will run when the saves have finished.
	     */
	    function save(object, continuation) {
	        update_cache(object)

	        // Save all the objects
	        if (object.key && object.key[0] == '/')
	            server_save(object, continuation)
	        else
	            if (continuation) continuation()
	    }

	    /*  Deletes from server (if it's there) and removes from cache
	     *  You can pass a callback that will run when the delete has finished.
	     */
	    function destroy(key, continuation) {
	        if (!key) return

	        // Save all the objects
	        if (key[0] == '/')
	            server_destroy(key, continuation)
	        else {
	            // Just remove the key from the cache if this state is
	            // owned by the client.  Note that this won't clean up
	            // references to this object in e.g. any lists. The Client
	            // is responsible for updating all the relevant
	            // references.
	            delete cache[key]
	            if (continuation) continuation()
	        }
	    }


	    // ================================
	    // == Internal funcs

	    var new_index = 0
	    var affected_keys = new Set()
	    var re_render_timer = null
	    function update_cache(object) {
	        function recurse(object) {
	            // Recurses into object and folds it into the cache.

	            // If this object has a key, update the cache for it
	            var key = object && object.key
	            if (key) {
	                // Change /new/thing to /new/thing/45
	                if (key.match(new RegExp('^/new/'))     // Starts with /new/
	                    && !key.match(new RegExp('/\\d+$'))) // Doesn't end in a /number
	                    key = object.key = key + '/' + new_index++

	                var cached = cache[key]
	                if (!cached)
	                    // This object is new.  Let's cache it.
	                    cache[key] = object
	                else if (object !== cached)
	                    // Else, mutate cache to match the object.
	                    for (var k in object)          // Mutating in place preserves
	                        cache[key][k] = object[k]  // pointers to this object

	                // Remember this key for re-rendering
	                affected_keys.add(key)
	            }

	            // Now recurse into this object.
	            //  - Through each element in arrays
	            //  - And each property on objects
	            if (Array.isArray(object))
	                for (var i=0; i < object.length; i++)
	                    object[i] = recurse(object[i])
	            else if (typeof(object) === 'object' && object !== null)
	                for (var k in object)
	                    object[k] = recurse(object[k])

	            // Return the new cached representation of this object
	            return cache[key] || object
	        }

	        recurse(object)

	        // Now initiate the re-rendering, if there isn't a timer already going
	        re_render_timer = re_render_timer || setTimeout(function () {
	            re_render_timer = null
	            var keys = affected_keys.all()
	            affected_keys.clear()
	            if (keys.length > 0) {
	                var re_render = (window.re_render || function () {
	                    console.log('You need to implement re_render()') })
	                re_render(keys)
	            }
	        })
	    }

	    var outstanding_fetches = {}
	    function server_fetch(key) {
	        // Error check
	        if (outstanding_fetches[key]) {
	            console.error('Duplicate request for '+key)
	            return
	        }

	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            delete outstanding_fetches[key]
	            if (request.status === 200) {
	                var result = JSON.parse(request.responseText)
	                if (window.arest.trans_in)
	                    result = arest.trans_in(result)
	                update_cache(result)
	            }
	            else if (request.status === 500)
	                if (window.on_ajax_error) window.on_ajax_error()

	        }

	        // Open request
	        outstanding_fetches[key] = request
	        request.open('GET', key, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')

	        request.send(null)
	    }

	    var pending_saves = {} // Stores xmlhttprequest of any key being saved
	                           // (Note: This shim will fail in many situations...)
	    function server_save(object, continuation) {
	        if (pending_saves[object.key]) {
	            console.log('Yo foo, aborting')
	            pending_saves[object.key].abort()
	            delete pending_saves[object.key]
	        }

	        var original_key = object.key
	        
	        // Special case for /new.  Grab the pieces of the URL.
	        var pattern = new RegExp("/new/([^/]+)/(\\d+)")
	        var match = original_key.match(pattern)
	        var url = (match && '/' + match[1]) || original_key

	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            // No longer pending
	            delete pending_saves[original_key]

	            if (request.status === 200) {
	                var result = JSON.parse(request.responseText)
	                // console.log('New save result', result)
	                // Handle /new/stuff
	                deep_map(function (obj) {
	                    match = obj.key && obj.key.match(/(.*)\?original_id=(\d+)$/)
	                    if (match && match[2]) {
	                        // Let's map the old and new together
	                        var new_key = match[1]                // It's got a fresh key
	                        cache[new_key] = cache[original_key]  // Point them at the same thing
	                        obj.key = new_key                     // And it's no longer "/new/*"
	                    }
	                },
	                        result)
	                update_cache(result)
	                if (continuation) continuation()
	            }
	            else if (request.status === 500)
	                window.ajax_error && window.ajax_error()
	        }

	        object = clone(object)
	        object['authenticity_token'] = csrf()

	        // Open request
	        var POST_or_PUT = match ? 'POST' : 'PUT'
	        request.open(POST_or_PUT, url, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
	        request.setRequestHeader('X-CSRF-Token', csrf())
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	        request.send(JSON.stringify(object))

	        // Remember it
	        pending_saves[original_key] = request
	    }

	    function server_destroy(key, continuation) {
	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            if (request.status === 200) {
	                console.log('Destroy returned for', key)
	                var result = JSON.parse(request.responseText)
	                delete cache[key]
	                update_cache(result)
	                if (continuation) continuation()
	            }
	            else if (request.status === 500)
	                if (window.on_ajax_error) window.on_ajax_error()
	            else {
	                // TODO: give user feedback that DELETE failed
	                console.log('DELETE of', key, 'failed!')
	            }

	        }

	        payload = {'authenticity_token': csrf()}

	        // Open request
	        request.open('DELETE', key, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
	        request.setRequestHeader('X-CSRF-Token', csrf())
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	        request.send(JSON.stringify(payload))
	    }

	    // This is used in a specific hack.  I need to work on it.
	    function clear_matching_objects (match_key_func) {
	        // Clears all keys where match_key_func(key) returns true
	        for (key in cache)
	            if (match_key_func(key))
	                delete cache[key]
	    }


	    var csrf_token = null
	    function csrf(new_token) {
	        if (new_token) csrf_token = new_token
	        if (csrf_token) return csrf_token
	        var metas = document.getElementsByTagName('meta')
	        for (i=0; i<metas.length; i++) { 
	            if (metas[i].getAttribute("name") == "csrf-token") { 
	                return metas[i].getAttribute("content");
	            } 
	        } 
	        return ""
	    }

	    window.loading_indicator = React.DOM.div({style: {height: '100%', width: '100%'},
	                                       className: 'loading'}, 'Loading')
	    function error_indicator(message) {
	        return React.DOM.div(null, 'Error! ' + message)
	    }

	    // ****************
	    // Wrapper for React Components
	    var components = {}                  // Indexed by 'component/0', 'component/1', etc.
	    var components_count = 0
	    var dirty_components = {}
	    var execution_context = []  // The stack of components that are being rendered
	    function ReactiveComponent(component) {
	        // STEP 1: Define get() and save()
	        component.fetch = component.data = component.get = function (key, defaults) {
	            if (!this._lifeCycleState || this._lifeCycleState == 'UNMOUNTED')
	                throw Error('Component ' + this.name + ' (' + this.local_key
	                            + ') is tryin to get data(' + key + ') after it died.')

	            if (key === undefined)    key = this.mounted_key || this.name
	            if (!key)                 return null
	            // if (!key)    throw TypeError('Component mounted onto a null key. '
	            //                              + this.name + ' ' + this.local_key)
	            if (key.key) key = key.key   // If user passes key as object
	            return fetch(key, defaults)  // Call into main activerest
	        }
	        component.save = save                  // Call into main activerest
	        

	        // STEP 2: Wrap all the component's methods
	        function wrap(obj, method, before, after) {
	            var original_method = obj[method]
	            if (!(original_method || before || after)) return
	            obj[method] = function() {
	                before && before.apply(this, arguments)
	                if (this.local_key !== undefined)
	                    // We only want to set the execution context on wrapped methods
	                    // that are called on live instance.  getDefaultProps(), for
	                    // instance, is called when defining a component class, but not
	                    // on actual instances.  You can't render new components from
	                    // within there, so we don't need to track the execution context.
	                    execution_context = this.props.parents.concat([this.local_key])

	                try {
	                    var result = original_method && original_method.apply(this, arguments)
	                } catch (e) {
	                    execution_context = []
	                    if (this.is_waiting())
	                        return loading_indicator
	                    else {
	                        // Then let's re-cause the error, but without catching it
	                        original_method.apply(this, arguments)
	                        console.assert(false) // this cannot happen unless method has side effects
	                    }
	                }

	                execution_context = []
	                after && after.apply(this, arguments)

	                return result
	            }
	        }

	        // We register the component when mounting it into the DOM
	        wrap(component, 'componentWillMount',
	             function () { 

	                 // STEP 1. Register the component's basic info
	                 if (component.displayName === undefined)
	                     throw 'Component needs a displayName'
	                 this.name = component.displayName.toLowerCase().replace(' ', '_')
	                 this.local_key = 'component/' + components_count++
	                 components[this.local_key] = this

	                 // You can pass an object in as a key if you want:
	                 if (this.props.key && this.props.key.key)
	                     this.props.key = this.props.key.key

	                 // XXX Putting this into WillMount probably won't let you use the
	                 // mounted_key inside getInitialState!  But you should be using
	                 // activerest state anyway, right?
	                 this.mounted_key = this.props.key

	                 // STEP 2: Create shortcuts e.g. `this.foo' for all parents up the
	                 // tree, and this component's local key
	                 function add_shortcut (obj, shortcut_name, to_key) {
	                     //console.log('Giving '+obj.name+' shorcut @'+shortcut_name+'='+to_key)
	                     delete obj[name]
	                     Object.defineProperty(obj, shortcut_name, {
	                         get: function () { return obj.get(to_key) },
	                         configurable: true })
	                 }

	                 // ...first for @local
	                 add_shortcut(this, 'local', this.local_key)
	                 
	                 // ...and now for all parents
	                 var parents = this.props.parents.concat([this.local_key])
	                 for (var i=0; i<parents.length; i++) {
	                     var name = components[parents[i]].name
	                     var key = components[parents[i]].props.key
	                     if (!key && cache[name] !== undefined)
	                         key = name
	                     add_shortcut(this, name, key)
	                 }
	             })

	        wrap(component, 'render', function () {
	            // Render will need to clear the component's old
	            // dependencies before rendering and finding new ones
	            clear_component_dependencies(this.local_key)
	            delete dirty_components[this.local_key]
	        })

	        wrap(component, 'componentDidMount')
	        wrap(component, 'componentDidUpdate')
	        wrap(component, 'getDefaultProps')
	        //wrap(component, 'componentWillReceiveProps')
	        wrap(component, 'componentWillUnmount', function () {
	            // Clean up
	            clear_component_dependencies(this.local_key)
	            delete cache[this.local_key]
	            delete components[this.local_key]
	            delete dirty_components[this.local_key]
	        })
	        component.shouldComponentUpdate = function (next_props, next_state) {
	            // This component definitely needs to update if it is marked as dirty
	            if (dirty_components[this.local_key] !== undefined) return true

	            // Otherwise, we'll check to see if its state or props
	            // have changed.  We can do so by simply serializing them
	            // and then comparing them.  But ignore React's 'children'
	            // prop, because it often has a circular reference.
	            next_props = clone(next_props); this_props = clone(this.props)
	            delete next_props['children']; delete this_props['children']
	            return JSON.stringify([next_state, next_props]) != JSON.stringify([this.state, this_props])
	        }
	        
	        component.is_waiting = function () {
	            // Does this component depend on any keys that are being
	            // requested?
	            var dependent_keys = keys_4_component.get(this.local_key)
	            for (var i=0; i<dependent_keys.length; i++)
	                if (outstanding_fetches[dependent_keys[i]])
	                    return true
	            return false
	        }

	        // STEP 3: Configure the global function hooks for React
	        window.re_render = react_rerender
	        window.record_dependence = record_component_dependence

	        // Now create the actual React class with this definition, and
	        // return it.
	        var react_class = React.createClass(component)
	        var result = function (props, children) {
	            props = props || {}
	            props.parents = execution_context.slice()
	            return react_class(props, children)
	        }
	        // Give it the same prototype as the original class so that it
	        // passes React.isValidClass() inspection
	        result.prototype = react_class.prototype
	        return result
	    }


	    // *****************
	    // Dependency-tracking for React components
	    var keys_4_component = new One_To_Many() // Maps component to its dependence keys
	    var components_4_key = new One_To_Many() // Maps key to its dependent components
	    function react_rerender (keys) {
	        // Re-renders only the components that depend on `keys'

	        // First we determine the components that will need to be updated
	        for (var i = 0; i < keys.length; i++) {
	            affected_components = components_4_key.get(keys[i])
	            for (var j = 0; j < affected_components.length; j++)
	                dirty_components[affected_components[j]] = true
	        }

	        // Then we sweep through and update them
	        for (var comp_key in dirty_components)
	            // the check on both dirty_components and components is a PATCH
	            // for a possible inconsistency between dirty_components and components
	            // that occurs if a component has a componentWillUnmount method.
	            if (dirty_components[comp_key] && components[comp_key]) // Since one component might update another
	                components[comp_key].forceUpdate()
	    }
	    function record_component_dependence(key) {
	        // Looks up current component from the execution context
	        if (execution_context.length > 0) {
	            var component = execution_context[execution_context.length-1]
	            keys_4_component.add(component, key)  // Track dependencies
	            components_4_key.add(key, component)  // both ways
	        }
	    }
	    function clear_component_dependencies(component) {
	        var depends_on_keys = keys_4_component.get(component)
	        for (var i=0; i<depends_on_keys.length; i++)
	            components_4_key.del(depends_on_keys[i], component)
	        keys_4_component.delAll(component)
	    }


	    // ****************
	    // Utility for React Components
	    function One_To_Many() {
	        var hash = this.hash = {}
	        this.get = function (k) { return Object.keys(hash[k] || {}) }
	        this.add = function (k, v) {
	            if (hash[k] === undefined)
	                hash[k] = {}
	            hash[k][v] = true
	        }
	        this.del = function (k, v) {
	            delete hash[k][v]
	        }
	        this.delAll = function (k) { hash[k] = {} }
	    }
	    function Set() {
	        var hash = {}
	        this.add = function (a) { hash[a] = true }
	        this.all = function () { return Object.keys(hash) }
	        this.clear = function () { hash = {} }
	    }


	    // ******************
	    // General utility funcs
	    function clone(obj) {
	        if (obj == null) return obj
	        var copy = obj.constructor()
	        for (var attr in obj)
	            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
	        return copy
	    }
	    function extend(obj, with_obj) {
	        if (with_obj === undefined) return obj
	        for (var attr in with_obj)
	            if (!obj.hasOwnProperty(attr)) obj[attr] = with_obj[attr]
	        return obj
	    }
	    function deep_map(func, object) {
	        // This function isn't actually a full "deep map" yet.
	        // Limitations: It only applies func to OBJECTS (not arrays or
	        // atoms), and doesn't return anything.
	        if (Array.isArray(object))
	            for (var i=0; i < object.length; i++)
	                deep_map(func, object[i])
	        else if (typeof(object) === 'object' && object !== null) {
	            func(object)
	            for (var k in object)
	                deep_map(func, object[k])
	        }
	    }
	    function error(e, name) {
	        console.error('In', name + ':', e.stack)
	        if (window.on_client_error)
	            window.on_client_error(e)
	    }

	    function key_id(string) {
	        return string.match(/\/[^\/]+\/(\d+)/)[1]
	    }

	    // Camelcased API options
	    var updateCache=update_cache, serverFetch=server_fetch,
	        serverSave=server_save, serverDestroy=server_destroy

	    // Export the public API
	    window.ReactiveComponent = ReactiveComponent
	    window.fetch = fetch
	    window.save = save
	    window.destroy = destroy

	    // Make the private methods accessible under "window.arest"
	    vars = [['cache', cache], ['fetch',fetch], ['save',save], ['server_fetch', server_fetch], ['serverFetch', serverFetch], ['server_save', server_save], ['serverSave',serverSave], ['update_cache',update_cache], ['updateCache',updateCache], ['csrf',csrf], ['keys_4_component',keys_4_component], ['components_4_key', components_4_key], ['components',components], ['execution_context',execution_context], ['One_To_Many',One_To_Many], ['clone',clone], ['dirty_components', dirty_components], ['affected_keys',affected_keys], ['clear_matching_objects',clear_matching_objects], ['deep_map', deep_map], ['key_id', key_id]]
	    window.arest = {}
	    for (var i=0; i<vars.length; i++)
	        window.arest[vars[i][0]] = vars[i][1]

	})()


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var Auth, ensureCurrentUserAvatar;

	__webpack_require__(2);

	__webpack_require__(5);

	__webpack_require__(3);

	__webpack_require__(1);

	window.logout = function() {
	  var auth, current_user, ref;
	  current_user = fetch('/current_user');
	  current_user.logged_in = false;
	  current_user.trying_to = 'logout';
	  auth = fetch('auth');
	  if (auth.form && ((ref = auth.form) === 'edit profile')) {
	    loadPage('/');
	  }
	  reset_key(auth);
	  return save(current_user, (function(_this) {
	    return function() {
	      return location.reload();
	    };
	  })(this));
	};

	window.auth_ghost_gray = '#a1a1a1';

	window.auth_text_gray = '#444';

	Auth = ReactiveComponent({
	  displayName: 'Auth',
	  render: function() {
	    var auth, current_user;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (!this.local.last_auth || this.local.auth !== auth.auth) {
	      this.local.last_auth = auth;
	      current_user.errors = [];
	      this.local.errors = [];
	      save(this.local);
	      return SPAN(null);
	    }
	    if (!auth.form) {
	      return SPAN(null);
	    }
	    return DIV({
	      style: {
	        background: auth.form !== 'edit profile' && !this.props.naked ? customization('background') || focus_color() : void 0
	      }
	    }, auth.form !== 'edit profile' && !this.props.naked ? A({
	      href: 'https://consider.it',
	      target: '_blank',
	      style: {
	        position: 'absolute',
	        left: 10,
	        top: 10
	      }
	    }, drawLogo({
	      height: 35,
	      main_text_color: 'white',
	      o_text_color: 'white',
	      clip: false,
	      draw_line: true,
	      line_color: 'white',
	      transition: true
	    })) : void 0, DIV({
	      style: {
	        margin: "0 auto",
	        padding: !this.props.naked ? '4em 0' : void 0,
	        position: 'relative',
	        zIndex: 0,
	        width: AUTH_WIDTH()
	      }
	    }, this.buildAuthForm()));
	  },
	  buildAuthForm: function() {
	    var auth, avatar_field, current_user, email_field, goal, pledges, pledges_field, subdomain;
	    auth = fetch('auth');
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    goal = null;
	    if (auth.goal) {
	      try {
	        goal = "To " + (t(auth.goal).toLowerCase());
	      } catch (error1) {
	        goal = "To " + (auth.goal.toLowerCase());
	      }
	    }
	    switch (auth.form) {
	      case 'login':
	        return [this.headerAndBorder(goal, t('Introduce Yourself'), this.body([["" + (t('login_as')), this.inputBox('email', 'email@address', 'email')], ["" + (t("password")), [this.inputBox('password', t("password"), 'password'), this.resetPasswordLink()]]].concat(this.userQuestionInputs())))];
	      case 'create account':
	      case 'create account via invitation':
	        if (avatar_field = this.avatarInput()) {
	          avatar_field = ["" + (t('pic_prompt')), avatar_field];
	        }
	        if (pledges = this.pledgeInput()) {
	          pledges_field = [
	            DIV({
	              style: {
	                paddingTop: 12
	              }
	            }, 'Community Pledge'), pledges
	          ];
	        } else {
	          pledges_field = [];
	        }
	        if (auth.form === 'create account') {
	          email_field = ["" + (t('login_as')), this.inputBox('email', 'email@address', 'email')];
	        } else {
	          email_field = [
	            "" + (t('login_as')), DIV({
	              style: {
	                color: auth_text_gray,
	                padding: '4px 8px'
	              }
	            }, current_user.email)
	          ];
	        }
	        return [this.headerAndBorder(goal, t('create an account'), this.body([email_field, ["" + (t("password")), this.inputBox('password', t("password"), 'password')], [t('name_prompt'), this.inputBox('name', t('full_name'))], avatar_field].concat(this.userQuestionInputs()).concat([pledges_field])))];
	      case 'edit profile':
	        if (avatar_field = this.avatarInput()) {
	          avatar_field = [(t('pic_prompt')) + ":", avatar_field];
	        }
	        return [
	          this.headerAndBorder(goal, t('Your Profile'), this.body([!fetch('/subdomain').SSO_domain ? [(t('login_as')) + ":", this.inputBox('email', 'email@address', 'email')] : void 0, !fetch('/subdomain').SSO_domain ? ["My " + (t("password")) + ":", this.inputBox('password', t("password"), 'password')] : void 0, [(t('name_prompt')) + ":", this.inputBox('name', t('full_name'))], avatar_field].concat(this.userQuestionInputs()))), this.local.saved_successfully ? (subdomain.SSO_domain ? loadPage('/') : void 0, SPAN({
	            style: {
	              color: 'white'
	            }
	          }, t("Updated successfully"))) : void 0
	        ];
	      case 'reset password':
	        return [
	          this.headerAndBorder(null, t('Reset Your Password'), this.body([
	            [
	              '', INPUT({
	                name: 'user[verification_code]',
	                disabled: true,
	                style: {
	                  display: 'none'
	                }
	              })
	            ], [
	              '', INPUT({
	                type: 'password',
	                name: 'user[password]',
	                disabled: true,
	                style: {
	                  display: 'none'
	                }
	              })
	            ], [(t('Code')) + ":", this.inputBox('verification_code', t('code_from_email'))], [(t('New password')) + ":", this.inputBox('password', t("choose_password"), 'password')]
	          ], t('verification_sent'))), DIV({
	            style: {
	              marginTop: 20,
	              color: 'white',
	              textAlign: 'center'
	            }
	          }, 'Having trouble resetting your password? Watch this brief ', A({
	            target: '_blank',
	            href: 'https://vimeo.com/198802322',
	            style: {
	              textDecoration: 'underline',
	              fontWeight: 600
	            }
	          }, 'video tutorial'), '.')
	        ];
	      case 'verify email':
	        return [this.headerAndBorder(goal, t('Verify Your Email'), this.body([[(t('Code')) + ":", this.inputBox('verification_code', t('code_from_email'))]], t('verification_sent')))];
	      case 'user questions':
	        return [this.headerAndBorder(goal, t('more_info'), this.body(this.userQuestionInputs()))];
	      default:
	        throw "Unrecognized authentication form " + auth.form;
	    }
	  },
	  privacyAndTerms: function() {
	    return customization('terms') || "I agree to Consider.it's \n<a href='/terms_of_service' target='_blank' style='text-decoration: underline'>Terms</a>\n and \n<a href='/privacy_policy' target='_blank' style='text-decoration: underline'>Privacy Policy</a>.";
	  },
	  headerAndBorder: function(goal, task, body) {
	    var auth, button;
	    auth = fetch('auth');
	    if (auth.form === 'login') {
	      button = t('Log in');
	    } else {
	      button = t('Done');
	    }
	    return DIV(null, DIV({
	      style: {
	        width: AUTH_WIDTH(),
	        position: 'relative',
	        margin: 'auto',
	        top: 5
	      }
	    }, DIV({
	      style: {
	        textAlign: 'center',
	        position: 'relative',
	        display: this.props.naked ? 'none' : void 0
	      }
	    }, goal ? DIV({
	      style: {
	        fontWeight: 600,
	        fontSize: 18,
	        transform: 'translateY(6px)',
	        color: 'white'
	      }
	    }, goal) : void 0, H1({
	      style: {
	        display: 'inline-block',
	        position: 'relative',
	        fontWeight: 'bold',
	        fontSize: 48,
	        whiteSpace: 'nowrap',
	        color: auth.form !== 'edit profile' ? 'white' : void 0,
	        marginBottom: 10
	      }
	    }, task))), DIV({
	      className: this.local.submitting ? ' waiting' : '',
	      style: {
	        padding: '2.5em 80px 1.5em 80px',
	        fontSize: 18,
	        boxShadow: auth.form !== 'edit profile' ? '0 2px 4px rgba(0,0,0,.4)' : void 0,
	        backgroundColor: 'white',
	        position: 'relative'
	      }
	    }, body, this.submitButton(button, true)), this.form_footer());
	  },
	  body: function(fields, additional_instructions) {
	    var auth, current_user, error, errors, field, field_id, primary_color, ref;
	    current_user = fetch('/current_user');
	    primary_color = this.props.primary_color || focus_color();
	    return DIV(null, additional_instructions ? DIV({
	      style: {
	        color: auth_text_gray,
	        marginBottom: 18
	      }
	    }, additional_instructions) : void 0, (function() {
	      var i, len, ref, ref1, ref2, ref3, ref4, results;
	      results = [];
	      for (i = 0, len = fields.length; i < len; i++) {
	        field = fields[i];
	        if (!(field)) {
	          continue;
	        }
	        field_id = ((ref = field[1]) != null ? (ref1 = ref.props) != null ? ref1.id : void 0 : void 0) || ((ref2 = field[1]) != null ? (ref3 = ref2[0]) != null ? (ref4 = ref3.props) != null ? ref4.id : void 0 : void 0 : void 0);
	        if (field_id) {
	          field_id = field_id.replace('user_avatar_form', 'user_avatar');
	        }
	        results.push(DIV({
	          style: {
	            marginBottom: 8
	          }
	        }, LABEL({
	          htmlFor: field_id,
	          style: {
	            color: '#888',
	            fontSize: 24,
	            display: 'block',
	            fontWeight: 700,
	            fontStyle: 'oblique'
	          }
	        }, field[0]), field[1]));
	      }
	      return results;
	    })(), customization('auth_footer') ? (auth = fetch('auth'), auth.ask_questions && ((ref = auth.form) === 'create account' || ref === 'create account via invitation' || ref === 'user questions') ? DIV({
	      style: {
	        fontSize: 13,
	        color: auth_text_gray,
	        padding: '16px 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: customization('auth_footer')
	      }
	    }) : void 0) : void 0, (current_user.errors || []).length > 0 || this.local.errors.length > 0 ? (errors = current_user.errors.concat(this.local.errors || []), DIV({
	      role: 'alert',
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = errors.length; i < len; i++) {
	        error = errors[i];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    })())) : void 0);
	  },
	  form_footer: function() {
	    var auth, cancel_auth, ref, ref1, toggle, toggle_to;
	    auth = fetch('auth');
	    if (auth.form === 'create account') {
	      toggle_to = t('Log in');
	    } else {
	      toggle_to = t('Create an account');
	    }
	    toggle = (function(_this) {
	      return function(e) {
	        var current_user;
	        current_user = fetch('/current_user');
	        auth.form = auth.form === 'create account' ? 'login' : 'create account';
	        current_user.errors = [];
	        _this.local.errors = [];
	        save(auth);
	        save(_this.local);
	        return setTimeout(function() {
	          return $('#user_email')[0].focus();
	        }, 0);
	      };
	    })(this);
	    return DIV({
	      style: {
	        textAlign: 'center'
	      }
	    }, (ref = auth.form) === 'create account' || ref === 'login' ? DIV({
	      style: {
	        marginTop: 23,
	        width: '100%'
	      }
	    }, SPAN({
	      style: {
	        color: 'white',
	        fontWeight: 300,
	        fontSize: 24
	      }
	    }, auth.form === 'create account' ? 'Already have an account? ' : 'Not registered? '), BUTTON({
	      className: 'toggle_auth',
	      style: {
	        display: 'inline-block',
	        color: 'white',
	        textDecoration: 'underline',
	        fontWeight: 600,
	        fontSize: 24,
	        backgroundColor: 'transparent',
	        border: 'none',
	        padding: 0
	      },
	      onClick: toggle,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            toggle(e);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, toggle_to)) : void 0, ((ref1 = auth.form) !== 'edit profile') && !this.props.disable_cancel && (location.pathname !== '/' || auth.goal !== "access this private forum") ? (cancel_auth = (function(_this) {
	      return function(e) {
	        if (auth.form === 'verify email' || location.pathname === '/proposal/new') {
	          loadPage('/');
	        }
	        if (auth.form === 'verify email') {
	          setTimeout(logout, 1);
	        }
	        return reset_key(auth);
	      };
	    })(this), BUTTON({
	      style: {
	        color: 'white',
	        position: 'absolute',
	        cursor: 'pointer',
	        right: -100,
	        top: 40,
	        padding: 10,
	        fontSize: 24,
	        backgroundColor: 'transparent',
	        border: 'none',
	        opacity: .7
	      },
	      title: t('cancel'),
	      onClick: cancel_auth,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            cancel_auth(e);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, t('cancel'))) : void 0);
	  },
	  submitButton: function(action) {
	    var primary_color;
	    primary_color = this.props.primary_color || '#676767';
	    return BUTTON({
	      style: {
	        fontSize: 36,
	        display: 'block',
	        width: '100%',
	        fontWeight: 700,
	        backgroundColor: primary_color,
	        textAlign: 'center',
	        borderRadius: 8,
	        boxShadow: '0 2px 4px rgba(0,0,0,.2)',
	        marginTop: 20
	      },
	      className: 'primary_button' + (this.local.submitting ? ' disabled' : ''),
	      onClick: this.submitAuth,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            _this.submitAuth(e);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, action);
	  },
	  inputBox: function(name, placeholder, type, onChange, pattern) {
	    var auth, current_user, ref;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (!onChange) {
	      onChange = (function(_this) {
	        return function(event) {
	          if (type === 'email') {
	            _this.local[name] = current_user[name] = event.target.value.trim();
	          } else {
	            _this.local[name] = current_user[name] = event.target.value;
	          }
	          return save(_this.local);
	        };
	      })(this);
	    }
	    if (this.local[name] !== current_user[name]) {
	      this.local[name] = current_user[name];
	      save(this.local);
	      return SPAN(null);
	    }
	    return INPUT({
	      id: 'user_' + name,
	      className: 'auth_text_input',
	      style: {
	        marginBottom: 6,
	        width: '100%',
	        border: "1px solid #ccc",
	        padding: '10px 14px',
	        fontSize: browser.is_mobile ? 36 : 20,
	        display: 'inline-block',
	        backgroundColor: '#f2f2f2'
	      },
	      value: (ref = auth.form) === 'edit profile' ? this.local[name] : null,
	      name: "user[" + name + "]",
	      key: name + "_inputBox",
	      'aria-label': name === 'password' ? placeholder : void 0,
	      required: "required",
	      type: type || 'text',
	      onChange: onChange,
	      onKeyPress: (function(_this) {
	        return function(event) {
	          if (event.which === 13) {
	            return _this.submitAuth(event);
	          }
	        };
	      })(this),
	      pattern: pattern,
	      autoComplete: name === 'verification_code' ? 'off' : void 0
	    });
	  },
	  avatarInput: function() {
	    var current_user;
	    if (window.FormData) {
	      current_user = fetch('/current_user');
	      return FORM({
	        id: 'user_avatar_form',
	        action: '/update_user_avatar_hack'
	      }, DIV({
	        style: {
	          height: 60,
	          width: 60,
	          borderRadius: '50%',
	          backgroundColor: '#e6e6e6',
	          overflow: 'hidden',
	          display: 'inline-block',
	          marginRight: 18,
	          marginTop: 3
	        }
	      }, IMG({
	        alt: '',
	        id: 'avatar_preview',
	        style: {
	          width: 60,
	          display: !this.local.preview ? 'none' : void 0
	        },
	        src: current_user.b64_thumbnail ? current_user.b64_thumbnail : current_user.avatar_remote_url ? current_user.avatar_remote_url : null
	      }), !this.local.preview ? SVG({
	        width: 60,
	        viewBox: "0 0 100 100",
	        style: {
	          position: 'relative',
	          top: 8
	        }
	      }, PATH({
	        fill: "#ccc",
	        d: "M64.134,50.642c-0.938-0.75-1.93-1.43-2.977-2.023c8.734-6.078,10.867-18.086,4.797-26.805  c-6.086-8.727-18.086-10.875-26.82-4.797c-8.719,6.086-10.867,18.086-4.781,26.812c1.297,1.867,2.922,3.484,4.781,4.789  c-1.039,0.594-2.039,1.273-2.977,2.023c-6.242,5.031-11.352,11.312-15.023,18.438c-0.906,1.75-1.75,3.539-2.555,5.344  c17.883,16.328,45.266,16.328,63.133,0c-0.789-1.805-1.641-3.594-2.547-5.344C75.509,61.954,70.384,55.673,64.134,50.642z"
	      })) : void 0), INPUT({
	        id: 'user_avatar',
	        name: "avatar",
	        type: "file",
	        style: {
	          marginTop: 24,
	          verticalAlign: 'top'
	        },
	        onChange: (function(_this) {
	          return function(ev) {
	            var input, reader;
	            _this.submit_avatar_form = true;
	            input = $('#user_avatar')[0];
	            if (input.files && input.files[0]) {
	              reader = new FileReader();
	              reader.onload = function(e) {
	                _this.local.preview = true;
	                save(_this.local);
	                return $("#avatar_preview").attr('src', e.target.result);
	              };
	              return reader.readAsDataURL(input.files[0]);
	            } else {
	              return $("#avatar_preview").attr('src', asset('no_image_preview.png'));
	            }
	          };
	        })(this)
	      }));
	    } else {
	      return null;
	    }
	  },
	  pledgeInput: function() {
	    var idx, pledge, pledges, subdomain;
	    subdomain = fetch('/subdomain');
	    if (!customization('auth_require_pledge')) {
	      return null;
	    } else if (customization('pledge')) {
	      pledges = customization('pledge');
	    } else {
	      pledges = ['I will use only one account', 'I will not attack or mock others'];
	    }
	    return UL({
	      style: {
	        paddingTop: 6
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = pledges.length; i < len; idx = ++i) {
	        pledge = pledges[idx];
	        results.push(DIV({
	          style: {
	            marginBottom: 10,
	            marginLeft: -18
	          }
	        }, LABEL({
	          htmlFor: "pledge-" + idx,
	          style: {
	            fontSize: 18,
	            marginLeft: 18,
	            float: 'left'
	          }
	        }, INPUT({
	          className: "pledge-input",
	          type: 'checkbox',
	          id: "pledge-" + idx,
	          name: "pledge-" + idx,
	          style: {
	            fontSize: 24,
	            margin: 0,
	            marginLeft: -34
	          }
	        }), SPAN({
	          style: {
	            paddingLeft: 20
	          }
	        }, pledge)), DIV({
	          style: {
	            clear: 'both'
	          }
	        })));
	      }
	      return results;
	    })());
	  },
	  resetPasswordLink: function() {
	    var reset;
	    reset = (function(_this) {
	      return function(e) {
	        var current_user;
	        current_user = fetch('/current_user');
	        current_user.trying_to = 'send_password_reset_token';
	        return save(current_user, function() {
	          var ref;
	          if (((ref = current_user.errors) != null ? ref.length : void 0) > 0) {
	            return arest.updateCache(current_user);
	          } else {
	            return reset_key('auth', {
	              form: 'reset password'
	            });
	          }
	        });
	      };
	    })(this);
	    return DIV({
	      style: {
	        textAlign: 'right',
	        width: '100%'
	      }
	    }, BUTTON({
	      style: {
	        textDecoration: 'underline',
	        color: '#737373',
	        backgroundColor: 'transparent',
	        border: 'none',
	        fontSize: 12,
	        padding: 0,
	        fontWeight: 300,
	        position: 'relative',
	        top: -8
	      },
	      onClick: reset,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            reset(e);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, t('forgot_password')));
	  },
	  userQuestionInputs: function() {
	    var auth, current_user, i, input, inputs, label, len, question, questions, ref, ref1, subdomain, value;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (auth.ask_questions && ((ref = auth.form) === 'edit profile' || ref === 'create account' || ref === 'create account via invitation' || ref === 'user questions')) {
	      questions = customization('auth_questions').slice();
	    } else {
	      questions = [];
	    }
	    if ((ref1 = auth.form) === 'create account' || ref1 === 'craete account via invitation') {
	      questions.push({
	        tag: 'considerit_terms.editable',
	        question: this.privacyAndTerms(),
	        input: 'boolean',
	        required: true,
	        require_checked: true
	      });
	    }
	    if (this.local.tags !== current_user.tags) {
	      this.local.tags = current_user.tags;
	      save(this.local);
	      return SPAN(null);
	    }
	    inputs = [];
	    for (i = 0, len = questions.length; i < len; i++) {
	      question = questions[i];
	      label = "" + question.question;
	      switch (question.input) {
	        case 'text':
	          input = INPUT({
	            style: _.defaults(question.input_style || {}, {
	              marginBottom: 6,
	              width: 300,
	              border: "1px solid " + auth_ghost_gray,
	              padding: '5px 10px',
	              fontSize: 18
	            }),
	            key: question.tag + "_inputBox",
	            id: slugify(question.tag + "inputBox"),
	            type: 'text',
	            value: this.local.tags[question.tag],
	            onChange: (function(_this) {
	              return function(question) {
	                return function(event) {
	                  _this.local.tags = _this.local.tags || {};
	                  _this.local.tags[question.tag] = current_user.tags[question.tag] = event.target.value;
	                  return save(_this.local);
	                };
	              };
	            })(this)(question),
	            onKeyPress: (function(_this) {
	              return function(event) {
	                if (event.which === 13) {
	                  return _this.submitAuth(event);
	                }
	              };
	            })(this)
	          });
	          break;
	        case 'boolean':
	          input = DIV({
	            style: {
	              marginBottom: 10,
	              marginLeft: -18
	            }
	          }, LABEL({
	            htmlFor: slugify(question.tag + "inputBox"),
	            style: {
	              fontSize: 18,
	              marginLeft: 18,
	              float: 'left'
	            }
	          }, INPUT({
	            id: slugify(question.tag + "inputBox"),
	            key: question.tag + "_inputBox",
	            type: 'checkbox',
	            style: {
	              fontSize: 24,
	              margin: 0,
	              marginLeft: -34
	            },
	            checked: this.local.tags[question.tag],
	            onChange: (function(_this) {
	              return function(question) {
	                return function(event) {
	                  _this.local.tags = _this.local.tags || {};
	                  _this.local.tags[question.tag] = current_user.tags[question.tag] = event.target.checked;
	                  return save(_this.local);
	                };
	              };
	            })(this)(question)
	          }), SPAN({
	            style: {
	              paddingLeft: 20
	            },
	            dangerouslySetInnerHTML: {
	              __html: question.question
	            }
	          })), DIV({
	            style: {
	              clear: 'both'
	            }
	          }));
	          label = '';
	          break;
	        case 'dropdown':
	          input = SELECT({
	            id: slugify(question.tag + "inputBox"),
	            key: question.tag + "_inputBox",
	            style: _.defaults(question.input_style || {}, {
	              fontSize: 18,
	              marginTop: 4
	            }),
	            value: this.local.tags[question.tag],
	            onChange: (function(_this) {
	              return function(question) {
	                return function(event) {
	                  _this.local.tags = _this.local.tags || {};
	                  _this.local.tags[question.tag] = current_user.tags[question.tag] = event.target.value;
	                  return save(_this.local);
	                };
	              };
	            })(this)(question)
	          }, [
	            OPTION({
	              value: '',
	              selected: true,
	              disabled: true,
	              hidden: true
	            }), (function() {
	              var j, len1, ref2, results;
	              ref2 = question.options;
	              results = [];
	              for (j = 0, len1 = ref2.length; j < len1; j++) {
	                value = ref2[j];
	                results.push(OPTION({
	                  value: value
	                }, value));
	              }
	              return results;
	            })()
	          ]);
	          break;
	        default:
	          throw "Unsupported question type: " + question.input + " for " + question.tag;
	      }
	      if (!question.required && question.input !== 'boolean') {
	        label = [
	          label, SPAN({
	            style: {
	              color: '#888',
	              fontSize: 12,
	              paddingLeft: 10
	            }
	          }, 'optional')
	        ];
	      }
	      inputs.push([label, input]);
	    }
	    return inputs;
	  },
	  submitAuth: function(ev) {
	    var $el, auth, current_user, has_response, i, is_valid_input, len, question, questions, ref, ref1, subdomain;
	    ev.preventDefault();
	    $el = $(this.getDOMNode());
	    subdomain = fetch('/subdomain');
	    auth = fetch('auth');
	    current_user = fetch('/current_user');
	    this.local.errors = [];
	    if (auth.ask_questions && ((ref = auth.form) === 'create account' || ref === 'create account via invitation')) {
	      questions = customization('auth_questions');
	      for (i = 0, len = questions.length; i < len; i++) {
	        question = questions[i];
	        if (question.required) {
	          has_response = !!current_user.tags[question.tag];
	          if (!has_response || (question.require_checked && !current_user.tags[question.tag])) {
	            this.local.errors.push(question.question + " required!");
	          }
	          is_valid_input = true;
	          if (question.validation) {
	            is_valid_input = question.validation(current_user.tags[question.tag]);
	          }
	          if (!is_valid_input && has_response) {
	            this.local.errors.push(current_user.tags[question.tag] + " isn't a valid answer to " + question.question + "!");
	          }
	        }
	      }
	      save(this.local);
	    }
	    if ((ref1 = auth.form) === 'create account' || ref1 === 'create account via invitation') {
	      console.log(current_user.tags);
	      if (!current_user.tags['considerit_terms.editable']) {
	        this.local.errors.push("To proceed, you must agree to the terms");
	      }
	    }
	    if (this.local.errors.length === 0) {
	      this.local.submitting = true;
	      save(this.local);
	      current_user.signed_pledge = $el.find('.pledge-input').length === $el.find('.pledge-input:checked').length;
	      current_user.trying_to = auth.form;
	      save(current_user, (function(_this) {
	        return function() {
	          var ref2, ref3;
	          if ((ref2 = auth.form) === 'create account' || ref2 === 'edit profile') {
	            ensureCurrentUserAvatar();
	          }
	          if ((ref3 = auth.form) === 'edit profile') {
	            _this.local.saved_successfully = current_user.errors.length === 0 && (_this.local.errors || []).length === 0;
	          } else if (current_user.logged_in) {
	            if (auth.goal === 'Save your Opinion') {
	              setTimeout((function() {
	                return updateProposalMode('results', 'after_save');
	              }), 700);
	            }
	            reset_key(auth);
	          }
	          _this.local.submitting = false;
	          return save(_this.local);
	        };
	      })(this));
	      if (this.submit_avatar_form) {
	        return $('#user_avatar_form').ajaxSubmit({
	          type: 'PUT',
	          data: {
	            authenticity_token: current_user.csrf,
	            trying_to: 'update_avatar_hack'
	          }
	        });
	      }
	    }
	  },
	  componentDidMount: function() {
	    return writeToLog({
	      what: 'accessed authentication'
	    });
	  }
	});

	ensureCurrentUserAvatar = function(attempts) {
	  if (attempts == null) {
	    attempts = 0;
	  }
	  return $.getJSON('/user_avatar_hack', (function(_this) {
	    return function(response) {
	      var current_user, ref;
	      current_user = fetch('/current_user');
	      if ((response != null ? (ref = response[0]) != null ? ref.b64_thumbnail : void 0 : void 0) && current_user.b64_thumbnail !== response[0].b64_thumbnail) {
	        $('head').append("<style type=\"text/css\">#avatar-" + current_user.id + " { background-image: url('" + response[0].b64_thumbnail + "');}</style>");
	        current_user.b64_thumbnail = response[0].b64_thumbnail;
	        return save(current_user);
	      } else if (attempts < 20) {
	        return _.delay(function() {
	          return ensureCurrentUserAvatar(attempts + 1);
	        }, 1000);
	      }
	    };
	  })(this));
	};

	styles += "\n.auth_text_input::-webkit-input-placeholder{\n  color: " + auth_ghost_gray + ";\n} \n.auth_text_input:-moz-placeholder{\n  color: " + auth_ghost_gray + ";\n} \n.auth_text_input::-moz-placeholder {\n  color: " + auth_ghost_gray + ";\n} \n.auth_text_input::-ms-input-placeholder {\n  color: " + auth_ghost_gray + ";\n}";

	window.Auth = Auth;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var hide_tooltip, show_tooltip, user_name;

	__webpack_require__(1);

	__webpack_require__(9);

	__webpack_require__(3);

	window.avatarUrl = function(user, img_size) {
	  user = fetch(user);
	  return (fetch('/application').asset_host || '') + "/system/avatars/" + ((user.key.split('/')[2]) + "/" + img_size + "/" + user.avatar_file_name);
	};

	user_name = function(user, anon) {
	  user = fetch(user);
	  if (anon || !user.name || user.name.trim().length === 0) {
	    return 'Anonymous';
	  } else {
	    return user.name;
	  }
	};

	show_tooltip = function(e) {
	  var anonymous, current_user, filter, filters, i, icon, len, name, tooltip, user;
	  if (e.target.getAttribute('data-user') && e.target.getAttribute('data-tooltip')) {
	    user = fetch(e.target.getAttribute('data-user'));
	    anonymous = e.target.getAttribute('data-anonymous') === 'true';
	    current_user = fetch('/current_user');
	    name = e.target.getAttribute('data-tooltip');
	    if (!anonymous && (filters = customization('opinion_filters')) && (!customization('opinion_filters_admin_only') || current_user.is_admin)) {
	      for (i = 0, len = filters.length; i < len; i++) {
	        filter = filters[i];
	        if (filter.pass(user) && filter.icon) {
	          if (typeof filter.icon !== 'string') {
	            icon = filter.icon(user);
	          } else {
	            icon = filter.icon;
	          }
	          name += '<div style="font-style: italic; padding: 4px 0 0 0px">' + icon + "</div>";
	        }
	      }
	    }
	    tooltip = fetch('tooltip');
	    tooltip.coords = $(e.target).offset();
	    tooltip.tip = name;
	    save(tooltip);
	    return e.preventDefault();
	  }
	};

	hide_tooltip = function(e) {
	  var tooltip;
	  if (e.target.getAttribute('data-user') && e.target.getAttribute('data-tooltip')) {
	    if (e.target.getAttribute('data-title')) {
	      e.target.setAttribute('title', e.target.getAttribute('data-title'));
	      e.target.removeAttribute('data-title');
	    }
	    tooltip = fetch('tooltip');
	    tooltip.coords = null;
	    return save(tooltip);
	  }
	};

	document.addEventListener("mouseover", show_tooltip);

	document.addEventListener("mouseout", hide_tooltip);

	$('body').on('focusin', '.avatar', show_tooltip);

	$('body').on('focusout', '.avatar', hide_tooltip);

	window.avatar = function(user, props) {
	  var add_initials, alt, anonymous, attrs, current_user, ff, fontsize, id, img_size, name, ref, show_avatar, style, tag, thumbnail, tooltip, use_large_image;
	  props = _.extend({}, props);
	  if (!user.key) {
	    if (user === ((ref = arest.cache['/current_user']) != null ? ref.user : void 0)) {
	      user = fetch(user);
	    } else if (arest.cache[user]) {
	      user = arest.cache[user];
	    } else {
	      fetch(user);
	      return SPAN(null);
	    }
	  }
	  anonymous = (props.anonymous != null) && props.anonymous;
	  id = anonymous ? "avatar-hidden" : "avatar-" + (user.key.split('/')[2]);
	  style = _.extend({}, props.style);
	  img_size = props.img_size || 'small';
	  show_avatar = !anonymous && !!user.avatar_file_name;
	  if (img_size === 'small' && (style != null ? style.width : void 0) >= 50 && !browser.is_ie9) {
	    img_size = 'large';
	  }
	  use_large_image = img_size !== 'small' && show_avatar;
	  if (use_large_image) {
	    props.src = avatarUrl(user, img_size);
	  } else if (show_avatar) {
	    props.src = avatarUrl(user, img_size);
	  } else {
	    current_user = fetch('/current_user');
	    if (current_user.user === user.key) {
	      thumbnail = current_user.b64_thumbnail;
	      if ((thumbnail != null) && img_size === 'small') {
	        props.src = thumbnail;
	      }
	    } else {
	      style.content = "''";
	    }
	  }
	  if (show_avatar) {
	    style.backgroundColor = 'white';
	  }
	  add_initials = !user.avatar_file_name;
	  if (add_initials) {
	    style.textAlign = 'center';
	  }
	  tag = props.src == null ? SPAN : IMG;
	  name = user_name(user, anonymous);
	  alt = props.alt;
	  if (props.alt != null) {
	    delete props.alt;
	  }
	  tooltip = (alt != null ? alt.replace('<user>', name) : void 0) || name;
	  attrs = _.extend({}, props, {
	    key: user.key,
	    className: "avatar " + (props.className || ''),
	    'data-user': user.key,
	    'data-tooltip': !props.hide_tooltip ? tooltip : void 0,
	    'data-anon': anonymous,
	    style: style,
	    tabIndex: props.focusable ? 0 : -1
	  });
	  if (tag === IMG) {
	    attrs.alt = props.hide_tooltip ? '' : tooltip;
	  }
	  return tag(attrs, add_initials ? (fontsize = style.width / 2, ff = 'monaco,Consolas,"Lucida Console",monospace', name === 'Anonymous' ? name = '?' : void 0, name.length === 2 ? name = "" + name[0][0] + name[1][0] : name = "" + name[0][0], DIV({
	    style: {
	      color: 'white',
	      pointerEvents: 'none',
	      fontSize: fontsize,
	      position: 'relative',
	      fontFamily: ff,
	      top: .3 * fontsize,
	      overflow: 'hidden'
	    }
	  }, name, DIV({
	    className: 'hidden'
	  }, tooltip))) : void 0);
	};

	window.Avatar = ReactiveComponent({
	  displayName: 'Avatar',
	  render: function() {
	    return avatar(this.data(), this.props);
	  }
	});

	styles += ".avatar {\n  vertical-align: top;\n  background-color: transparent;\n  border: none;\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  border-radius: 50%;\n  background-size: cover;\n  background-color: " + default_avatar_in_histogram_color + "; \n  user-select: none; \n  -moz-user-select: none; \n  -webkit-user-select: none;\n  -ms-user-select: none;}\n  .avatar.avatar_anonymous {\n    cursor: default; \n}\n";


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  var style;
	  style = document.createElement('style');
	  style.type = 'text/css';
	  if (style.styleSheet) {
	    style.styleSheet.cssText = window.styles;
	  } else {
	    style.appendChild(document.createTextNode(window.styles));
	  }
	  document.body.appendChild(style);
	  return React.renderComponent(Saas({
	    key: 'saas_root'
	  }), document.getElementById('content'));
	})();


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	$.fn.ensureInView = function(options) {
	  var $el, bottom_inside, distance_to_travel, doc_bottom, doc_height, doc_top, el_bottom, el_height, el_top, in_viewport, is_onscreen, target, top_inside;
	  if (options == null) {
	    options = {};
	  }
	  _.defaults(options, {
	    fill_threshold: .5,
	    offset_buffer: 50,
	    scroll: true,
	    position: 'top',
	    speed: null,
	    callback: function() {}
	  });
	  $el = $(this);
	  el_height = $el.height();
	  el_top = $el.offset().top;
	  el_bottom = el_top + el_height;
	  doc_height = $(window).height();
	  doc_top = $(window).scrollTop();
	  doc_bottom = doc_top + doc_height;
	  is_onscreen = el_top > doc_top && el_bottom < doc_bottom;
	  bottom_inside = el_bottom < doc_bottom && (el_bottom - doc_top) > options.fill_threshold * el_height;
	  top_inside = el_top > doc_top && (doc_bottom - el_top) > options.fill_threshold * el_height;
	  in_viewport = is_onscreen || top_inside || bottom_inside;
	  if (!in_viewport) {
	    switch (options.position) {
	      case 'top':
	        target = el_top - options.offset_buffer;
	        break;
	      case 'bottom':
	        target = el_bottom - doc_height + options.offset_buffer;
	        break;
	      default:
	        throw 'bad position for ensureInView';
	    }
	    if (options.scroll) {
	      distance_to_travel = options.speed || Math.abs(doc_top - target);
	      return $("html, body").animate({
	        scrollTop: $el.offset().top - options.offset_buffer
	      }, {
	        duration: Math.min(distance_to_travel, 1500),
	        complete: options.callback
	      }, 'ease-in');
	    } else {
	      $(document).scrollTop(target);
	      return options.callback();
	    }
	  } else {
	    return options.callback();
	  }
	};

	$.fn.moveToTop = function(options) {
	  var $el, distance_to_travel, doc_top, el_bottom, el_top, target;
	  if (options == null) {
	    options = {};
	  }
	  _.defaults(options, {
	    offset_buffer: 50,
	    scroll: false
	  });
	  $el = $(this);
	  el_top = $el.offset().top;
	  el_bottom = target = el_top - options.offset_buffer;
	  doc_top = $(document).scrollTop();
	  if (options.scroll) {
	    distance_to_travel = Math.abs(doc_top - target);
	    return $('body').animate({
	      scrollTop: target
	    }, distance_to_travel);
	  } else {
	    return $(document).scrollTop(target);
	  }
	};


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var GoogleDocEmbed, LegalDoc, privacy_policy, terms_of_service;

	GoogleDocEmbed = ReactiveComponent({
	  displayName: 'GoogleDocEmbed',
	  render: function() {
	    return DIV({
	      style: {
	        width: '80%',
	        margin: 'auto',
	        maxWidth: 800
	      }
	    }, IFRAME({
	      ref: 'iframe',
	      width: '100%',
	      height: window.innerHeight,
	      src: this.props.link
	    }));
	  }
	});

	LegalDoc = function(html) {
	  return DIV({
	    style: {
	      width: '80%',
	      margin: '40px auto',
	      maxWidth: 1000,
	      padding: '25px 60px',
	      backgroundColor: 'white',
	      boxShadow: '0 1px 2px rgba(0,0,0,.2)'
	    }
	  }, STYLE({
	    dangerouslySetInnerHTML: {
	      __html: ".legaldoc .title {font-size: 36px; font-weight: bold; margin-bottom: 10px; margin-top: 20px}\n.legaldoc h1 {font-size: 28px; font-weight: 600; margin-bottom: 10px; margin-top: 20px}\n.legaldoc h2 {font-size: 20px; font-weight: 500; margin-bottom: 10px; margin-top: 20px}\n.legaldoc ul {list-style-position: outside; padding-left: 40px;}\n.legaldoc p {padding-top: 5px; padding-bottom: 5px;}\n.legaldoc a {text-decoration: underline; color:" + logo_red + ";}"
	    }
	  }), DIV({
	    className: 'legaldoc',
	    dangerouslySetInnerHTML: {
	      __html: html.replace(/hello@consider.it/g, '<a href="mailto:hello@consider.it">hello@consider.it</a>')
	    }
	  }));
	};

	window.PrivacyPolicy = function() {
	  return LegalDoc(privacy_policy);
	};

	window.TermsOfService = function() {
	  return LegalDoc(terms_of_service);
	};

	privacy_policy = '<p class="c0 title" id="h.46ek5o6s6nll"><span>Consider.it Privacy Policy </span></p><p class="c1"><span>Updated: 10/23/2016</span></p><p class="c1 c3"><span></span></p><p class="c1 c3"><span></span></p><p class="c1"><span>Hi Friends,</span></p><p class="c1"><span>We want you (the end user) to understand how and why Consider.it, Invisible College LLC (&ldquo;Consider.it,&rdquo; &ldquo;we&rdquo; or &ldquo;us&rdquo;) collects, uses and shares information about you when you access and use Consider.it&rsquo;s site and services (collectively, the &ldquo;Services&rdquo;) or when you otherwise interact with us. </span></p><h1 class="c0" id="h.htirnipe6py7"><span>Information we collect about you</span></h1><p class="c1"><span>We collect information you provide directly to us when you use our Services. Depending on which Service you use, we may collect different information about you. This includes: </span></p><h2 class="c0" id="h.wdoprsyqfsnu"><span>Content you share</span></h2><p class="c1"><span>Consider.it allows users to post content, including proposals, points, comments, photos, links and other materials. Anything that a user posts or otherwise makes available on our Services is referred to as &ldquo;Content.&rdquo; We collect the Content you post to the Services, such as opinions you give, the proposals, points and comments you write, both in public and in private Consider.it Forums.</span></p><h2 class="c0" id="h.zg7yli1ymy2p"><span>Information regarding your account</span></h2><p class="c1"><span>We collect the information you provide when you use our Services. This includes information used to create your account (e.g., a username, </span><span>password</span><span>, email address and avatar).</span></p><h2 class="c0" id="h.440l4yel9x0g"><span>Transactional information</span></h2><p class="c1"><span>If you purchase products or services from us, we will collect certain information from you, including your name, address, email address, and information about the product or service you are purchasing. Sometimes p</span><span>ayments are processed by third-party payment processors</span><span>; if so, please refer to the applicable processor&rsquo;s terms and privacy policy for more information about how payment information is processed and stored.</span></p><h2 class="c0" id="h.peooesnmsifi"><span>Other Information</span></h2><p class="c1"><span>You may choose to provide other information or certain Consider.it Forums might require you to provide other information to join. For example, a Forum about housing affordability may ask questions about your housing type and whether you own or rent it. </span></p><h2 class="c0" id="h.5d0vpdd0m38"><span>Information we collect automatically</span></h2><p class="c1"><span>When you access or use our Services, we may also automatically collect information about you. This includes Log and Usage Data such as your IP address, user-agent string, browser type, operating system, referral URLs, device information, pages listed, links clicked, user interactions (opinions, proposals, comments and points created), the requested URL, and hardware settings. </span></p><h2 class="c1 c4" id="h.dy0wqhng99wx"><span>Children Under the Age of 13</span></h2><p class="c1"><span>Our Services are not intended for children under 13 years of age. No one under age 13 may provide any information to or on the Services. We do not knowingly collect personal information from children under 13. If you are under 13, do not use or provide any information on these Services or on or through any of its features/register on the Services, make any purchases through the Services, use any of the interactive or public comment features of the Services or provide any information about yourself to us, including your name, address, telephone number, email address, or any screen name or user name you may use.</span></p><p class="c1 c3"><span></span></p><p class="c1"><span>If we learn we have collected or received personal information from a child under 13 without verification of parental consent, we will delete that information. If you believe we might have any information from or about a child under 13, please contact us at hello@consider.it.</span></p><p class="c1 c3"><span></span></p><h1 class="c0" id="h.m7sqfsgs9n6w"><span>How we use information about you</span></h1><p class="c1"><span>By way of example, and not as a limitation, w</span><span>e use information about you to</span><span>:</span></p><ul class="c8 lst-kix_c2vn886nr1ma-0 start"><li class="c2 c1"><span>Provide, maintain, and improve the Services;</span></li><li class="c2 c1"><span>Help protect the safety of Consider.it and our users, which includes blocking suspected spammers, addressing abuse, and enforcing the <a class="c5" href="/terms_of_service">Terms of Service</a></li><li class="c2 c1"><span>Send you technical notices, updates, security alerts, invoices and other support and administrative messages;</span></li><li class="c2 c1"><span>Provide customer service;</span></li><li class="c2 c1"><span>Communicate with you about products, services, offers, promotions and events, and provide other news and information we think be of interest to you;</span></li><li class="c2 c1"><span>Monitor and analyze trends, usage, and activities in connection with our Services; and</span></li><li class="c2 c1"><span>Promote our Services using Content that you share in public forums</span></li></ul><h1 class="c0" id="h.w4d372dnyqwt"><span>How we share information</span></h1><p class="c1"><span>When you use the Services, certain information may be shared with other users and the public. For example, when you submit a proposal, point, opinion, comment or other Content to the Services, visitors to and users of our Services will be able to see your Content, the username associated with your Content, and sometimes the date and time you originally submitted the Content. Although some parts of the Services may be private, they may become public (e.g., at the moderator&rsquo;s option in the case of private communities) and you should take that into consideration before posting Content to the Services.</span></p><h2 class="c0" id="h.d32epkgxe9cs"><span>Forum Information</span></h2><p class="c1"><span>In private Forums, proposals, points, comments, usernames and other Content are only viewable by members of the respective private Forum. In order to enter a Forum, a member must log in with his or her proper credentials. </span></p><p class="c1 c3"><span></span></p><p class="c1"><span>In public Forums, proposals, points, comments, usernames, and other Content are viewable by the public at large. </span><span>Consider.it may use publicly viewable information and Content to promote the Services in any and all media, including, without limitation, social media</span><span>.</span></p><p class="c1 c3"><span></span></p><h2 class="c0" id="h.1dm6kvt1bc2e"><span>Sponsors; Governmental Entities</span></h2><ul class="c8 lst-kix_7h72mbu6em9h-0 start"><li class="c2 c1"><span>General. We will provide certain Personal Information to certain Sponsors of a Forum. These sponsors will be chartered organizations that (1) have clearly communicated that the forum is run by that organization and (2) have signed a contract with us. Specifically, we will provide Sponsor with reports containing (a) Content created in the Forum, linked to the account information of the user who created it and (b) Account information about users of the forum including but not limited to demographic data and personal contact information; and (c) other related data.</span></li><li class="c2 c1"><span>Public Records. If the Sponsor is a government entity or other public body, then representatives of that government entity or public body will communicate via the Services. Consequently, any communication via the Services (whether by a government representative, your, or the general public) may be considered a &ldquo;public record&rdquo; in the jurisdiction of the Sponsor, and, as such, may be subject to monitoring and retention by the Sponsor, and disclosure to third parties.</span></li><li class="c2 c1"><span>Other/Legal. There are other instances in which Consider.it may divulge your Personal Information, such as when required by law, regulation, or litigation.</span></li></ul><p class="c1 c3"><span></span></p><p class="c1"><span>We will not share, sell, or give away any of our users&rsquo; personal information to third parties, unless one of the following circumstances applies:</span></p><p class="c1 c3"><span></span></p><ul class="c8 lst-kix_fx6f8rldc2zc-0 start"><li class="c2 c1"><span>We may share information (and will attempt to provide you with prior notice, to the extent legally permissible) in response to a request for information if we believe disclosure is in accordance with, or required by, any applicable law, regulation, legal process or governmental request;</span></li><li class="c2 c1"><span>We may share information in response to an emergency if we believe it&#39;s necessary to prevent imminent and serious bodily harm to a person;</span></li><li class="c2 c1"><span>We may share information between and among Consider.it and Invisible College, LLC, and its current and future parents, affiliates, subsidiaries, and other companies under common control and ownership;</span></li><li class="c2 c1"><span>We may share information as it relates to advertisers and our ad partners, we may share information with vendors, consultants, and other service providers who need access to such information to carry out work for us;</span></li><li class="c2 c1"><span>We may share information with your consent or at your direction;</span></li><li class="c1 c2"><span>We may share aggregated or de-identified information, which cannot reasonably be used to identify you</span><span>;</span></li><li class="c2 c1"><span>We may share information with Sponsors of a Forum as described elsewhere in this document</span></li></ul><p class="c1 c3"><span></span></p><h2 class="c0" id="h.3xtgda5h3qbo"><span>Security</span></h2><p class="c1"><span>We take reasonable measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration, and destruction. For example, we do not directly store your password on our server; instead we store a salted password that is then encrypted using a cryptographic hash function.</span></p><h2 class="c1 c4" id="h.szjbarfnyus8"><span>California Rights</span></h2><p class="c1"><span>California Civil Code Section &sect; 1798.83 permits users of our site that are California residents to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make such a request, please send an email to hello@consider.it or write us at: 2420 NE Sandy Blvd, Suite 126, Portland, OR 97232.</span></p><h1 class="c0" id="h.6ccag1e9eq8m"><span>Accessing and Correcting Your Information</span></h1><p class="c1"><span>You can review and change your personal information by logging into Services and visiting your account profile page.</span></p><p class="c1 c3"><span></span></p><p class="c1"><span>You may also send us an email at hello@consider.it to request access to, or correct any personal information that you have provided to us. Sometimes we cannot delete your personal information except by also deleting your user account. We may not accommodate a request to change information if we believe the change would violate any law or legal requirement or cause the information to be incorrect.</span></p><p class="c1 c3"><span></span></p><p class="c1"><span>If you delete your Content from the Services, copies of your Content may remain viewable in cached and archived pages, or might have been copied or stored by other users of the Service. Proper access and use of information provided on the Services, including Content, is governed by our <a class="c5" href="/terms_of_service">Terms of Service</a>.</p><h1 class="c0" id="h.h1c028lcgxnq"><span>Changes</span></h1><p class="c1"><span>We may change this Privacy Policy from time to time. If we do, we will let you know by revising the </span><span>date at the top of the policy</span><span>. We encourage you to review the Privacy Policy whenever you access or use our Services or otherwise interact with us to stay informed about our information practices and the ways you can help protect your privacy. If you continue to use our Services after Privacy Policy changes go into effect, you consent to the revised policy.</span></p><h1 class="c0" id="h.y4nstxs9j4rd"><span>Contact Us</span></h1><p class="c1"><span>If you have any questions about this Privacy Policy, please email hello@consider.it. </span></p>';

	terms_of_service = '<p class="c1 c3 title" id="h.593bs2mn3ara"><span>Consider.it Terms of Service</span></p><p class="c1"><span>Updated: 10/23/2016</span></p><p class="c0"><span></span></p><p class="c0"><span></span></p><p class="c1"><span>Hi Friends,</span></p><p class="c0"><span></span></p><p class="c1"><span>This agreement is a legal contract between you (the user of the Service) and us (Consider.it). You acknowledge that you have read, understood, and agree to be bound by the terms of this agreement. If you do not agree to this agreement, you should not use Consider.it. Please also take a look at Consider.it&rsquo;s <a class="c5" href="/privacy_policy">Privacy Policy</a>; it explains how we collect and use your information.</span></p><p class="c0"><span></span></p><p class="c1"><span>Consider.it and Invisible College, LLC (&ldquo;Consider.it&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;) has established the Consider.it website located at https://consider.it (the &ldquo;Site&rdquo;) to enable you to provide input, feedback and suggestions on the topics described on pages of the Site and contribute to the conversation with other users of the Site, as applicable. Please read these Terms of Use (the &ldquo;Terms&rdquo;) carefully because they govern your use of the Site and our services accessible via our Site. To make these Terms easier to read, the Site and our services are collectively called the &ldquo;Services.&rdquo;</span></p><h2 class="c1 c3" id="h.3de3zzlneeje"><span>Acceptance of Terms</span></h2><p class="c1"><span>By using our Services in any way, including registering on the Site, contributing your input, feedback or suggestions, or merely browsing the Site, you agree to be and are bound by these Terms. If you do not agree to all of the Terms, do not access or use our Services.</span></p><h2 class="c1 c3" id="h.yt4of1k1ez0i"><span>Who can use Consider.it? </span></h2><p class="c1"><span>You may use our Services only if you can form a binding contract with Consider.it, and only in compliance with these Terms and all applicable laws. Any use or access by anyone under the age of 13 is prohibited. If you open an account on behalf of a company, organizations, or other entity, then (a) &ldquo;you&rdquo; includes you and that entity, and (b) you represent and warrant that you are authorized to grant all permissions and licenses provided in these Terms and bind the entity to these Terms, and that you agree to these Terms on the entity&rsquo;s behalf.</span></p><h2 class="c1 c3" id="h.p9lbo1actl5o"><span>User content in Consider.it</span></h2><p class="c1"><span>Consider.it allows users to post content, including proposals, points, comments, photos, links and other materials. Anything that a user posts or otherwise makes available on our Services is referred to as &ldquo;Content.&rdquo;</span></p><p class="c0"><span></span></p><p class="c1"><span>Consider.it does not guarantee the accuracy, integrity or quality of any Content posted or submitted to the Site. You understand that by using the Site you may be exposed to Content that is offensive, indecent or objectionable.</span></p><p class="c0"><span></span></p><p class="c1"><span>The Services may provide, or third parties may provide, links to other websites or resources. Because Consider.it has no control over such sites and resources, you acknowledge and agree that Consider.it is not responsible for the availability of such external sites or resources, and does not endorse and is not responsible or liable for any content, advertising, products or other materials on or available from such sites or resources. You further acknowledge and agree that Consider.it shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such site or resource. </span></p><h2 class="c1 c3" id="h.p5gmj19t7a2i"><span>Your content in Consider.it&rsquo;s services</span></h2><p class="c1"><span>Consider.it allows you to post content, including proposals, points, comments, photos, links, user profile information and other materials (the &ldquo;Content&rdquo;).</span></p><p class="c0"><span></span></p><p class="c1"><span>You own all of the Content you post on Consider.it and retain all rights therein. When you use our Services, you give Consider.it and those who we work with a perpetual, worldwide, non-exclusive, royalty-free license to use, host, store, reproduce, modify, create derivative works (such as those resulting from translations, adaptations or other changes we make so that your Content works better with our Services), communicate, publish, publicly perform, publicly display and distribute such Content, including all versions of that Content. This license continues even if you stop using our Services.</span></p><p class="c0"><span></span></p><p class="c1"><span>When you post or otherwise submit Content to the Site, you acknowledge and agree that you, and not Consider.it, are entirely responsible for all such Content. You agree to defend, indemnify and hold harmless Consider.it, its affiliates, licensors and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses or fees (including reasonable attorneys&#39; fees) arising out of or relating to your violation of these Terms of Use or your use of the Site, including, but not limited to, your Content, any use of the Site&rsquo;s content, services and products other than as expressly authorized in these Terms of Use or your use of any information obtained from the Site.</span></p><h2 class="c1 c3" id="h.1mt0zz1mupsr"><span>User conduct </span></h2><p class="c1"><span>As a condition of use, you promise not to use the Services for any purpose that is unlawful or prohibited by these Terms, or any other purpose not reasonably intended by Consider.it. Such Content may be subject to removal by Consider.it. By way of example, and not as a limitation, you agree not to use the Services:</span></p><ul class="c2 lst-kix_ezu80jfv7war-0 start"><li class="c4 c1"><span>To abuse, harass, threaten, impersonate or intimidate any person;</span></li><li class="c1 c4"><span>To post or transmit, or cause to be posted or transmitted, any Content or communications that are libelous, defamatory, abusive, or that infringes any copyright or other right of any person;</span></li><li class="c4 c1"><span>For any purpose that is not permitted under the laws of the jurisdiction where you use the Services;</span></li><li class="c4 c1"><span>To post or transmit, or cause to be posted or transmitted, any communication designed or intended to obtain password, account, or private information from any other Consider.it user;</span></li><li class="c4 c1"><span>To advertise to or solicit, any user to buy or sell any third party products or services, or to use any information obtained from the Services in order to contact, advertise to, solicit, or sell to any user without their prior explicit consent;</span></li><li class="c4 c1"><span>To create multiple accounts for the purpose of manipulating the feedback in Consider.it; or</span></li><li class="c4 c1"><span>To post copyrighted communications that do not belong to you.</span></li></ul><p class="c1"><span>&nbsp;</span></p><p class="c1"><span>Certain Consider.it sites have a moderation interface and the creators of those conversations can choose to hide or remove user Content that do not meet the standards of their forum.</span></p><p class="c0"><span></span></p><p class="c1"><span>To report suspected abuse of the Site or a breach of the Terms please send written notice to Consider.it at email: hello@consider.it. For conversations without moderation, you are responsible for your interactions with other users of the Site. Consider.it reserves the right, but has no obligation, to monitor disputes between you and other users. </span></p><h2 class="c1 c3" id="h.63u6qavynfo6"><span>Termination</span></h2><p class="c1"><span>Consider.it may terminate or suspend any and all Services and/or your Consider.it account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination of your account, your right to use the Services will immediately cease. If you wish to terminate your Consider.it account, you may simply discontinue using the Services or request your account to be deleted. All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</span></p><p class="c0"><span></span></p><p class="c1"><span>It is your responsibility to remove all Content from your account prior to termination.</span></p><h2 class="c1 c3" id="h.7i6iujwwmfc2"><span>Copyright Infringement</span></h2><p class="c1"><span>If you believe that any content or user contributions violate your copyright, please email us at hello@consider.it for instructions on sending us a notice of copyright infringement. It is the policy of the Consider.it to terminate the user accounts of repeat infringers. </span></p><h2 class="c1 c3" id="h.h6i9zzhvw1i"><span>Reliance on Information Posted</span></h2><p class="c1"><span>The information presented on or through the Services is made available solely for general information purposes. We do not warrant the accuracy, completeness or usefulness of this information. Any reliance you place on such information is strictly at your own risk. We disclaim all liability and responsibility arising from any reliance placed on such materials by you or any other visitor to Consider.it, or by anyone who may be informed of any of its contents.</span></p><p class="c0"><span></span></p><p class="c1"><span>The Services may include content provided by third parties, including materials provided by other users, bloggers and third-party licensors, syndicators, aggregators and/or reporting services. All statements and/or opinions expressed in these materials, and all articles and responses to questions and other content, other than the content provided by Consider.it, are solely the opinions and the responsibility of the person or entity providing those materials. These materials do not necessarily reflect the opinion of Consider.it. We are not responsible, or liable to you or any third party, for the content or accuracy of any materials provided by any third parties.</span></p><h2 class="c1 c3" id="h.p52q8qmtj4rg"><span>Deleting Account</span></h2><p class="c1"><span>Users may delete their account by emailing a request for deletion to hello@consider.it. Because you may have created points that other users have included in their personal lists or commented on or you may have created proposals that other users have given their opinion on, any Content that may be lawfully retained and displayed will continue to be visible through the Services and retained by us. The account associated with these points and proposals will have the name, email address and demographic information removed, leaving an anonymous profile. </span></p><h2 class="c1 c3" id="h.rjqgabgm7kmm"><span>Use of site by Governmental Entities</span></h2><p class="c1"><span>Consider.it intends to comply with all local, state and federal laws related to the required disclosure of any information provided via the Services. Under some instances the entity sponsoring specific Content or a project (&ldquo;Sponsor&rdquo;) through our Services will be a governmental entity. In such instances, the governmental Sponsor may or may not use the information that you provide to the Services for the purposes associated with the Services. It should be noted that such information may or may not be considered public information or public records under applicable state and federal laws. To the extent that anything you contribute to the Services, including your personal information, is considered a public record or as otherwise belonging to a governmental entity and, therefore, subject to certain local, state or federal disclosure laws, such applicable laws will govern the use and required disclosure of such information. </span></p><h2 class="c1 c3" id="h.civhky9d7umo"><span>Data Requests</span></h2><p class="c1"><span>Users and group coordinators may request data related to their personal account and group(s) respectively. The data provided shall be related to the Consider.it plan chosen. Consider.it will take reasonable efforts to provide this data. Consider.it has the right to refuse repetitive or technically difficult requests. For information about how we collect and share user information, please refer to Consider.it&rsquo;s</span><span> <a class="c5" href="/privacy_policy">privacy policy</a></span><span>.</span></p><h2 class="c1 c3" id="h.emnayct82llp"><span>Limitation of Liability</span></h2><p class="c1"><span>In no event shall Consider.it, its affiliates or their respective officers, directors, members, managers, partners, employees, or agents (or the Sponsor) be liable to you or any third party for any special, punitive, incidental, indirect or consequential damages or losses of any kind, or any damages or losses whatsoever, including those resulting from loss of use, data or profits, whether or not foreseeable or if Consider.it (or the Sponsor) has been advised of the possibility of such damages or losses, and on any theory of liability, including breach of contract or warranty, negligence or other tortious action, or any other claim arising out of or in connection with: (i) the access or use or of or the inability to access or use the services; (ii) the statements or actions of any third party on or via the services; (iii) any dealings with vendors or other third parties; (iv) any unauthorized access to or alteration of your transmissions, submitted content or other data; (v) any information that is sent or received or not sent or received; (vi) any failure to store or loss of data, files, materials or other content; (vii) any services available that are delayed or interrupted; (viii) any web site referenced or linked to from this services; or ix) your access to or use of or inability to access or use any linked site. Some jurisdictions prohibit the exclusion or limitation of liability for consequential or incidental damages. Accordingly, the limitations and exclusions set forth above may not apply to you.</span></p><p class="c0"><span></span></p><p class="c1"><span>You understand that we cannot and do not guarantee or warrant that files available for downloading from the internet or the Site will be free of viruses or other destructive code. You are responsible for implementing sufficient procedures and checkpoints to satisfy your particular requirements for anti-virus protection and accuracy of data input and output, and for maintaining a means external to our site for any reconstruction of any lost data. WE WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK, VIRUSES OR OTHER TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA OR OTHER PROPRIETARY MATERIAL DUE TO YOUR USE OF THE SITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE SITE OR TO YOUR DOWNLOADING OF ANY MATERIAL POSTED ON IT, OR ON ANY WEBSITE LINKED TO IT.</span></p><p class="c0"><span></span></p><p class="c1"><span>YOUR USE OF THE SITE, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE SITE IS AT YOUR OWN RISK. THE SITE, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE ARE PROVIDED ON AN &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. NEITHER CONSIDER.IT NOR ANY PERSON ASSOCIATED WITH CONSIDER.IT MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE SITE. WITHOUT LIMITING THE FOREGOING, NEITHER CONSIDER.IT NOR ANYONE ASSOCIATED WITH CONSIDER.IT REPRESENTS OR WARRANTS THAT THE SITE, ITS CONTENT OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE SITE OR SERVICES WILL BE ACCURATE, RELIABLE, ERROR-FREE OR UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT OUR SITE OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE SITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE SITE WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.</span></p><p class="c0"><span></span></p><p class="c1"><span>CONSIDER.IT HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR PARTICULAR PURPOSE.</span></p><p class="c0"><span></span></p><p class="c1"><span>THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.</span></p><h2 class="c1 c3" id="h.vxk2pa6dld7y"><span>Change to Terms or Services</span></h2><p class="c1"><span>Consider.it may change the Terms and other guidelines and rules posted on the Site from time to time at its sole discretion. If we do so, we&rsquo;ll let you know either by posting the modified Terms on the Site or through other communications. Your continued access or use for the Services constitutes your acceptance of the changes. Your access to and use of the Site will be subject to the most current version of the Terms posted on the Site at the time of such use. Please regularly check the </span><span><a class="c5" href="terms_of_service">Terms of Service link</a></span><span> to view the then-current terms. If you don&rsquo;t agree to be bound by the modified Terms, then you may no longer use the Services. If you breach any of the Terms, your authorization to access or use our Services automatically terminates. Because our Services are evolving over time we may change or discontinue all or any part of the Services, at any time and without notice, at our sole discretion.</span></p><h2 class="c1 c3" id="h.ypa68ydlyz73"><span>Contact Information</span></h2><p class="c1"><span>If you have any questions about these Terms or the Services, please contact us at hello@consider.it</span><span>.</span></p><p class="c0"><span></span></p>';


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var AccessControlled, AccessDenied, Permission, matchEmail, matchSomeRole, permit,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	__webpack_require__(2);

	__webpack_require__(3);

	Permission = {
	  PERMITTED: 1,
	  DISABLED: -1,
	  UNVERIFIED_EMAIL: -2,
	  NOT_LOGGED_IN: -3,
	  INSUFFICIENT_INFORMATION: -5,
	  INSUFFICIENT_PRIVILEGES: -4
	};

	permit = function(action) {
	  var comment, current_user, existing_required_info, opinion, point, proposal, required_info, subdomain;
	  current_user = fetch('/current_user');
	  switch (action) {
	    case 'create proposal':
	      subdomain = fetch('/subdomain');
	      if (!current_user.is_admin && !matchEmail(subdomain.roles.proposer)) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      break;
	    case 'update proposal':
	    case 'delete proposal':
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      proposal = fetch(arguments[1]);
	      if (!current_user.is_admin && (proposal.key === 'new_proposal' || !matchEmail(proposal.roles.editor))) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'publish opinion':
	      proposal = fetch(arguments[1]);
	      subdomain = fetch('/subdomain');
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'writer', 'opiner'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      required_info = _.pluck(_.where(customization('auth_questions'), {
	        required: true
	      }), 'tag');
	      existing_required_info = _.intersection(required_info, _.keys(current_user.tags));
	      if (existing_required_info.length !== required_info.length) {
	        return Permission.INSUFFICIENT_INFORMATION;
	      }
	      break;
	    case 'update opinion':
	      proposal = fetch(arguments[1]);
	      opinion = fetch(arguments[2]);
	      if (opinion.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'create point':
	      proposal = fetch(arguments[1]);
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'writer'])) {
	        if (!current_user.logged_in) {
	          return Permission.NOT_LOGGED_IN;
	        } else {
	          return Permission.INSUFFICIENT_PRIVILEGES;
	        }
	      }
	      break;
	    case 'update point':
	      point = fetch(arguments[1]);
	      if (!current_user.is_admin && point.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'delete point':
	      point = fetch(arguments[1]);
	      if (!current_user.is_admin) {
	        if (point.user !== fetch('/current_user').user) {
	          return Permission.INSUFFICIENT_PRIVILEGES;
	        }
	        if (point.includers.length > 1 || (point.includers.length === 1 && point.includers[0] !== current_user.user)) {
	          return Permission.DISABLED;
	        }
	      }
	      break;
	    case 'create comment':
	      proposal = fetch(arguments[1]);
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'writer', 'commenter'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'update comment':
	      comment = fetch(arguments[1]);
	      if (!current_user.is_admin && comment.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    default:
	      console.error("Unrecognized action to permit: " + action);
	  }
	  return Permission.PERMITTED;
	};

	matchEmail = function(permission_list) {
	  var allowed_domain, email_or_key, i, len, ref, user;
	  user = fetch('/current_user');
	  if (indexOf.call(permission_list, '*') >= 0) {
	    return true;
	  }
	  if (ref = user.user, indexOf.call(permission_list, ref) >= 0) {
	    return true;
	  }
	  for (i = 0, len = permission_list.length; i < len; i++) {
	    email_or_key = permission_list[i];
	    if (email_or_key.indexOf('*') > -1) {
	      if (user.email) {
	        allowed_domain = email_or_key.split('@')[1];
	        if (user.email.split('@')[1] === allowed_domain) {
	          return true;
	        }
	      }
	    }
	  }
	  return false;
	};

	matchSomeRole = function(roles, accepted_roles) {
	  var i, len, role;
	  for (i = 0, len = accepted_roles.length; i < len; i++) {
	    role = accepted_roles[i];
	    if (matchEmail(roles[role])) {
	      return true;
	    }
	  }
	  return false;
	};

	window.recourse = function(permission, goal) {
	  var auth, current_user, loc;
	  loc = fetch('location');
	  auth = fetch('auth');
	  goal = goal || ("access this " + (loc.url === '/' ? 'private forum' : 'page'));
	  switch (permission) {
	    case Permission.INSUFFICIENT_PRIVILEGES:
	      if (loc.url !== '/') {
	        return loadPage('/');
	      }
	      break;
	    case Permission.NOT_LOGGED_IN:
	      if (!auth.form) {
	        return reset_key('auth', {
	          form: 'login',
	          goal: goal,
	          ask_questions: true
	        });
	      }
	      break;
	    case Permission.UNVERIFIED_EMAIL:
	      if (auth.form !== 'verify email') {
	        reset_key('auth', {
	          form: 'verify email',
	          goal: goal
	        });
	        current_user = fetch('/current_user');
	        current_user.trying_to = 'send_verification_token';
	        return save(current_user);
	      }
	  }
	};

	AccessControlled = {
	  accessGranted: function() {
	    var access_attrs, current_user, local_but_not_component_unique;
	    current_user = fetch('/current_user');
	    local_but_not_component_unique = fetch("local-" + this.page.key);
	    access_attrs = ['verified', 'logged_in', 'email'];
	    if (local_but_not_component_unique._last_current_user && this.data().permission_denied) {
	      if (this._relevant_current_user_values_have_changed(access_attrs)) {
	        delete this.data().permission_denied;
	        arest.serverFetch(this.page.key);
	      }
	    }
	    if (this.data().permission_denied && this.data().permission_denied < 0) {
	      recourse(this.data().permission_denied);
	    }
	    if (this._relevant_current_user_values_have_changed(access_attrs)) {
	      local_but_not_component_unique._last_current_user = _.map(access_attrs, function(attr) {
	        return current_user[attr];
	      });
	      save(local_but_not_component_unique);
	    }
	    return !this.data().permission_denied || this.data().permission_denied > 0;
	  },
	  _relevant_current_user_values_have_changed: function(access_attrs) {
	    var current_user, el, i, idx, last_values, len, reduced_user;
	    current_user = fetch('/current_user');
	    last_values = fetch("local-" + this.page.key);
	    reduced_user = _.map(access_attrs, function(attr) {
	      return current_user[attr];
	    });
	    for (idx = i = 0, len = reduced_user.length; i < len; idx = ++i) {
	      el = reduced_user[idx];
	      if (!last_values._last_current_user || el !== last_values._last_current_user[idx]) {
	        return true;
	      }
	    }
	    return false;
	  }
	};

	AccessDenied = function() {
	  var user;
	  user = fetch('/current_user');
	  return DIV({
	    style: {
	      position: 'relative',
	      padding: 50
	    }
	  }, ProfileMenu(), DIV({
	    style: {
	      width: HOMEPAGE_WIDTH(),
	      margin: 'auto',
	      padding: '50px 100px',
	      backgroundColor: focus_color(),
	      color: 'white',
	      fontSize: 22
	    }
	  }, H1({
	    style: {
	      fontSize: 36,
	      color: 'white',
	      paddingBottom: 40
	    }
	  }, "We're sorry, but " + user.email + " doesn't have access to this private forum."), DIV(null, "If you think you should have access, please contact the person who invited you. \nSometimes they will have granted access to a different email address. You will \neither have to create an account using that other email address, or the forum \nadministrator will have to grant this email address access."), DIV({
	    style: {
	      marginTop: 40
	    }
	  }, "Contact us at ", A({
	    href: 'mailto:support@consider.it?subject=I am having trouble accessing a private forum',
	    style: {
	      textDecoration: 'underline'
	    }
	  }, 'support@consider.it'), " if you need help.")));
	};

	window.AccessControlled = AccessControlled;

	window.permit = permit;

	window.Permission = Permission;

	window.AccessDenied = AccessDenied;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var forms;

	window.Contact = ReactiveComponent({
	  displayName: 'Contact',
	  render: function() {
	    return DIV(null, this.heading(), this.form_chooser(), this.form(), this.letter());
	  },
	  heading: function() {
	    return DIV({
	      style: {
	        paddingTop: 40,
	        width: SAAS_PAGE_WIDTH(),
	        margin: 'auto',
	        textAlign: 'center'
	      }
	    }, H1({
	      style: {
	        fontSize: 50,
	        fontWeight: 800,
	        color: 'white',
	        textShadow: '0px 2px 4px rgba(0,0,0,.2)'
	      }
	    }, "Hi friend, how can we help?"), DIV({
	      style: {
	        fontSize: 18,
	        color: 'white',
	        marginTop: 8
	      }
	    }, 'Please introduce yourself, we’d be delighted to hear from you.'));
	  },
	  form_chooser: function() {
	    var base, form, i, idx, len, loc, n, set_form;
	    set_form = (function(_this) {
	      return function() {
	        var loc;
	        loc = fetch('location');
	        loc.query_params.form = forms[_this.local.current_form].id;
	        return save(loc);
	      };
	    })(this);
	    if (this.local.current_form == null) {
	      loc = fetch('location');
	      if (loc.query_params.form) {
	        for (idx = i = 0, len = forms.length; i < len; idx = ++i) {
	          form = forms[idx];
	          if (form.id === loc.query_params.form) {
	            this.local.current_form = idx;
	            break;
	          }
	        }
	      }
	      (base = this.local).current_form || (base.current_form = 0);
	    }
	    return DIV({
	      style: {
	        position: 'relative',
	        textAlign: 'center',
	        top: 40
	      }
	    }, SELECT({
	      className: 'unstyled',
	      style: {
	        fontSize: 24,
	        padding: '28px 40px',
	        fontWeight: 400,
	        backgroundSize: '24px 20px',
	        backgroundColor: 'white',
	        border: '1px solid #979797',
	        borderRadius: 32
	      },
	      value: this.local.current_form,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.current_form = e.target.value;
	          save(_this.local);
	          set_form();
	          return document.activeElement.blur();
	        };
	      })(this)
	    }, (function() {
	      var j, len1, results;
	      results = [];
	      for (idx = j = 0, len1 = forms.length; j < len1; idx = ++j) {
	        n = forms[idx];
	        results.push(OPTION({
	          value: idx,
	          style: {}
	        }, n.question));
	      }
	      return results;
	    })()));
	  },
	  form: function() {
	    var current_form, error, field, submit_click;
	    current_form = forms[this.local.current_form];
	    submit_click = (function(_this) {
	      return function(e) {
	        var c, i, len, p, ref;
	        e.preventDefault();
	        c = {
	          key: '/new/contact_us'
	        };
	        ref = _this.refs.form.getDOMNode().elements;
	        for (i = 0, len = ref.length; i < len; i++) {
	          p = ref[i];
	          if (p.name.length > 0) {
	            c[p.name] = p.value;
	          }
	        }
	        _this.local.errors = null;
	        _this.local.successful = null;
	        return save(c, function(resp) {
	          if (c.errors.length > 0) {
	            _this.local.errors = c.errors;
	          } else {
	            _this.local.successful = true;
	          }
	          return save(_this.local);
	        });
	      };
	    })(this);
	    return DIV({
	      style: {
	        paddingTop: 80,
	        paddingBottom: 300,
	        backgroundColor: '#F4F4F4'
	      }
	    }, DIV({
	      style: {
	        backgroundColor: 'white',
	        maxWidth: 500,
	        margin: 'auto',
	        padding: '40px 60px',
	        boxShadow: '0 1px 2px rgba(0,0,0,.2)'
	      }
	    }, FORM({
	      action: '/contact_us',
	      method: 'post',
	      ref: 'form'
	    }, (function() {
	      var i, len, ref, results;
	      ref = current_form.fields;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        field = ref[i];
	        results.push(DIV({
	          style: {
	            paddingBottom: 24
	          }
	        }, LABEL({
	          style: {
	            fontSize: 22,
	            display: 'block',
	            paddingBottom: 2
	          },
	          htmlFor: slugify(field.label)
	        }, field.label), field.form ? field.form() : field.tag({
	          name: slugify(field.label),
	          id: slugify(field.label),
	          required: !field.optional ? true : void 0,
	          style: {
	            width: '100%',
	            fontSize: 22,
	            padding: '4px 8px',
	            border: '1px solid #ddd',
	            height: field.tag === TEXTAREA ? 100 : void 0,
	            resize: field.tag === TEXTAREA ? 'vertical' : void 0
	          }
	        }), !field.optional ? DIV({
	          style: {
	            fontSize: 10,
	            color: '#777'
	          }
	        }, 'required') : void 0));
	      }
	      return results;
	    })(), DIV({
	      style: {
	        position: 'relative',
	        top: 20,
	        textAlign: 'center'
	      }
	    }, INPUT({
	      type: 'hidden',
	      name: 'inquiry',
	      value: current_form.question
	    }), (function() {
	      var i, len, ref, results;
	      if (this.local.errors) {
	        ref = this.local.errors;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          error = ref[i];
	          results.push(DIV({
	            style: {
	              color: 'red',
	              fontSize: 14,
	              paddingTop: 20
	            }
	          }, error));
	        }
	        return results;
	      }
	    }).call(this), this.local.successful ? DIV({
	      style: {
	        backgroundColor: primary_color(),
	        color: 'white',
	        fontSize: 18,
	        padding: 20
	      }
	    }, 'Thank you for your message. We will be in touch.') : BUTTON({
	      style: _.extend({}, big_button(), {
	        width: '100%'
	      }),
	      onClick: submit_click,
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            return submit_click(e);
	          }
	        };
	      })(this)
	    }, 'Deliver to Consider.it')))));
	  },
	  letter: function() {
	    var full, height, width;
	    height = 390 * SAAS_PAGE_WIDTH() / 1160;
	    width = 1160 * SAAS_PAGE_WIDTH() / 1160;
	    full = SAAS_PAGE_WIDTH() > 960 && !browser.is_mobile;
	    return DIV({
	      style: {
	        backgroundColor: 'white'
	      }
	    }, DIV({
	      style: {
	        position: 'relative',
	        top: -height / 2,
	        backgroundColor: 'white',
	        margin: 'auto',
	        width: width,
	        height: full ? height : void 0,
	        boxShadow: '0 1px 3px rgba(0,0,0,.4)',
	        textAlign: !full ? 'center' : void 0,
	        padding: !full ? '40px 40px' : void 0
	      }
	    }, DIV({
	      style: {
	        position: full ? 'absolute' : void 0,
	        left: 50,
	        top: 30,
	        fontSize: 24,
	        fontWeight: 600,
	        color: !full ? primary_color() : void 0
	      }
	    }, 'Shy about filling out a form? ', full ? BR(null) : void 0, 'Mail us a nice letter instead!'), DIV({
	      style: css.crossbrowserify({
	        position: full ? 'absolute' : void 0,
	        left: '25%',
	        top: '40%',
	        paddingTop: !full ? 50 : void 0,
	        fontSize: 24,
	        fontWeight: 600,
	        display: 'flex',
	        flexDirection: !full ? 'column' : void 0
	      })
	    }, DIV({
	      style: css.crossbrowserify({
	        flex: '1 1 auto'
	      })
	    }, DIV({
	      style: {}
	    }, 'Deliver Electronically'), A({
	      href: 'mailto:hello@consider.it',
	      style: {
	        textDecoration: 'underline',
	        fontWeight: 400,
	        fontSize: full ? 22 : 16
	      }
	    }, 'hello@consider.it')), DIV({
	      style: css.crossbrowserify({
	        flex: '1 1 auto',
	        padding: 20,
	        fontWeight: 400
	      })
	    }, 'or'), DIV({
	      style: css.crossbrowserify({
	        flex: '1 1 auto',
	        padding: '0px 20px'
	      })
	    }, DIV({
	      style: {}
	    }, 'via Postal Service'), DIV({
	      style: {
	        fontWeight: 400,
	        fontSize: full ? 22 : 16
	      }
	    }, 'Consider.it', BR(null), '2420 NE Sandy Blvd', BR(null), 'Suite 126', BR(null), 'Portland, OR 97232'))), full ? DIV({
	      style: {
	        position: 'absolute',
	        right: 20,
	        top: 16
	      }
	    }, IMG({
	      src: asset('product_page/wwstamp.png'),
	      width: SAAS_PAGE_WIDTH() * 84 / 1160,
	      height: SAAS_PAGE_WIDTH() * 132 / 1160
	    })) : void 0));
	  }
	});

	forms = [
	  {
	    id: 'general_inquiry',
	    question: "General inquiry",
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT
	      }, {
	        label: 'Your email',
	        tag: INPUT
	      }, {
	        label: 'Your organization',
	        tag: INPUT
	      }, {
	        label: 'What can we help you with?',
	        tag: TEXTAREA
	      }
	    ]
	  }, {
	    id: 'request_demo',
	    question: "Let's schedule a demo",
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT
	      }, {
	        label: 'Your email',
	        tag: INPUT
	      }, {
	        label: 'Your organization',
	        tag: INPUT
	      }, {
	        label: 'A basic description of your goal for a dialogue',
	        tag: TEXTAREA
	      }, {
	        label: 'How did you learn about Consider.it?',
	        tag: TEXTAREA,
	        optional: true
	      }
	    ]
	  }, {
	    id: 'consulting_inquiry',
	    question: 'Will your consulting services help my project?',
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT
	      }, {
	        label: 'Your email',
	        tag: INPUT
	      }, {
	        label: 'Your organization',
	        tag: INPUT
	      }, {
	        label: 'Describe your project',
	        tag: TEXTAREA
	      }, {
	        label: 'Approximate budget',
	        tag: INPUT,
	        optional: true
	      }, {
	        label: 'How did you learn about Consider.it?',
	        tag: TEXTAREA,
	        optional: true
	      }
	    ]
	  }, {
	    id: 'consultant_partnership',
	    question: "I'm interested in the consultant partnership",
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT
	      }, {
	        label: 'Your email',
	        tag: INPUT
	      }, {
	        label: 'Your organization',
	        tag: INPUT
	      }, {
	        label: 'Describe your practice',
	        tag: TEXTAREA,
	        optional: true
	      }, {
	        label: 'How did you learn about Consider.it?',
	        tag: TEXTAREA,
	        optional: true
	      }
	    ]
	  }, {
	    id: 'upgrade_to_unlimited',
	    question: 'I\'d like to upgrade to an Unlimited Forum',
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT
	      }, {
	        label: 'Your email',
	        tag: INPUT
	      }, {
	        label: 'The Consider.it forum you\'re upgrading',
	        form: function() {
	          var url_hint;
	          url_hint = {
	            color: '#aaa'
	          };
	          return DIV(null, SPAN({
	            style: url_hint
	          }, 'https://'), INPUT({
	            type: 'text',
	            name: slugify(this.label),
	            id: slugify(this.label),
	            style: {
	              fontSize: 16,
	              padding: '4px 8px',
	              border: '1px solid #ddd'
	            }
	          }), SPAN({
	            style: url_hint
	          }, '.consider.it'));
	        }
	      }
	    ]
	  }, {
	    id: 'start_enterprise',
	    question: "My organization is interested in the Enterprise plan",
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT
	      }, {
	        label: 'Your email',
	        tag: INPUT
	      }, {
	        label: 'Your organization',
	        tag: INPUT
	      }
	    ]
	  }, {
	    id: 'discount',
	    question: "My project could use a discount...",
	    fields: [
	      {
	        label: 'Your name',
	        tag: INPUT
	      }, {
	        label: 'Your email',
	        tag: INPUT
	      }, {
	        label: 'Your organization',
	        tag: INPUT
	      }, {
	        label: 'Why should your community\'s forum get a discount?',
	        tag: TEXTAREA
	      }, {
	        label: 'Approximate budget',
	        tag: INPUT
	      }, {
	        label: 'What do you need that the Free Forum does not provide?',
	        tag: TEXTAREA
	      }, {
	        label: 'How did you learn about Consider.it?',
	        tag: TEXTAREA,
	        optional: true
	      }
	    ]
	  }
	];


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	window.CustomerSignup = ReactiveComponent({
	  displayName: 'CustomerSignup',
	  render: function() {
	    var auth, compact, current_user, domain_hint, error, loc;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (!current_user.logged_in && !auth.form) {
	      auth.form = 'create account';
	      save(auth);
	    }
	    domain_hint = {
	      color: 'white',
	      fontSize: 28,
	      padding: '0 2px'
	    };
	    compact = browser.is_mobile || SAAS_PAGE_WIDTH() < 800;
	    loc = fetch('location');
	    if (loc.query_params.error) {
	      this.local.errors = [decodeURIComponent(loc.query_params.error)];
	      save(this.local);
	      delete loc.query_params.error;
	      save(loc);
	    }
	    return DIV(null, current_user.logged_in ? FORM({
	      action: '/subdomain',
	      method: 'POST'
	    }, DIV({
	      style: {
	        paddingTop: 40,
	        paddingBottom: 60,
	        width: SAAS_PAGE_WIDTH(),
	        margin: 'auto',
	        fontSize: compact ? 34 : 50,
	        color: 'white',
	        textAlign: 'center',
	        fontWeight: 800,
	        textShadow: '0px 2px 4px rgba(0,0,0,.2)'
	      }
	    }, 'Give your Free Forum a name', DIV({
	      style: {
	        paddingBottom: 10
	      }
	    }, SPAN({
	      style: domain_hint
	    }, 'https://'), INPUT({
	      type: 'text',
	      name: 'subdomain',
	      ref: 'subdomain_name',
	      style: {
	        border: "1px solid #2a70a2",
	        padding: '8px 16px',
	        fontSize: 20
	      }
	    }), SPAN({
	      style: domain_hint
	    }, '.consider.it')), DIV({
	      style: {
	        fontSize: 14,
	        color: 'rgba(255,255,255,.6)',
	        marginTop: 8,
	        textShadow: 'none',
	        fontWeight: 400
	      }
	    }, 'You can upgrade later if you want an Unlimited Forum.')), DIV({
	      style: {
	        backgroundColor: 'white',
	        textAlign: 'center',
	        borderTop: "1px solid '#666'"
	      }
	    }, INPUT({
	      type: 'hidden',
	      name: 'authenticity_token',
	      value: current_user.csrf
	    }), INPUT({
	      type: 'hidden',
	      name: 'plan',
	      plan: 0
	    }), INPUT({
	      type: 'submit',
	      disabled: !current_user.logged_in ? true : void 0,
	      style: _.extend({}, big_button(), {
	        opacity: !current_user.logged_in ? 0 : void 0,
	        backgroundColor: '#666',
	        cursor: !current_user.logged_in ? 'auto' : 'pointer',
	        position: 'relative',
	        top: -26
	      }),
	      value: 'Create my forum'
	    }), this.local.errors && this.local.errors.length > 0 ? DIV({
	      style: {
	        padding: 40,
	        backgroundColor: '#FFE2E2',
	        maxWidth: 500,
	        margin: 'auto'
	      }
	    }, H1({
	      style: {
	        fontSize: 18
	      }
	    }, 'Ooops!'), (function() {
	      var i, len, ref, results;
	      ref = this.local.errors;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        error = ref[i];
	        results.push(DIV({
	          style: {
	            marginTop: 10
	          }
	        }, error));
	      }
	      return results;
	    }).call(this)) : void 0)) : void 0, DIV({
	      style: {
	        padding: '0px 10px'
	      }
	    }, !current_user.logged_in ? DIV({
	      style: {
	        paddingBottom: 80
	      }
	    }, H1({
	      style: {
	        paddingTop: 40,
	        paddingBottom: 30,
	        width: SAAS_PAGE_WIDTH(),
	        margin: 'auto',
	        fontSize: compact ? 34 : 50,
	        color: 'white',
	        textAlign: 'center',
	        fontWeight: 800,
	        textShadow: '0px 2px 4px rgba(0,0,0,.2)'
	      }
	    }, 'Please introduce yourself first'), this.drawAuth()) : void 0, current_user.logged_in && current_user.is_super_admin ? A({
	      style: {
	        opacity: .1,
	        marginTop: 40
	      },
	      onClick: logout
	    }, 'Logout') : void 0));
	  },
	  componentDidMount: function() {
	    return this.refs.subdomain_name.getDOMNode().focus();
	  },
	  drawAuth: function() {
	    return Auth({
	      naked: true,
	      disable_cancel: true,
	      primary_color: primary_color()
	    });
	  },
	  drawCreateSubdomain: function() {
	    var current_user, domain_hint;
	    current_user = fetch('/current_user');
	    domain_hint = {
	      color: '#aaa',
	      fontSize: 20
	    };
	    return DIV({
	      style: {
	        margin: '30px auto',
	        width: DECISION_BOARD_WIDTH()
	      }
	    });
	  }
	});


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var DEMO_AUTOPLAY_DELAY, VIDEO_FILE, caption_color, chapters, current_chapter_color, exit_demo, hover_caption_color;

	VIDEO_FILE = 'slowdeathstarcam';

	chapters = [
	  {
	    time: 6.0,
	    caption: "Pretend we're considering this proposal",
	    menu: "Consider an issue"
	  }, {
	    time: 5.0,
	    caption: "Consider.it helps us analyze its tradeoffs",
	    menu: "Analyze tradeoffs"
	  }, {
	    time: 8.5,
	    caption: "Each thought becomes a Pro or Con point",
	    menu: "Analyze tradeoffs"
	  }, {
	    time: 7.0,
	    caption: "We can learn from our peers",
	    menu: "Learn from peers"
	  }, {
	    time: 4.0,
	    caption: "...and even build from them!",
	    menu: "Learn from peers"
	  }, {
	    time: 11.0,
	    caption: "Weigh the tradeoffs on a slider",
	    menu: "Slide overall opinion"
	  }, {
	    time: 4.5,
	    caption: "Now let's share our opinion",
	    menu: "Slide overall opinion"
	  }, {
	    time: 4.5,
	    caption: "Behold: what people think, and why!",
	    menu: "See what the group thinks"
	  }, {
	    time: 4.0,
	    caption: "A histogram shows the spectrum of opinions",
	    menu: "Spectrum of opinion"
	  }, {
	    time: 4.0,
	    caption: "Points are ranked by importance to the group",
	    menu: "Top tradeoffs"
	  }, {
	    time: 8.5,
	    caption: "Now explore patterns of thought!",
	    menu: "Explore patterns of thought"
	  }, {
	    time: 6.0,
	    caption: "Learn the reservations of opposers",
	    menu: "Explore patterns of thought"
	  }, {
	    time: 12.5,
	    caption: "Inspect a peer's opinion",
	    menu: "Inspect a peer’s opinion"
	  }, {
	    time: 8.0,
	    caption: "See who resonates with the top Pro",
	    menu: "Inspect a peer’s opinion"
	  }, {
	    time: 4.0,
	    caption: "Focus on a single point",
	    menu: "Focus & discuss a single point"
	  }, {
	    time: 11.0,
	    caption: "...and discuss its implications",
	    menu: "Focus & discuss a single point"
	  }, {
	    time: 0.0,
	    caption: "Those are the basics! Learn more below",
	    menu: "Focus & discuss a single point"
	  }
	];

	DEMO_AUTOPLAY_DELAY = 5000;

	hover_caption_color = primary_color();

	caption_color = "black";

	current_chapter_color = primary_color();

	exit_demo = function() {
	  var loc;
	  window.scrollTo(0, 0);
	  loc = fetch('location');
	  delete loc.query_params.play_demo;
	  return save(loc);
	};

	window.Video = ReactiveComponent({
	  displayName: "Video",
	  render: function() {
	    this.compact = browser.is_mobile || SAAS_PAGE_WIDTH() < 1000;
	    this.video_width = this.compact ? Math.min(SAAS_PAGE_WIDTH(), window.innerWidth) : Math.min(SAAS_PAGE_WIDTH(), window.innerWidth - 320);
	    return DIV({
	      id: 'demo',
	      style: {
	        position: 'relative',
	        backgroundColor: 'white',
	        minHeight: window.innerHeight,
	        paddingTop: 20
	      }
	    }, this.drawCaptions(), DIV({
	      style: {
	        paddingTop: 10
	      }
	    }, this.drawVideo(), !this.compact ? this.drawChapterMenu() : void 0), BUTTON({
	      style: {
	        position: 'absolute',
	        cursor: 'pointer',
	        right: 40,
	        top: 40,
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      onClick: exit_demo,
	      onKeyPress: function(e) {
	        if (e.which === 13 || e.which === 32) {
	          e.preventDefault();
	          return exit_demo();
	        }
	      }
	    }, SVG({
	      style: {
	        cursor: 'pointer'
	      },
	      viewBox: "0 0 64 64",
	      width: 24,
	      height: 24
	    }, PATH({
	      d: "M62,52c0,5.5-4.5,10-10,10H12C6.5,62,2,57.5,2,52V12C2,6.5,6.5,2,12,2h40c5.5,0,10,4.5,10,10V52z",
	      fill: seattle_salmon
	    }), PATH({
	      fill: "#fff",
	      d: "M50 21.2 42.8 14 32 24.8 21.2 14 14 21.2 24.8 32 14 42.8 21.2 50 32 39.2 42.8 50 50 42.8 39.2 32z"
	    }))));
	  },
	  drawVideo: function() {
	    var asset_path, format;
	    return VIDEO({
	      preload: "auto",
	      loop: true,
	      autoPlay: false,
	      ref: "video",
	      controls: this.props.playing,
	      style: {
	        position: 'relative',
	        width: this.video_width,
	        margin: 'auto',
	        left: !this.compact ? 160 : 10,
	        height: this.video_width * 1080 / 1920
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = ['mp4', 'webm'];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        format = ref[i];
	        asset_path = asset("product_page/" + VIDEO_FILE + "." + format);
	        if ((asset_path != null ? asset_path.length : void 0) > 0) {
	          results.push(SOURCE({
	            key: format,
	            src: asset_path,
	            type: "video/" + format
	          }));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    })());
	  },
	  drawCaptions: function() {
	    var chapter;
	    chapter = fetch("video_chapter");
	    return DIV({
	      style: _.extend({}, h1, {
	        fontWeight: 400,
	        whiteSpace: 'nowrap',
	        paddingBottom: 5,
	        position: 'relative',
	        zIndex: 1,
	        width: this.video_width - 1,
	        textAlign: 'center',
	        left: this.compact ? 10 : 140,
	        fontSize: !this.compact ? h1.fontSize : 24
	      })
	    }, DIV({
	      style: {
	        height: 70,
	        color: this.props.playing ? primary_color() : void 0
	      }
	    }, chapter.caption), SVG({
	      height: 10,
	      width: 60,
	      style: {
	        position: 'absolute',
	        left: '50%',
	        marginLeft: -60 / 2,
	        bottom: -0
	      }
	    }, POLYGON({
	      points: "0,0 30,10 60,0",
	      fill: primary_color()
	    }), POLYGON({
	      points: "0,-1 30,9 60,-1",
	      fill: 'white'
	    })));
	  },
	  drawChapterMenu: function() {
	    var chapter, current_chapter, idx, menu;
	    current_chapter = fetch("video_chapter");
	    return UL({
	      style: {
	        position: 'absolute',
	        top: 100,
	        left: 5,
	        listStyle: 'none',
	        width: 120,
	        textAlign: 'right'
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = _.uniq((function() {
	        var j, len, results1;
	        results1 = [];
	        for (j = 0, len = chapters.length; j < len; j++) {
	          chapter = chapters[j];
	          results1.push(chapter.menu);
	        }
	        return results1;
	      })());
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        menu = ref[idx];
	        results.push((function(_this) {
	          return function(menu) {
	            var highlighted;
	            highlighted = menu === current_chapter.menu;
	            return LI({
	              key: idx,
	              onMouseEnter: function() {
	                _this.local.hover_chapter = menu;
	                return save(_this.local);
	              },
	              onMouseLeave: function() {
	                _this.local.hover_chapter = null;
	                return save(_this.local);
	              },
	              onClick: function() {
	                var c, chapter_time, controls, j, len1, new_chapter, v;
	                v = _this.refs.video.getDOMNode();
	                chapter = fetch("video_chapter");
	                controls = fetch('video_controls');
	                chapter_time = 0;
	                new_chapter = null;
	                for (idx = j = 0, len1 = chapters.length; j < len1; idx = ++j) {
	                  c = chapters[idx];
	                  if (c.menu === menu) {
	                    new_chapter = c;
	                    break;
	                  }
	                  chapter_time += c.time;
	                }
	                v.currentTime = chapter_time;
	                controls.value = chapter_time / v.duration;
	                chapter.caption = new_chapter != null ? new_chapter.caption : void 0;
	                chapter.menu = new_chapter != null ? new_chapter.menu : void 0;
	                save(controls);
	                return save(chapter);
	              },
	              style: {
	                color: (highlighted || _this.local.hover_chapter === menu) ? current_chapter_color : 'black',
	                fontSize: 14,
	                fontWeight: highlighted ? 700 : 300,
	                padding: '10px 0',
	                cursor: 'pointer'
	              }
	            }, menu);
	          };
	        })(this)(menu));
	      }
	      return results;
	    }).call(this));
	  },
	  componentDidUpdate: function() {
	    return this.attachToVideo();
	  },
	  componentDidMount: function() {
	    this.attachToVideo();
	    return this.startVideo();
	  },
	  startVideo: function() {
	    var controls, e, video;
	    controls = fetch('video_controls');
	    controls.playing = true;
	    controls.value = 0;
	    try {
	      video = this.refs.video.getDOMNode();
	      video.currentTime = 0;
	      video.play();
	    } catch (error) {
	      e = error;
	      console.error(e);
	      setTimeout((function(_this) {
	        return function() {
	          return _this.startVideo();
	        };
	      })(this), 500);
	    }
	    this.local.ready = true;
	    this.local.playing = true;
	    save(controls);
	    return save(this.local);
	  },
	  attachToVideo: function() {
	    var v;
	    v = this.refs.video.getDOMNode();
	    if (this.v !== v) {
	      this.v = v;
	      return v.addEventListener('timeupdate', function(ev) {
	        var c, chapter, chapter_time, controls, i, idx, len, new_chapter;
	        chapter = fetch("video_chapter");
	        controls = fetch('video_controls');
	        chapter_time = 0;
	        for (idx = i = 0, len = chapters.length; i < len; idx = ++i) {
	          c = chapters[idx];
	          if (v.currentTime < chapter_time + c.time || idx === chapters.length - 1) {
	            new_chapter = c;
	            break;
	          }
	          chapter_time += c.time;
	        }
	        controls.value = v.currentTime / v.duration;
	        save(controls);
	        if (chapter.caption !== (new_chapter != null ? new_chapter.caption : void 0)) {
	          chapter.caption = new_chapter.caption;
	          chapter.menu = new_chapter.menu;
	          return save(chapter);
	        }
	      }, false);
	    }
	  }
	});


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var Example, ExampleTabs, cases, get_example, set_example;

	get_example = function() {
	  var id, loc, parts;
	  loc = fetch('location');
	  parts = loc.url.split('/');
	  id = parts.length < 3 ? 'seattle' : parts[parts.length - 1];
	  if (id === 'public_engagement') {
	    id = 'seattle';
	  } else if (id === 'strategic_planning') {
	    id = 'wsffn';
	  } else if (id === 'decentralized_decisions') {
	    id = 'dao';
	  }
	  return cases[id];
	};

	set_example = function(example) {
	  var loc;
	  loc = fetch('location');
	  loc.url = "/examples/" + (example["class"] || example.id);
	  return save(loc);
	};

	window.ExamplesPage = ReactiveComponent({
	  displayName: 'LandingPage',
	  render: function() {
	    var active_example;
	    active_example = get_example();
	    return DIV({
	      style: {
	        paddingTop: 60
	      }
	    }, ExampleTabs({
	      examples: [
	        {
	          "case": cases.seattle,
	          label: 'Public Engagement'
	        }, {
	          "case": cases.wsffn,
	          label: 'Strategic Planning'
	        }, {
	          "case": cases.dao,
	          label: 'Decentralized Decisions'
	        }
	      ]
	    }), Example({
	      "case": active_example
	    }));
	  },
	  heading: function() {
	    return DIV({
	      style: {
	        paddingTop: 40,
	        width: SAAS_PAGE_WIDTH(),
	        margin: 'auto',
	        textAlign: 'center'
	      }
	    }, H1({
	      style: {
	        fontSize: 50,
	        fontWeight: 800,
	        color: 'white',
	        textShadow: '0px 2px 4px rgba(0,0,0,.2)'
	      }
	    }, "What is your need for a dialogue?"));
	  }
	});

	ExampleTabs = ReactiveComponent({
	  displayName: 'ExampleTabs',
	  render: function() {
	    var active_example, example, examples;
	    active_example = get_example();
	    examples = this.props.examples;
	    return DIV({
	      style: {
	        width: '100%',
	        zIndex: 2,
	        position: 'relative',
	        top: 2
	      }
	    }, UL({
	      role: 'tablist',
	      style: {
	        width: SAAS_PAGE_WIDTH(),
	        margin: 'auto',
	        textAlign: 'left',
	        listStyle: 'none'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = examples.length; i < len; i++) {
	        example = examples[i];
	        results.push((function(_this) {
	          return function(example) {
	            var current;
	            current = example["case"] === active_example;
	            return LI({
	              tabIndex: 0,
	              role: 'tab',
	              style: {
	                display: 'inline-block',
	                opacity: !current ? 0.3 : void 0,
	                fontSize: 24,
	                fontWeight: 700,
	                padding: '6px 24px 4px 24px',
	                color: 'white',
	                cursor: 'pointer',
	                fontStyle: 'oblique',
	                position: 'relative',
	                backgroundColor: current ? example["case"].color : void 0
	              },
	              'aria-controls': 'active_example',
	              'aria-selected': current,
	              onMouseEnter: function() {
	                if (get_example() !== example["case"].id) {
	                  _this.local.hovering = example["case"];
	                  return save(_this.local);
	                }
	              },
	              onMouseLeave: function() {
	                _this.local.hovering = null;
	                return save(_this.local);
	              },
	              onKeyDown: function(e) {
	                if (e.which === 13 || e.which === 32) {
	                  e.currentTarget.click();
	                  return e.preventDefault();
	                }
	              },
	              onClick: function() {
	                set_example(example["case"]);
	                return document.activeElement.blur();
	              }
	            }, example.label);
	          };
	        })(this)(example));
	      }
	      return results;
	    }).call(this)));
	  }
	});

	Example = ReactiveComponent({
	  displayName: 'Example',
	  render: function() {
	    var compact, ex, link, m;
	    ex = this.props["case"];
	    compact = browser.is_mobile || SAAS_PAGE_WIDTH() < 970;
	    return DIV({
	      id: 'active_example',
	      style: {
	        position: 'relative',
	        paddingBottom: 80,
	        background: ex.background
	      }
	    }, A({
	      name: ex.id
	    }), DIV({
	      style: {
	        width: SAAS_PAGE_WIDTH(),
	        margin: 'auto',
	        position: 'relative',
	        zIndex: 1,
	        paddingTop: 36
	      }
	    }, H2({
	      style: {
	        fontSize: compact ? 38 : 50,
	        fontWeight: 800,
	        color: 'white',
	        paddingBottom: 20,
	        textShadow: '0px 2px 4px rgba(0,0,0,.2)',
	        fontStyle: 'oblique'
	      }
	    }, ex.heading), DIV({
	      style: css.crossbrowserify({
	        display: 'flex',
	        flexDirection: compact ? 'column' : void 0,
	        paddingTop: 20
	      })
	    }, DIV({
	      style: {
	        flex: 0,
	        paddingTop: 24,
	        color: 'white'
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = ex.metrics;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        m = ref[i];
	        results.push(DIV({
	          style: {
	            textAlign: 'center',
	            marginBottom: 36,
	            display: compact ? 'inline-block' : void 0,
	            paddingRight: compact ? 40 : void 0
	          }
	        }, DIV({
	          style: {
	            fontSize: 36,
	            lineHeight: 1,
	            fontWeight: 600
	          }
	        }, m.quantity), DIV({
	          style: {
	            fontSize: 14,
	            fontWeight: 500,
	            whiteSpace: 'nowrap'
	          }
	        }, m.metric)));
	      }
	      return results;
	    })()), DIV({
	      style: {
	        flex: 1,
	        marginLeft: !compact ? 60 : void 0,
	        width: SAAS_PAGE_WIDTH() - (compact ? 0 : 60 + 120)
	      }
	    }, DIV({
	      style: {
	        marginTop: 0
	      }
	    }, A({
	      href: ex.browser_loc,
	      target: '_blank'
	    }, ex.screen(SAAS_PAGE_WIDTH() - (compact ? 0 : 60 + 120)))))), DIV({
	      style: {
	        fontSize: 36,
	        color: 'white'
	      }
	    }, 'Details:'), DIV({
	      style: {
	        paddingTop: 6
	      }
	    }, DIV({
	      style: {
	        backgroundColor: 'white',
	        boxShadow: '0 1px 2px rgba(0,0,0,.2)',
	        padding: '20px 40px'
	      }
	    }, H3({
	      style: {
	        fontSize: 36,
	        fontWeight: 400,
	        paddingBottom: 36
	      }
	    }, ex.extra_heading), DIV({
	      style: css.crossbrowserify({
	        display: 'flex'
	      })
	    }, DIV({
	      style: {
	        flex: 1,
	        maxWidth: 600,
	        paddingRight: 40
	      }
	    }, DIV({
	      className: 'embedded',
	      dangerouslySetInnerHTML: {
	        __html: ex.story
	      }
	    }), DIV({
	      style: {
	        marginTop: 20
	      }
	    }, "Explore at", ex.links.length === 1 ? [
	      ' ', A({
	        href: ex.links[0],
	        target: '_blank',
	        style: {
	          textDecoration: 'underline'
	        }
	      }, ex.links[0]), ex === cases.wsffn ? DIV({
	        style: {
	          fontStyle: 'italic'
	        }
	      }, '(their board-only forum is private)') : void 0
	    ] : [
	      ':', UL({
	        style: {
	          listStyle: 'none'
	        }
	      }, (function() {
	        var i, len, ref, results;
	        ref = ex.links;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          link = ref[i];
	          results.push(LI({
	            style: {}
	          }, A({
	            href: link,
	            target: '_blank',
	            style: {
	              textDecoration: 'underline',
	              color: '#007BC6',
	              fontWeight: 500
	            }
	          }, link)));
	        }
	        return results;
	      })())
	    ])), DIV({
	      style: {
	        flex: 1,
	        position: 'relative',
	        top: -32
	      }
	    }, TestimonialGrid({
	      testimonials: [ex.testimonial],
	      top: true,
	      italic: true,
	      hide_full: true
	    })))))));
	  }
	});

	cases = {};

	cases.seattle = {
	  id: 'seattle',
	  "class": 'public_engagement',
	  color: '#B4589D',
	  background: '#B4589D',
	  heading: 'City of Seattle uses Consider.it to transform public controversy into productive discussion',
	  example_text: '<b>City of Seattle</b> uses Consider.it to engage residents about its affordable housing crisis',
	  browser_loc: 'https://seattle2035.consider.it/Housing',
	  screen: function(width) {
	    return Webframe({
	      browser_loc: cases.seattle.browser_loc,
	      width: width
	    }, DIV({
	      style: {
	        width: '90%',
	        margin: 'auto'
	      }
	    }, DIV({
	      style: {
	        fontSize: 36,
	        fontWeight: 500,
	        margin: '30px 0 0px 0',
	        textAlign: 'center'
	      }
	    }, 'Increase the diversity of housing types in lower density residential zones'), IMG({
	      src: asset('product_page/seattle_example.png'),
	      style: {
	        width: '100%',
	        display: 'block'
	      }
	    })));
	  },
	  metrics: [
	    {
	      quantity: '8,000+',
	      metric: 'opinions given'
	    }, {
	      quantity: '1,500+',
	      metric: 'comments'
	    }, {
	      quantity: '0',
	      metric: 'personal attacks'
	    }
	  ],
	  more_callout: 'about Seattle cases',
	  extra_heading: 'Organized and civil public dialogue on contentious issues.',
	  story: "<p>Seattle is booming. Affordable housing is vanishing.</p>\n<p>Seattle Mayor Ed Murray launched an <a href='http://hala.seattle.gov'>ambitious plan</a> to dramatically increase the supply of affordable housing.</p>\n<p>Consider.it is helping the City of Seattle engage local residents in developing the plan. Every resident has the opportunity to provide feedback on how the plan will impact them.</p>\n<p>The structure of the Consider.it forum has encouraged civil dialogue. Neighbors are learning from each other. Neighbors are participating in building a better city. The feedback City staff receive is higher quality than other online sources, and many public meetings.</p>",
	  links: ['https://hala.consider.it', 'https://seattle2035.consider.it', 'https://engageseattle.consider.it'],
	  testimonial: testimonials.susie
	};

	cases.wsffn = {
	  id: 'wsffn',
	  "class": 'strategic_planning',
	  background: 'linear-gradient(143deg, #9BA43D 35%, #7D8928 100%)',
	  color: '#9BA43D',
	  heading: 'Statewide farming non-profit makes strategic plan for ~15% the cost of a traditional process',
	  example_text: 'statewide non-profit made strategic plan for ~15% the cost of a traditional process',
	  browser_loc: 'https://wsffn.consider.it',
	  screen: function(width) {
	    return Webframe({
	      browser_loc: cases.wsffn.browser_loc,
	      width: width
	    }, DIV({
	      style: {
	        width: '90%',
	        margin: 'auto'
	      }
	    }, IMG({
	      src: asset('product_page/wsffn_example.png'),
	      style: {
	        width: '100%',
	        display: 'block'
	      }
	    })));
	  },
	  metrics: [
	    {
	      quantity: '40',
	      metric: 'stakeholders'
	    }, {
	      quantity: '$6k',
	      metric: 'tech + consulting'
	    }, {
	      quantity: '1',
	      metric: 'adopted plan'
	    }
	  ],
	  more_callout: 'about this case',
	  extra_heading: 'Lightweight strategic planning on a tight budget.',
	  story: "<p>Russ Lehman had a problem. He had just been hired as the director of the Washington Sustainable Food and Farming Network. WSFFN needed a new strategic plan, including a new name. And he needed to engage his members across the state in vetting and ultimately supporting the changes. All on a shoe-string budget.</p>\n<p>Russ set up a Consider.it forum and gathered feedback on the core points of the new plan over several weeks. Russ could now see at a glance points of agreement amongst stakeholders, as well as sticking points that he'd have to navigate.</p>\n<p>With newfound confidence, Russ drafted a full plan and proposed it to the board via a private Consider.it forum. The board used Consider.it to refine and ultimately adopt the new plan. Now they are using Consider.it to identify a new organization name.</p> \n<p>Consider.it helped get the organization pointed in the same direction and helped all stakeholders feel they were heard.</p>\n<p><b>Total cost</b>: $1.2k for a Consider.it <a href=\"/pricing\">Unlimited Forum</a>, plus $5k for <a href=\"/pricing#consulting\">additional consulting</a>.</p>",
	  links: ['https://wsffn.consider.it'],
	  testimonial: testimonials.russ
	};

	cases.dao = {
	  id: 'dao',
	  "class": 'decentralized_decisions',
	  background: 'linear-gradient(141deg, #348AC7 35%, #7474BF 100%)',
	  color: '#348AC7',
	  heading: 'Worldwide decentralized network deliberates how to spend $150m',
	  example_text: 'Worldwide decentralized internet community deliberated how to spend $150m',
	  browser_loc: 'https://dao.consider.it/temporary-moratorium-on-the-dao-security-issues',
	  screen: function(width) {
	    return Webframe({
	      browser_loc: cases.dao.browser_loc,
	      width: width
	    }, DIV({
	      style: {
	        width: '90%',
	        margin: 'auto'
	      }
	    }, DIV({
	      style: {
	        fontSize: 36,
	        fontWeight: 500,
	        margin: '30px 0 20px 0',
	        textAlign: 'center'
	      }
	    }, 'Temporary moratorium for security audit'), IMG({
	      src: asset('product_page/dao_example.png'),
	      style: {
	        width: '100%',
	        display: 'block'
	      }
	    })));
	  },
	  metrics: [
	    {
	      quantity: '10,000+',
	      metric: 'opinions given'
	    }, {
	      quantity: '1,500+',
	      metric: 'participants'
	    }, {
	      quantity: '400+',
	      metric: 'ideas deliberated'
	    }
	  ],
	  more_callout: 'about this case',
	  extra_heading: 'Make decisions amongst thousands, without hierarchy',
	  story: "<p>The DAO was a prominent attempt to create a decentralized cooperative organization existing entirely on the internet. It set records in raising $150m of crowdfunding from thousands of individuals.</p> \n<p>The DAO had many challenges to overcome as an unprecedented social experiment. The community adopted Consider.it to help address one of these problems: aggregating and gauging community support about (1) what to invest in and (2) how to self-govern. Consider.it delivered: it became the community's primary forum for deliberating ideas and gauging community sentiment. </p>\n<p>Unfortunately, a security flaw in The DAO itself ultimately undermined the project and the experiment came to an end.</p>",
	  links: ['https://dao.consider.it'],
	  testimonial: testimonials.auryn
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var address, copyright, helloemail, nav;

	window.Footer = ReactiveComponent({
	  displayName: 'Footer',
	  render: function() {
	    var draw_top_button, loc, mobile, ref, section, section_div, w;
	    loc = fetch('location');
	    w = SAAS_PAGE_WIDTH();
	    mobile = w < 830;
	    section_div = function(section) {
	      var link;
	      return DIV(null, H3({
	        style: {
	          fontSize: 18,
	          fontWeight: 500,
	          color: '#000',
	          marginBottom: 10
	        }
	      }, section.label), UL({
	        style: {
	          listStyle: 'none'
	        }
	      }, (function() {
	        var i, len, ref, results;
	        ref = section.links;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          link = ref[i];
	          results.push(LI({
	            style: {
	              marginBottom: 10
	            }
	          }, A({
	            href: link.link,
	            style: {
	              color: primary_color(),
	              textDecoration: 'underline',
	              fontSize: 16,
	              fontWeight: 500
	            }
	          }, link.label)));
	        }
	        return results;
	      })()));
	    };
	    draw_top_button = (ref = loc.url) !== '/create_forum' && ref !== '/';
	    return FOOTER({
	      ref: 'footer',
	      id: 'footer',
	      style: {
	        paddingTop: loc.url === '/' || loc.url.indexOf('/examples') > -1 ? 0 : 140,
	        backgroundColor: loc.url !== '/' && loc.url.indexOf('/examples') < 0 ? 'white' : void 0,
	        bottom: 0,
	        left: 0,
	        zIndex: 1,
	        width: '100%',
	        position: 'relative'
	      }
	    }, draw_top_button ? DIV({
	      style: {
	        textAlign: 'center',
	        position: 'absolute',
	        top: 20,
	        width: '100%'
	      }
	    }, BUTTON({
	      onClick: function() {
	        return scrollTo(0, 0);
	      },
	      onKeyPress: function(e) {
	        if (e.which === 13 || e.which === 32) {
	          e.preventDefault();
	          return scrollTo(0, 0);
	        }
	      },
	      style: {
	        backgroundColor: 'transparent',
	        border: 'none',
	        opacity: .7,
	        position: 'relative'
	      }
	    }, SVG({
	      viewBox: "0 0 64 16",
	      width: 64,
	      height: 16
	    }, G({
	      fill: "#4d5357"
	    }, PATH({
	      d: "m32 2l-16 16h10v15h12v-15h10z"
	    }))), SVG({
	      viewBox: "0 0 64 16",
	      width: 64,
	      height: 16,
	      style: {
	        position: 'absolute',
	        top: 7,
	        left: 6
	      }
	    }, G({
	      fill: "#ffffff"
	    }, PATH({
	      d: "m32 2l-16 16h10v15h12v-15h10z"
	    }))), DIV({
	      style: {
	        textAlign: 'center'
	      }
	    }, 'to top'))) : void 0, DIV({
	      style: {
	        paddingTop: 80,
	        backgroundColor: "#F4F4F4",
	        borderTop: "1px solid #" + 737373,
	        padding: '45px 0 15px 0',
	        position: 'relative',
	        zIndex: 3
	      }
	    }, DIV({
	      style: {
	        width: w,
	        margin: 'auto'
	      }
	    }, DIV({
	      style: {
	        position: 'relative',
	        margin: 'auto',
	        textAlign: 'center',
	        top: -70
	      }
	    }, loc.url !== '/create_forum' ? A({
	      href: '/create_forum',
	      style: _.extend({}, big_button(), {
	        backgroundColor: loc.url === '/' || loc.url.indexOf('/examples') > -1 ? '#717171' : primary_color(),
	        fontStyle: 'oblique',
	        width: 410
	      })
	    }, 'Start a free Consider.it Forum') : void 0, loc.url.indexOf('/examples') > -1 ? A({
	      href: '/contact?form=request_demo',
	      target: '_blank',
	      style: _.extend({}, big_button(), {
	        backgroundColor: '#717171',
	        marginLeft: 32,
	        fontStyle: 'oblique',
	        width: 410
	      })
	    }, 'Request a demo') : loc.url !== '/create_forum' && !mobile ? A({
	      href: 'https://galacticfederation.consider.it/Death_Star?results=true',
	      target: '_blank',
	      style: _.extend({}, big_button(), {
	        backgroundColor: '#717171',
	        marginLeft: 32,
	        fontStyle: 'oblique',
	        width: 410
	      })
	    }, 'Experiment with Consider.it') : void 0), loc.url !== '/' ? DIV({
	      style: {
	        marginBottom: 35
	      }
	    }, (function() {
	      var i, len, results;
	      if (mobile) {
	        results = [];
	        for (i = 0, len = nav.length; i < len; i++) {
	          section = nav[i];
	          results.push(DIV({
	            style: {
	              textAlign: 'center',
	              paddingBottom: 20
	            }
	          }, section_div(section)));
	        }
	        return results;
	      } else {
	        return TABLE({
	          style: {
	            margin: 'auto',
	            borderSpacing: '80px 0px',
	            borderCollapse: 'separate'
	          }
	        }, TR({
	          style: {}
	        }, (function() {
	          var j, len1, results1;
	          results1 = [];
	          for (j = 0, len1 = nav.length; j < len1; j++) {
	            section = nav[j];
	            results1.push(TD({
	              style: {
	                textAlign: 'right'
	              }
	            }, section_div(section)));
	          }
	          return results1;
	        })()));
	      }
	    })()) : void 0, DIV({
	      style: {
	        color: '#303030',
	        fontSize: 11,
	        textAlign: 'center',
	        marginTop: 30
	      }
	    }, mobile ? [
	      helloemail(), DIV({
	        style: {
	          paddingBottom: 10
	        }
	      }), address(), DIV({
	        style: {
	          paddingBottom: 10
	        }
	      }), copyright()
	    ] : [copyright(), helloemail(), address()]))));
	  },
	  sizeFooter: function() {
	    var f, height;
	    f = fetch('footer');
	    height = this.refs.footer.getDOMNode().offsetHeight;
	    if (height !== f.height) {
	      f.height = height;
	      return save(f);
	    }
	  },
	  componentDidMount: function() {
	    return this.sizeFooter();
	  },
	  componentDidUpdate: function() {
	    return this.sizeFooter();
	  }
	});

	nav = [
	  {
	    label: 'I want a forum for…',
	    links: [
	      {
	        label: 'Public Involvement',
	        link: '/examples/public_engagement'
	      }, {
	        label: 'Strategic Planning',
	        link: '/examples/strategic_planning'
	      }, {
	        label: 'Decentralized Organizing',
	        link: '/examples/decentralized_decisions'
	      }
	    ]
	  }, {
	    label: 'What is Consider.it?',
	    links: [
	      {
	        label: 'Feature Tour',
	        link: '/tour#features'
	      }, {
	        label: 'Video Demo',
	        link: '/tour?play_demo=true'
	      }, {
	        label: 'Research Findings',
	        link: '/tour#research'
	      }, {
	        label: 'Tech Questions',
	        link: '/pricing#faq'
	      }
	    ]
	  }, {
	    label: 'What will it cost?',
	    links: [
	      {
	        label: 'Pricing Tiers',
	        link: '/pricing'
	      }, {
	        label: 'Consulting Services',
	        link: '/pricing#consulting'
	      }, {
	        label: 'Testimonials',
	        link: '/pricing#testimonials'
	      }, {
	        label: 'Pricing Questions',
	        link: '/pricing#faq'
	      }
	    ]
	  }, {
	    label: 'Hello, friend!',
	    links: [
	      {
	        label: 'Contact Us',
	        link: '/contact'
	      }, {
	        label: 'Consultant Partnership',
	        link: '/pricing#partnership'
	      }, {
	        label: 'Request a demo',
	        link: '/contact?form=request_demo'
	      }
	    ]
	  }
	];

	copyright = function() {
	  return SPAN(null, DIV({
	    style: {
	      display: 'inline-block'
	    }
	  }, '© 2016 Consider.it. All rights reserved. '), A({
	    href: '/privacy_policy',
	    style: {
	      textDecoration: 'underline',
	      fontSize: 11
	    }
	  }, 'Privacy'), ' and ', A({
	    href: '/terms_of_service',
	    style: {
	      textDecoration: 'underline',
	      fontSize: 11
	    }
	  }, 'Terms'), '.');
	};

	helloemail = function() {
	  return A({
	    href: 'mailto:hello@consider.it',
	    style: {
	      margin: '0px 40px',
	      textDecoration: 'underline',
	      display: 'inline-block'
	    }
	  }, 'hello@consider.it');
	};

	address = function() {
	  return DIV({
	    style: {
	      display: 'inline-block'
	    }
	  }, '2420 NE Sandy Blvd, Suite 126 Portland, OR 97232');
	};


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var HamburgerMenu, menu_options, nav_links;

	menu_options = nav_links = [
	  {
	    href: '/examples',
	    label: 'Examples'
	  }, {
	    href: '/tour',
	    label: 'How it works'
	  }, {
	    href: '/pricing',
	    label: 'Pricing'
	  }, {
	    href: '/contact',
	    label: 'Contact'
	  }, {
	    href: '/create_forum',
	    label: 'Create a Forum'
	  }
	];

	window.Header = ReactiveComponent({
	  displayName: "Header",
	  render: function() {
	    var base, color, compact, current_user, dot_size, h, homepage, idx, loc, main_color, nav, w;
	    current_user = fetch("/current_user");
	    loc = fetch('location');
	    w = SAAS_PAGE_WIDTH();
	    h = 80;
	    compact = browser.is_mobile || w < 980;
	    if ((base = this.local).dot_x == null) {
	      base.dot_x = 0;
	    }
	    dot_size = 10;
	    homepage = loc.url === '/';
	    color = fetch('colors');
	    main_color = color.primary_color === 'white' ? seattle_salmon : 'white';
	    return HEADER({
	      style: {
	        position: "relative",
	        margin: "0 auto 5px auto"
	      }
	    }, DIV({
	      style: {
	        width: w,
	        margin: 'auto',
	        borderBottom: "1px solid " + main_color,
	        transition: 'border 500ms'
	      }
	    }, A({
	      ref: 'logo',
	      href: '/',
	      style: {
	        display: 'inline-block',
	        position: "relative",
	        top: 12
	      }
	    }, drawLogo({
	      height: h - 10,
	      main_text_color: main_color,
	      o_text_color: 'transparent',
	      box_shadow: true
	    })), SVG({
	      width: dot_size,
	      height: dot_size,
	      viewBox: "0 0 " + dot_size + " " + dot_size,
	      version: "1.1",
	      xmlns: "http://www.w3.org/2000/svg",
	      style: _.extend(css.crossbrowserify({
	        transition: 'left 500ms'
	      }), {
	        position: 'absolute',
	        left: this.local.dot_x - dot_size / 2,
	        zIndex: 2,
	        bottom: -dot_size / 2
	      })
	    }, G(null, CIRCLE({
	      style: {
	        transition: 'fill 500ms'
	      },
	      fill: main_color,
	      cx: dot_size / 2,
	      cy: dot_size / 2,
	      r: dot_size / 2
	    }))), DIV({
	      style: {
	        position: 'relative',
	        bottom: -39,
	        display: 'inline-block',
	        float: 'right'
	      }
	    }, (function() {
	      var i, len, results;
	      if (compact) {
	        return HamburgerMenu({
	          nav_links: nav_links
	        });
	      } else {
	        results = [];
	        for (idx = i = 0, len = nav_links.length; i < len; idx = ++i) {
	          nav = nav_links[idx];
	          results.push(A({
	            ref: nav.href,
	            key: idx,
	            style: _.extend({}, base_text, {
	              fontWeight: 500,
	              fontStyle: 'oblique',
	              textTransform: 'uppercase',
	              fontSize: 18,
	              color: main_color,
	              marginLeft: 25,
	              cursor: 'pointer',
	              border: '1px solid transparent',
	              borderColor: idx === nav_links.length - 1 ? main_color : void 0,
	              borderRadius: '8px 8px 0px 0',
	              borderBottom: 'none',
	              padding: idx === nav_links.length - 1 ? '14px 20px' : '14px 10px',
	              transition: 'border 500ms, color 500ms'
	            }),
	            href: nav.href
	          }, nav.label));
	        }
	        return results;
	      }
	    })())));
	  },
	  positionDot: function() {
	    var dot_x, link, rect, ref, ref1, url;
	    url = fetch('location').url;
	    if (url.indexOf('/examples') > -1) {
	      url = '/examples';
	    }
	    link = (ref = this.refs[url]) != null ? ref.getDOMNode() : void 0;
	    if (link) {
	      rect = link.getBoundingClientRect();
	      dot_x = rect.left + (rect.right - rect.left) / 2;
	    } else {
	      link = (ref1 = this.refs.logo) != null ? ref1.getDOMNode() : void 0;
	      rect = link.getBoundingClientRect();
	      dot_x = rect.right - 38;
	    }
	    if (dot_x !== this.local.dot_x) {
	      this.local.dot_x = dot_x;
	      return save(this.local);
	    }
	  },
	  componentDidMount: function() {
	    return this.positionDot();
	  },
	  componentDidUpdate: function() {
	    return this.positionDot();
	  }
	});

	HamburgerMenu = ReactiveComponent({
	  displayName: 'HamburgerMenu',
	  render: function() {
	    var close_menu, homepage, idx, link_color, main_color, option, set_focus;
	    set_focus = (function(_this) {
	      return function(idx) {
	        if (idx == null) {
	          idx = 0;
	        }
	        _this.local.focus = idx;
	        save(_this.local);
	        return setTimeout(function() {
	          return _this.refs["menuitem-" + idx].getDOMNode().focus();
	        }, 0);
	      };
	    })(this);
	    close_menu = (function(_this) {
	      return function() {
	        document.activeElement.blur();
	        _this.local.menu = false;
	        return save(_this.local);
	      };
	    })(this);
	    homepage = false;
	    main_color = homepage ? seattle_salmon : 'white';
	    link_color = homepage ? seattle_salmon : primary_color();
	    return DIV({
	      key: 'hamburger',
	      ref: 'menu_wrap',
	      style: {
	        position: 'relative'
	      },
	      onTouchEnd: (function(_this) {
	        return function() {
	          _this.local.menu = !_this.local.menu;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseEnter: (function(_this) {
	        return function(e) {
	          _this.local.menu = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: close_menu,
	      onBlur: (function(_this) {
	        return function(e) {
	          return setTimeout(function() {
	            if ($(document.activeElement).closest(_this.refs.menu_wrap.getDOMNode()).length === 0) {
	              _this.local.menu = false;
	              return save(_this.local);
	            }
	          }, 0);
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32 || e.which === 27) {
	            close_menu();
	            return e.preventDefault();
	          } else if (e.which === 38 || e.which === 40) {
	            if (_this.local.focus == null) {
	              _this.local.focus = -1;
	            }
	            if (e.which === 38) {
	              _this.local.focus--;
	              if (_this.local.focus < 0) {
	                _this.local.focus = menu_options.length;
	              }
	            } else {
	              _this.local.focus++;
	              if (_this.local.focus > menu_options.length) {
	                _this.local.focus = 0;
	              }
	            }
	            set_focus(_this.local.focus);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, BUTTON({
	      tabIndex: 0,
	      'aria-haspopup': "true",
	      'aria-owns': "hamburger_popup",
	      style: {
	        border: "1px solid " + main_color,
	        borderBottom: 'none',
	        borderRadius: '8px 8px 0px 0',
	        padding: '0px 6px',
	        position: 'relative',
	        top: -13,
	        backgroundColor: 'transparent'
	      },
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            _this.local.menu = true;
	            save(_this.local);
	            if (_this.local.focus == null) {
	              set_focus(0);
	            }
	            e.preventDefault();
	            return e.stopPropagation();
	          }
	        };
	      })(this)
	    }, SVG({
	      height: 44,
	      viewBox: "0 0 32 24",
	      width: 44
	    }, PATH({
	      fill: main_color,
	      d: "M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
	    }))), UL({
	      id: 'hamburger_popup',
	      role: "menu",
	      'aria-hidden': !this.local.menu,
	      hidden: !this.local.menu,
	      style: {
	        listStyle: 'none',
	        position: 'absolute',
	        left: 'auto',
	        right: !this.local.menu ? -9999 : 8,
	        margin: '-10px 0 0 -8px',
	        padding: "16px 14px 8px 8px",
	        backgroundColor: 'white',
	        textAlign: 'right',
	        zIndex: 999999,
	        boxShadow: '0 1px 2px rgba(0,0,0,.2)'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = menu_options.length; i < len; idx = ++i) {
	        option = menu_options[idx];
	        results.push(LI({
	          key: option.label,
	          role: "presentation"
	        }, A({
	          ref: "menuitem-" + idx,
	          role: "menuitem",
	          tabIndex: this.local.focus === idx ? 0 : -1,
	          href: option.href,
	          key: option.href,
	          style: {
	            color: this.local.focus === idx ? link_color : '#303030',
	            outline: 'none',
	            position: 'relative',
	            bottom: 8,
	            padding: '10px 0 10px 27px',
	            display: 'block',
	            whiteSpace: 'nowrap',
	            fontSize: 30,
	            borderBottom: idx !== menu_options.length - 1 ? '1px solid #eaeaea' : void 0
	          },
	          onKeyDown: (function(_this) {
	            return function(e) {
	              if (e.which === 13 || e.which === 32) {
	                e.currentTarget.click();
	                return e.preventDefault();
	              }
	            };
	          })(this),
	          onFocus: (function(_this) {
	            return function(idx) {
	              return function(e) {
	                if (_this.local.focus !== idx) {
	                  set_focus(idx);
	                }
	                return e.stopPropagation();
	              };
	            };
	          })(this)(idx),
	          onMouseEnter: (function(_this) {
	            return function(idx) {
	              return function() {
	                if (_this.local.focus !== idx) {
	                  return set_focus(idx);
	                }
	              };
	            };
	          })(this)(idx),
	          onBlur: (function(_this) {
	            return function(e) {
	              _this.local.focus = null;
	              return save(_this.local);
	            };
	          })(this),
	          onMouseExit: (function(_this) {
	            return function(e) {
	              _this.local.focus = null;
	              save(_this.local);
	              return e.stopPropagation();
	            };
	          })(this)
	        }, option.label)));
	      }
	      return results;
	    }).call(this)));
	  }
	});


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var nav, section_div;

	window.LandingPage = ReactiveComponent({
	  displayName: 'LandingPage',
	  render: function() {
	    var idx, loc, mobile, row, rows, section, w;
	    loc = fetch('location');
	    w = SAAS_PAGE_WIDTH();
	    mobile = w < 830;
	    return DIV({
	      style: {
	        color: 'white'
	      }
	    }, DIV({
	      style: {
	        paddingTop: 32,
	        width: SAAS_PAGE_WIDTH(),
	        margin: 'auto'
	      }
	    }, H1({
	      style: {
	        color: 'white',
	        maxWidth: 1050,
	        margin: 'auto'
	      }
	    }, DIV({
	      style: {
	        fontStyle: 'oblique',
	        fontWeight: 100,
	        fontSize: mobile ? 20 : 28
	      }
	    }, 'Consider.it creates'), DIV({
	      style: {
	        fontSize: mobile ? 32 : 50,
	        fontWeight: 700,
	        textAlign: 'left',
	        textShadow: '0px 1px 2px rgba(0,0,0,.2)',
	        fontStyle: 'oblique',
	        textTransform: 'uppercase'
	      }
	    }, SAAS_PAGE_WIDTH() < 1040 ? 'Civil and organized online dialogue' : "CIVIL, ORGANIZED, AND EFFICIENT ONLINE DIALOGUE"), DIV({
	      style: {
	        fontStyle: 'oblique',
	        fontWeight: 100,
	        fontSize: mobile ? 20 : 28,
	        textAlign: 'right'
	      }
	    }, 'by visually summarizing what your community thinks and why')), DIV({
	      style: {
	        textAlign: 'center',
	        paddingTop: 24,
	        position: 'relative',
	        top: 8
	      }
	    }, Demo({
	      width: Math.min(1050, SAAS_PAGE_WIDTH())
	    })), DIV({
	      style: {
	        fontStyle: 'oblique',
	        fontWeight: 100,
	        textAlign: 'center',
	        fontSize: mobile ? 16 : 20,
	        paddingTop: 18,
	        paddingBottom: 32
	      }
	    }, 'The City of Seattle is one of many to trust Consider.it with community and stakeholder engagement')), DIV({
	      style: {
	        fontSize: mobile ? 28 : 36,
	        fontWeight: 400,
	        width: SAAS_PAGE_WIDTH(),
	        maxWidth: 1020,
	        textAlign: 'left',
	        paddingBottom: 36,
	        margin: '8px auto 0 auto',
	        fontStyle: 'oblique'
	      }
	    }, "Consider.it conversations stay focused — even if hundreds participate — so you can learn together, \nmake better decisions, and gain buy-in, without the overhead of expensive meetings or \noverwhelming comment threads."), DIV({
	      style: {
	        paddingBottom: 60,
	        width: SAAS_PAGE_WIDTH(),
	        margin: 'auto'
	      }
	    }, (function() {
	      var i, len, results;
	      if (mobile) {
	        results = [];
	        for (i = 0, len = nav.length; i < len; i++) {
	          section = nav[i];
	          results.push(DIV({
	            style: {
	              textAlign: 'center',
	              paddingBottom: 20
	            }
	          }, section_div(section)));
	        }
	        return results;
	      } else {
	        rows = [[nav[0], nav[1]], [nav[2], nav[3]]];
	        return TABLE({
	          style: {
	            margin: 'auto',
	            borderSpacing: '80px 24px',
	            borderCollapse: 'separate'
	          }
	        }, (function() {
	          var j, len1, results1;
	          results1 = [];
	          for (j = 0, len1 = rows.length; j < len1; j++) {
	            row = rows[j];
	            results1.push(TR({
	              style: {}
	            }, (function() {
	              var k, len2, results2;
	              results2 = [];
	              for (idx = k = 0, len2 = row.length; k < len2; idx = ++k) {
	                section = row[idx];
	                results2.push(TD({
	                  style: {
	                    width: '48%',
	                    textAlign: idx === 0 ? 'right' : 'left'
	                  }
	                }, section_div(section)));
	              }
	              return results2;
	            })()));
	          }
	          return results1;
	        })());
	      }
	    })()));
	  }
	});

	nav = [
	  {
	    label: 'How does it work?',
	    link: '/tour',
	    links: [
	      {
	        label: 'starting your own forum',
	        link: '/tour'
	      }, {
	        label: 'features',
	        link: '/tour#features'
	      }, {
	        label: 'research findings',
	        link: '/tour#research'
	      }
	    ]
	  }, {
	    label: 'Show me examples!',
	    link: '/examples',
	    links: [
	      {
	        label: 'strategic planning on a tight budget',
	        link: '/examples/strategic_planning'
	      }, {
	        label: 'civil public engagement',
	        link: '/examples/public_engagement'
	      }, {
	        label: 'decentralized community decision-making',
	        link: '/examples/decentralized_decisions'
	      }
	    ]
	  }, {
	    label: 'What will it cost?',
	    link: '/pricing',
	    links: [
	      {
	        label: 'free, unlimited & enterprise tiers',
	        link: '/pricing'
	      }, {
	        label: 'consulting services',
	        link: '/pricing#consulting'
	      }, {
	        label: 'FAQ',
	        link: '/pricing#faq'
	      }
	    ]
	  }, {
	    label: 'I\'d like to talk',
	    link: '/contact',
	    links: [
	      {
	        label: 'request a demo',
	        link: '/contact?form=request_demo'
	      }, {
	        label: 'general inquiry',
	        link: '/contact'
	      }
	    ]
	  }
	];

	section_div = function(section) {
	  var idx, link;
	  return DIV(null, H3({
	    style: {
	      paddingBottom: 10
	    }
	  }, A({
	    href: section.link,
	    style: {
	      textDecoration: 'underline',
	      fontStyle: 'oblique',
	      color: 'white',
	      fontSize: 42,
	      fontWeight: 800
	    }
	  }, section.label)), UL({
	    style: {
	      listStyle: 'none'
	    }
	  }, (function() {
	    var i, len, ref, results;
	    ref = section.links;
	    results = [];
	    for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	      link = ref[idx];
	      results.push(LI({
	        style: {
	          textAlign: 'center',
	          opacity: .7,
	          display: 'inline'
	        }
	      }, A({
	        href: link.link,
	        style: {
	          fontSize: 18,
	          fontWeight: 400,
	          color: 'white'
	        }
	      }, link.label), idx < section.links.length - 1 ? ', ' : void 0));
	    }
	    return results;
	  })()));
	};

	window.Demo = ReactiveComponent({
	  displayName: 'Demo',
	  render: function() {
	    var asset_path, format, loc, props, video_height, watch_demo;
	    if (this.local.playing == null) {
	      this.local.playing = true;
	    }
	    loc = fetch('location');
	    props = this.props;
	    watch_demo = function() {
	      window.scrollTo(0, 0);
	      loc.query_params.play_demo = true;
	      return save(loc);
	    };
	    video_height = Math.max(200, 1.0 * props.width * 3 / 7);
	    return DIV({
	      style: {
	        position: 'relative',
	        width: props.width,
	        height: props.height,
	        margin: 'auto'
	      }
	    }, Webframe({
	      browser_loc: 'https://seattle2035.consider.it/housing',
	      width: video_height * 7 / 3 + 2,
	      dummy: video_height,
	      dummy2: this.local.playing
	    }, DIV({
	      style: {
	        width: '100%',
	        margin: 'auto',
	        position: 'relative'
	      }
	    }, VIDEO({
	      ref: 'video',
	      preload: true,
	      loop: true,
	      autoPlay: true,
	      style: {
	        width: video_height * 7 / 3,
	        height: video_height,
	        paddingTop: 10,
	        display: 'block'
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = ['mp4', 'webm'];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        format = ref[i];
	        asset_path = asset("product_page/trimmed-overall." + format);
	        results.push(SOURCE({
	          key: format,
	          src: asset_path,
	          type: "video/" + format
	        }));
	      }
	      return results;
	    })(), "Your browser does not support the video element."), DIV({
	      style: {
	        position: 'absolute',
	        right: 6,
	        bottom: 6,
	        backgroundColor: '#534B4B',
	        opacity: .7,
	        padding: '6px 12px',
	        borderRadius: 8,
	        fontSize: 24
	      }
	    }, BUTTON({
	      style: {
	        cursor: 'pointer',
	        backgroundColor: 'transparent',
	        border: 'none',
	        color: 'white',
	        width: 33,
	        display: 'inline-block'
	      },
	      title: this.local.playing ? 'Pause video demo' : 'Play video demo',
	      onClick: (function(_this) {
	        return function() {
	          return _this.toggleVideoPlay();
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function() {
	          if (e.which === 32 || e.which === 13) {
	            return _this.toggleVideoPlay();
	          }
	        };
	      })(this)
	    }, !this.local.playing ? SPAN({
	      dangerouslySetInnerHTML: {
	        __html: '&#9658;'
	      }
	    }) : [
	      SPAN({
	        dangerouslySetInnerHTML: {
	          __html: '&#10073'
	        }
	      }), SPAN({
	        style: {
	          paddingLeft: 1
	        },
	        dangerouslySetInnerHTML: {
	          __html: '&#10073'
	        }
	      })
	    ]), BUTTON({
	      style: {
	        color: 'white',
	        marginLeft: 6,
	        display: 'inline-block',
	        cursor: 'pointer',
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      title: 'Restart video demo',
	      onClick: (function(_this) {
	        return function() {
	          return _this.restart();
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function() {
	          if (e.which === 32 || e.which === 13) {
	            return _this.restart();
	          }
	        };
	      })(this),
	      dangerouslySetInnerHTML: {
	        __html: '&#10226;'
	      }
	    })))));
	  },
	  toggleVideoPlay: function() {
	    var el, ref;
	    el = (ref = this.refs.video) != null ? ref.getDOMNode() : void 0;
	    if (this.local.playing) {
	      if (typeof el.pause === "function") {
	        el.pause();
	      }
	    } else {
	      if (typeof el.play === "function") {
	        el.play();
	      }
	    }
	    this.local.playing = !this.local.playing;
	    save(this.local);
	    return document.activeElement.blur();
	  },
	  restart: function() {
	    var el, ref;
	    el = (ref = this.refs.video) != null ? ref.getDOMNode() : void 0;
	    el.currentTime = 0;
	    return document.activeElement.blur();
	  }
	});

	window.Webframe = ReactiveComponent({
	  displayName: 'Webframe',
	  render: function() {
	    var ref;
	    return DIV({
	      style: {
	        backgroundColor: 'white',
	        borderRadius: 4,
	        boxShadow: '0 2px 8px rgba(0,0,0,.1)',
	        border: '1px solid #DADADA',
	        borderTop: 'none',
	        width: this.props.width || 882,
	        margin: 'auto'
	      }
	    }, SVG({
	      viewBox: "0 0 882 26",
	      width: (this.props.width || 882) - 1,
	      height: 26 / 882 * ((this.props.width || 882) - 1),
	      style: {
	        borderRadius: '4px 4px 0 0',
	        position: 'relative',
	        top: -1,
	        display: 'block'
	      },
	      dangerouslySetInnerHTML: {
	        __html: "<defs>\n    <linearGradient x1=\"50%\" y1=\"0%\" x2=\"50%\" y2=\"97.915338%\" id=\"linearGradient-1\">\n        <stop stop-color=\"#F6F4F6\" offset=\"0%\"></stop>\n        <stop stop-color=\"#D5D5D5\" offset=\"99.5416135%\"></stop>\n        <stop stop-color=\"#B7B6B7\" offset=\"100%\"></stop>\n    </linearGradient>\n    <rect id=\"path-2\" x=\"0\" y=\"0\" width=\"882\" height=\"25\" rx=\"0\"></rect>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-3\">\n        <feOffset dx=\"0\" dy=\"-1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n        <feComposite in=\"shadowOffsetOuter1\" in2=\"SourceAlpha\" operator=\"out\" result=\"shadowOffsetOuter1\"></feComposite>\n        <feColorMatrix values=\"0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix>\n    </filter>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-4\">\n        <feGaussianBlur stdDeviation=\"0.5\" in=\"SourceAlpha\" result=\"shadowBlurInner1\"></feGaussianBlur>\n        <feOffset dx=\"0\" dy=\"1\" in=\"shadowBlurInner1\" result=\"shadowOffsetInner1\"></feOffset>\n        <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite>\n        <feColorMatrix values=\"0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix>\n    </filter>\n    <rect id=\"path-5\" x=\"0\" y=\"0\" width=\"361.581259\" height=\"14.1025641\" rx=\"3.5\"></rect>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-6\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n        <feColorMatrix values=\"0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix>\n    </filter>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-7\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetInner1\"></feOffset>\n        <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite>\n        <feColorMatrix values=\"0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix>\n    </filter>\n    <rect id=\"path-8\" x=\"0\" y=\"0.606608157\" width=\"16.4648609\" height=\"14.1025641\" rx=\"3.5\"></rect>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-9\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n        <feColorMatrix values=\"0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix>\n    </filter>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-10\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetInner1\"></feOffset>\n        <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite>\n        <feColorMatrix values=\"0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix>\n    </filter>\n    <rect id=\"path-11\" x=\"0\" y=\"0.606608157\" width=\"17.1105417\" height=\"14.1025641\" rx=\"3.5\"></rect>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-12\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"></feOffset>\n        <feColorMatrix values=\"0 0 0 0 0.792156863   0 0 0 0 0.788235294   0 0 0 0 0.792156863  0 0 0 1 0\" type=\"matrix\" in=\"shadowOffsetOuter1\"></feColorMatrix>\n    </filter>\n    <filter x=\"-50%\" y=\"-50%\" width=\"200%\" height=\"200%\" filterUnits=\"objectBoundingBox\" id=\"filter-13\">\n        <feOffset dx=\"0\" dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetInner1\"></feOffset>\n        <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" operator=\"arithmetic\" k2=\"-1\" k3=\"1\" result=\"shadowInnerInner1\"></feComposite>\n        <feColorMatrix values=\"0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0\" type=\"matrix\" in=\"shadowInnerInner1\"></feColorMatrix>\n    </filter>\n    <ellipse id=\"path-14\" cx=\"29.7013177\" cy=\"4.45706419\" rx=\"3.87408492\" ry=\"3.87196696\"></ellipse>\n    <mask id=\"mask-15\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"7.74816984\" height=\"7.74393392\" fill=\"white\">\n        <use xlink:href=\"#path-14\"></use>\n    </mask>\n    <ellipse id=\"path-16\" cx=\"16.7877013\" cy=\"4.43125108\" rx=\"3.87408492\" ry=\"3.84615385\"></ellipse>\n    <mask id=\"mask-17\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"7.74816984\" height=\"7.69230769\" fill=\"white\">\n        <use xlink:href=\"#path-16\"></use>\n    </mask>\n    <ellipse id=\"path-18\" cx=\"3.87408492\" cy=\"4.43125108\" rx=\"3.87408492\" ry=\"3.84615385\"></ellipse>\n    <mask id=\"mask-19\" maskContentUnits=\"userSpaceOnUse\" maskUnits=\"objectBoundingBox\" x=\"0\" y=\"0\" width=\"7.74816984\" height=\"7.69230769\" fill=\"white\">\n        <use xlink:href=\"#path-18\"></use>\n    </mask>\n</defs>\n<g id=\"landing-page\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n    <g id=\"Desktop-HD-Copy-34\" transform=\"translate(-328.000000, -749.000000)\">\n        <g id=\"Safari\" transform=\"translate(328.000000, 750.000000)\">\n            <g id=\"background\">\n                <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-3)\" xlink:href=\"#path-2\"></use>\n                <use fill-opacity=\"0.6\" fill=\"url(#linearGradient-1)\" fill-rule=\"evenodd\" xlink:href=\"#path-2\"></use>\n                <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-4)\" xlink:href=\"#path-2\"></use>\n            </g>\n            <!-- \n            <g id=\"New-Tab\" transform=\"translate(866.503660, 8.974359)\">\n                <rect id=\"background\" fill-opacity=\"0.5\" fill=\"#B6B6B6\" x=\"0\" y=\"0\" width=\"15.4963397\" height=\"16.025641\"></rect>\n                <path d=\"M7.74816984,7.69230769 L4.51976574,7.69230769 L4.51976574,8.33763552 L7.74816984,8.33763552 L7.74816984,11.5857856 L8.39385066,11.5857856 L8.39385066,8.33763552 L11.6222548,8.33763552 L11.6222548,7.69230769 L8.39385066,7.69230769 L8.39385066,4.48717949 L7.74816984,4.48717949 L7.74816984,7.69230769 Z M0.64568082,0 L15.4963397,0 L15.4963397,0.645327827 L0.64568082,0.645327827 L0.64568082,0 Z M0,0 L0.64568082,0 L0.64568082,15.376011 L0,15.376011 L0,0 Z\" id=\"Add\" fill=\"#7D7D7D\"></path>\n            </g>\n            -->\n\n\n            <g id=\"Search\" transform=\"translate(260.209370, 5.162623)\" style=\"" + (((ref = this.props.browser_loc) != null ? ref.length : void 0) > 0 ? '' : 'display:none') + "\">\n                <g id=\"background\">\n                    <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-6)\" xlink:href=\"#path-5\"></use>\n                    <use fill=\"#FCFBFC\" fill-rule=\"evenodd\" xlink:href=\"#path-5\"></use>\n                    <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-7)\" xlink:href=\"#path-5\"></use>\n                </g>\n                <path d=\"M352.865451,3.86914807 C351.055024,4.03175239 349.636164,5.55230111 349.636164,7.40406126 C349.636164,9.36428721 351.22611,10.9533643 353.187408,10.9533643 C355.148707,10.9533643 356.738653,9.36428721 356.738653,7.40406126 C356.738653,7.29529458 356.733758,7.18767059 356.724176,7.08139735 L356.075239,7.08139735 C356.086957,7.18733884 356.092972,7.29499793 356.092972,7.40406126 C356.092972,9.00788249 354.792107,10.3080365 353.187408,10.3080365 C351.58271,10.3080365 350.281845,9.00788249 350.281845,7.40406126 C350.281845,5.90900072 351.41226,4.67781842 352.865451,4.51771221 L352.865451,5.79162418 L356.09209,4.17742213 L352.865451,2.56322008 L352.865451,3.86914807 Z\" id=\"reload\" fill=\"#7E7E7E\"></path>\n                <text id=\"url\" font-family=\"HelveticaNeue, Helvetica Neue\" font-size=\"10\" font-weight=\"normal\" letter-spacing=\"-0.15384616\" fill=\"#000000\">\n                    <tspan x=\"19.6134701\" y=\"10.5641026\">" + this.props.browser_loc + "</tspan>\n                </text>\n            </g>\n            <g id=\"Back-+-Forward\" transform=\"translate(50.363104, 4.521597)\">\n                <g id=\"forward\" transform=\"translate(17.756223, 0.000000)\">\n                    <g id=\"background\">\n                        <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-9)\" xlink:href=\"#path-8\"></use>\n                        <use fill=\"#FCFBFC\" fill-rule=\"evenodd\" xlink:href=\"#path-8\"></use>\n                        <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-10)\" xlink:href=\"#path-8\"></use>\n                    </g>\n                    <g id=\"Icon\" transform=\"translate(6.779649, 4.190329)\" stroke=\"#DADADA\" stroke-width=\"1.5\" stroke-linecap=\"round\">\n                        <path d=\"M0.161420205,0.161331957 L3.425862,3.42398908\" id=\"Line\"></path>\n                        <path d=\"M0.161420205,6.69625979 L3.425862,3.43360266\" id=\"Line\"></path>\n                    </g>\n                </g>\n                <g id=\"back\">\n                    <g id=\"background\">\n                        <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-12)\" xlink:href=\"#path-11\"></use>\n                        <use fill=\"#FCFBFC\" fill-rule=\"evenodd\" xlink:href=\"#path-11\"></use>\n                        <use fill=\"black\" fill-opacity=\"1\" filter=\"url(#filter-13)\" xlink:href=\"#path-11\"></use>\n                    </g>\n                    <g id=\"Icon\" transform=\"translate(7.685212, 7.690329) scale(-1, 1) translate(-7.685212, -7.690329) translate(5.685212, 4.190329)\" stroke=\"#585858\" stroke-width=\"1.5\" stroke-linecap=\"round\">\n                        <path d=\"M0.161420205,0.161331957 L3.425862,3.42398908\" id=\"Line\"></path>\n                        <path d=\"M0.161420205,6.69625979 L3.425862,3.43360266\" id=\"Line\"></path>\n                    </g>\n                </g>\n            </g>\n            <g id=\"Close-+-Minimize-+-Full-Screen\" transform=\"translate(8.393851, 7.748236)\">\n                <use id=\"green\" stroke=\"#19B228\" mask=\"url(#mask-15)\" fill=\"#14CA34\" xlink:href=\"#path-14\"></use>\n                <use id=\"yellow\" stroke=\"#E3A300\" mask=\"url(#mask-17)\" fill=\"#FFC008\" xlink:href=\"#path-16\"></use>\n                <use id=\"red\" stroke=\"#E4453A\" mask=\"url(#mask-19)\" fill=\"#FF5F52\" xlink:href=\"#path-18\"></use>\n            </g>\n        </g>\n    </g>\n</g>"
	      }
	    }), this.props.children);
	  }
	});


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var LineGraph, smooth;

	smooth = function(series, window_l) {
	  var d, i, idx, j, k, len, len1, p, range, tot;
	  for (idx = j = 0, len = series.length; j < len; idx = ++j) {
	    d = series[idx];
	    range = (function() {
	      var k, ref, ref1, results;
	      results = [];
	      for (i = k = ref = idx - window_l + 1, ref1 = idx; ref <= ref1 ? k <= ref1 : k >= ref1; i = ref <= ref1 ? ++k : --k) {
	        if (i >= 0) {
	          results.push(i);
	        }
	      }
	      return results;
	    })();
	    tot = 0;
	    for (k = 0, len1 = range.length; k < len1; k++) {
	      p = range[k];
	      tot += series[p][2];
	    }
	    d.push(tot / range.length);
	  }
	  return series;
	};

	window.Metrics = ReactiveComponent({
	  displayName: 'Metrics',
	  render: function() {
	    var d, m, metrics;
	    m = fetch('/metrics');
	    if (this.local.log == null) {
	      this.local.log = 'linear';
	      this.local.time_frame = 'all time';
	    }
	    if (!m.daily_active_contributors) {
	      return DIV({
	        style: {
	          margin: '100px auto',
	          fontSize: 36,
	          width: 400,
	          textAlign: 'center'
	        }
	      }, 'Loading metrics, might be a minute');
	    }
	    if (this.local.time_frame === 'all time') {
	      metrics = m;
	    } else {
	      metrics = _.extend(m, {
	        daily_active_contributors: (function() {
	          var j, len, ref, results;
	          ref = m.daily_active_contributors;
	          results = [];
	          for (j = 0, len = ref.length; j < len; j++) {
	            d = ref[j];
	            if (d[0] < 365) {
	              results.push(d);
	            }
	          }
	          return results;
	        })(),
	        daily_active_subdomains: (function() {
	          var j, len, ref, results;
	          ref = m.daily_active_subdomains;
	          results = [];
	          for (j = 0, len = ref.length; j < len; j++) {
	            d = ref[j];
	            if (d[0] < 365) {
	              results.push(d);
	            }
	          }
	          return results;
	        })()
	      });
	    }
	    return DIV({
	      style: {
	        margin: 60,
	        minHeight: window.innerHeight
	      }
	    }, STYLE(null, ".axis path,\n.axis line {\n  fill: none;\n  stroke: #000;\n  shape-rendering: crispEdges;\n}\n\n.line {\n  fill: none;\n  stroke: steelblue;\n  stroke-width: 1.5px;\n}\n\n.line2 {\n  fill: none;\n  stroke: magenta;\n  stroke-width: 1.5px;\n}\n\n\n.tick line{\n    opacity: 0.1;\n  }\n\n.tick text{\n    font-size: 12px;\n  }            "), DIV({
	      style: {
	        fontSize: 24,
	        textAlign: 'center'
	      }
	    }, "Daily unique contributors", SPAN({
	      style: {
	        fontSize: 14,
	        border: '1px solid #ccc',
	        padding: '2px 4px',
	        cursor: 'pointer',
	        borderRadius: 8,
	        display: 'inline-block',
	        marginLeft: 10
	      },
	      onClick: (function(_this) {
	        return function() {
	          if (_this.local.log === 'linear') {
	            _this.local.log = 'log10';
	          } else {
	            _this.local.log = 'linear';
	          }
	          return save(_this.local);
	        };
	      })(this)
	    }, this.local.log), SPAN({
	      style: {
	        fontSize: 14,
	        border: '1px solid #ccc',
	        padding: '2px 4px',
	        cursor: 'pointer',
	        borderRadius: 8,
	        display: 'inline-block',
	        marginLeft: 10
	      },
	      onClick: (function(_this) {
	        return function() {
	          if (_this.local.time_frame === 'all time') {
	            _this.local.time_frame = 'past 365 days';
	          } else {
	            _this.local.time_frame = 'all time';
	          }
	          return save(_this.local);
	        };
	      })(this)
	    }, this.local.time_frame)), LineGraph({
	      key: "contributors-" + this.local.log + "-" + this.local.time_frame,
	      data: smooth(metrics.daily_active_contributors, 30),
	      width: WINDOW_WIDTH() - 60 * 2,
	      log: this.local.log
	    }), DIV({
	      style: {
	        fontSize: 24,
	        marginTop: 40,
	        textAlign: 'center'
	      }
	    }, "Daily active subdomains"), LineGraph({
	      key: "subs-" + this.local.log + "-" + this.local.time_frame,
	      data: smooth(metrics.daily_active_subdomains, 30),
	      width: WINDOW_WIDTH() - 60 * 2,
	      log: this.local.log
	    }), DIV({
	      style: {
	        fontSize: 24,
	        marginTop: 40,
	        textAlign: 'center'
	      }
	    }, "Total Usage (sum of Daily Unique Contributors)", (function(_this) {
	      return function() {
	        var cont, contributions, contributors, ref, sort_on_click, subdomain, td_style, th_style;
	        contributions = [];
	        ref = metrics.contributors_per_subdomain;
	        for (subdomain in ref) {
	          contributors = ref[subdomain];
	          if (contributors.lifetime > 1) {
	            contributions.push([subdomain, contributors]);
	          }
	        }
	        if (_this.local.sort_contributions_by == null) {
	          _this.local.sort_contributions_by = 'year';
	        }
	        contributions.sort(function(a, b) {
	          var ref1;
	          if ((ref1 = _this.local.sort_contributions_by) === 'opinions_per_subdomain' || ref1 === 'opinions_and_inclusions_per_subdomain') {
	            return metrics[_this.local.sort_contributions_by][b[0]] - metrics[_this.local.sort_contributions_by][a[0]];
	          } else {
	            return b[1][_this.local.sort_contributions_by] - a[1][_this.local.sort_contributions_by];
	          }
	        });
	        sort_on_click = function(e) {
	          _this.local.sort_contributions_by = e.currentTarget.getAttribute('data-time');
	          return save(_this.local);
	        };
	        td_style = {
	          padding: '0 8px'
	        };
	        th_style = {
	          padding: '2px 8px',
	          fontWeight: 'bold',
	          cursor: 'pointer',
	          borderBottom: '1px solid #999'
	        };
	        return TABLE({
	          style: {
	            margin: 'auto'
	          }
	        }, TBODY(null, TR(null, TH({
	          style: _.extend({}, th_style, {
	            textAlign: 'right',
	            cursor: 'default'
	          })
	        }, 'Name'), TH({
	          onClick: sort_on_click,
	          'data-time': 'opinions_per_subdomain',
	          style: th_style
	        }, 'Opinions'), TH({
	          onClick: sort_on_click,
	          'data-time': 'opinions_and_inclusions_per_subdomain',
	          style: th_style
	        }, '+inclusions'), TH({
	          onClick: sort_on_click,
	          'data-time': 'active',
	          style: th_style
	        }, 'Days active'), TH({
	          onClick: sort_on_click,
	          'data-time': 'lifetime',
	          style: th_style
	        }, 'Lifetime'), TH({
	          onClick: sort_on_click,
	          'data-time': 'year',
	          style: th_style
	        }, 'Past year'), TH({
	          onClick: sort_on_click,
	          'data-time': 'month',
	          style: th_style
	        }, 'Past month'), TH({
	          onClick: sort_on_click,
	          'data-time': 'week',
	          style: th_style
	        }, 'Past week'), TH({
	          onClick: sort_on_click,
	          'data-time': 'day',
	          style: th_style
	        }, 'Past day')), (function() {
	          var j, len, results;
	          results = [];
	          for (j = 0, len = contributions.length; j < len; j++) {
	            cont = contributions[j];
	            subdomain = cont[0], contributors = cont[1];
	            results.push(TR(null, TD({
	              style: _.extend({}, td_style, {
	                textAlign: 'right'
	              })
	            }, A({
	              href: "https://" + (fetch("/subdomain/" + subdomain).name) + ".consider.it",
	              title: fetch("/subdomain/" + subdomain).name,
	              style: {
	                color: focus_color(),
	                textDecoration: 'underline',
	                display: 'inline-block',
	                maxWidth: 200,
	                overflow: 'hidden'
	              }
	            }, fetch("/subdomain/" + subdomain).name)), TD({
	              style: td_style
	            }, metrics.opinions_per_subdomain[subdomain]), TD({
	              style: td_style
	            }, metrics.opinions_and_inclusions_per_subdomain[subdomain]), TD({
	              style: td_style
	            }, contributors.active), TD({
	              style: td_style
	            }, contributors.lifetime), TD({
	              style: td_style
	            }, contributors.year), TD({
	              style: td_style
	            }, contributors.month), TD({
	              style: td_style
	            }, contributors.week), TD({
	              style: td_style
	            }, contributors.day)));
	          }
	          return results;
	        })()));
	      };
	    })(this)()));
	  }
	});

	LineGraph = ReactiveComponent({
	  displayName: 'LineGraph',
	  render: function() {
	    return DIV({
	      ref: 'container'
	    });
	  },
	  componentDidMount: function() {
	    var container, data, formatDate, g, height, margin, measure, series, svg, valueline, width, x, xAxis, y, yAxis, yAxis_right, z;
	    data = this.props.data;
	    margin = {
	      top: 20,
	      right: 50,
	      bottom: 30,
	      left: 50
	    };
	    width = this.props.width - margin.left - margin.right;
	    height = 250 - margin.top - margin.bottom;
	    x = d3.time.scale().range([0, width]);
	    if (this.props.log === 'log10') {
	      y = d3.scale.log().domain([0.1, 100]).range([height, 0]);
	    } else {
	      y = d3.scale.linear().range([height, 0]);
	    }
	    z = d3.scale.category10();
	    xAxis = d3.svg.axis().scale(x).orient('bottom');
	    yAxis = d3.svg.axis().scale(y).orient('left').innerTickSize(-width).outerTickSize(0).tickPadding(10);
	    if (this.props.log === 'log10') {
	      yAxis.ticks(0, ".1s");
	    }
	    yAxis_right = d3.svg.axis().scale(y).outerTickSize(0).orient('right');
	    if (this.props.log === 'log10') {
	      yAxis_right.ticks(0, ".1s");
	    }
	    formatDate = d3.time.format("%d-%b-%y");
	    series = [
	      {
	        id: 'daily',
	        values: data.map(function(d) {
	          return [d[1], Math.max(d[2], .1)];
	        })
	      }, {
	        id: 'monthly',
	        values: data.map(function(d) {
	          return [d[1], Math.max(d[3], .1)];
	        })
	      }
	    ];
	    valueline = d3.svg.line().interpolate("basis").x(function(d) {
	      return x(formatDate.parse(d[0]));
	    }).y(function(d) {
	      return y(d[1]);
	    });
	    container = d3.select(this.getDOMNode());
	    svg = container.append('svg').attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom);
	    g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	    x.domain(d3.extent(data, function(d) {
	      return formatDate.parse(d[1]);
	    }));
	    y.domain([
	      d3.min(series, function(c) {
	        return d3.min(c.values, function(d) {
	          return d[1];
	        });
	      }), d3.max(series, function(c) {
	        return d3.max(c.values, function(d) {
	          return d[1];
	        });
	      })
	    ]);
	    z.domain(data.map(function(d) {
	      return d.id;
	    }));
	    g.append('g').attr('class', 'x axis').attr('transform', 'translate(0,' + height + ')').call(xAxis);
	    g.append('g').attr('class', 'y axis').call(yAxis);
	    g.append('g').attr('class', 'y axis').attr("transform", "translate(" + width + " ,0)").call(yAxis_right);
	    measure = g.selectAll('.measure').data(series).enter().append('g').attr('class', 'measure');
	    return measure.append('path').attr('class', 'line').attr('d', function(d) {
	      return valueline(d.values);
	    }).style('stroke', function(d) {
	      return z(d.id);
	    });
	  }
	});


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var FAQ, background_swosh, hide_opinion_tooltip, info, per_opinion, pricing_qs, show_opinion_tooltip, tech_qs;

	background_swosh = function() {
	  return SVG({
	    width: window.innerWidth,
	    height: 1430,
	    viewBox: "0 0 1440 1430"
	  }, G({
	    transform: "translate(0.000000, -374.000000)",
	    fill: "#9968D4",
	    fillOpacity: "0.26000002"
	  }, PATH({
	    d: "M-1.6640625,369.640625 C-1.6640625,369.640625 63.1989495,554.640744 303.054688,719.8125 C542.910426,884.984256 1440,1037.32031 1440,1037.32031 L1440,1803.60938 L-1.6640625,1576.3125 L-1.6640625,369.640625 Z"
	  })));
	};

	show_opinion_tooltip = function(e) {
	  var tooltip;
	  tooltip = fetch('tooltip');
	  tooltip.coords = $(e.currentTarget).offset();
	  tooltip.coords.left += e.currentTarget.offsetWidth / 2;
	  tooltip.tip = per_opinion.a;
	  tooltip.top = false;
	  save(tooltip);
	  return e.preventDefault();
	};

	hide_opinion_tooltip = function(e) {
	  var tooltip;
	  tooltip = fetch('tooltip');
	  tooltip.coords = null;
	  delete tooltip.top;
	  return save(tooltip);
	};

	info = function() {
	  return SPAN({
	    style: {
	      paddingLeft: 3,
	      verticalAlign: 'middle'
	    }
	  }, SVG({
	    viewBox: "3 3 6.5915 6.5915",
	    width: 15,
	    height: 15,
	    style: {
	      display: 'inline-block',
	      shapeRendering: 'geometricPrecision',
	      textRendering: 'geometricPrecision',
	      imageRendering: 'optimizeQuality',
	      fillRule: 'evenodd',
	      clipRule: 'evenodd'
	    }
	  }, G({
	    transform: "matrix(0.443852,0.000000,0.000000,0.443852,3.501380,3.501380)"
	  }, PATH({
	    fill: '#777',
	    d: "M 6.29577,0 C 9.77228,0 12.59154,2.81926 12.59154,6.29577 C 12.59154,9.77228 9.77228,12.59154 6.29577,12.59154 C 2.81926,12.59154 0,9.77228 0,6.29577 C 0,2.81926 2.81926,0 6.29577,0 z M 7.241939,4.51008 L 7.241939,10.10704 L 7.988183,10.10704 L 7.988183,10.773334 L 7.854945,10.773334 L 4.603355,10.773334 L 4.603355,10.10704 L 5.349633,10.10704 L 5.349633,5.17637 L 4.603355,5.17637 L 4.603355,4.510076 L 4.736627,4.510076 L 7.241937,4.510076 L 7.241939,4.51008 z M 5.296309,2.75105 C 5.296309,2.511166 5.3829582,2.295734 5.556188,2.104718 C 5.729418,1.913702 5.953761,1.818211 6.229147,1.818211 L 6.362419,1.818211 C 6.593393,1.818211 6.806615,1.9026157 7.002052,2.071425 C 7.197523,2.2402 7.295224,2.466753 7.295224,2.75105 C 7.295224,2.990899 7.2108533,3.206332 7.042044,3.397348 C 6.873235,3.588364 6.646716,3.683855 6.362419,3.683855 L 6.229147,3.683855 C 5.998173,3.683855 5.784951,3.5994503 5.589514,3.430675 C 5.394043,3.261866 5.296308,3.035313 5.296308,2.75105 L 5.296309,2.75105 z "
	  }))));
	};

	window.Pricing = ReactiveComponent({
	  displayName: 'Pricing',
	  render: function() {
	    return DIV({
	      style: {}
	    }, this.heading(), this.plans(), this.consulting(), DIV({
	      style: {
	        paddingTop: 40,
	        backgroundColor: 'white'
	      }
	    }, this.consultant_partnership()), FAQ());
	  },
	  heading: function() {
	    return DIV({
	      style: {
	        paddingTop: 40,
	        width: SAAS_PAGE_WIDTH(),
	        margin: 'auto',
	        textAlign: 'center'
	      }
	    }, H1({
	      style: {
	        fontSize: 50,
	        fontWeight: 800,
	        color: 'white',
	        textShadow: '0px 2px 4px rgba(0,0,0,.2)'
	      }
	    }, "Invest in your community’s opinions"), DIV({
	      style: {
	        fontSize: 18,
	        color: 'white',
	        marginTop: 8
	      }
	    }, 'Careful organization and visualization of your stakeholders\' considered opinions'));
	  },
	  plans: function() {
	    var base_text, compact, details_paragraph, dollar_style, feature, money_style, payment_container_style, plan_button_style, plan_name_style, plan_name_subtitle, plan_style;
	    compact = browser.is_mobile || SAAS_PAGE_WIDTH() < 1000;
	    plan_style = css.crossbrowserify({
	      padding: '32px 36px',
	      backgroundColor: 'white',
	      width: compact ? '80%' : void 0,
	      maxWidth: !compact ? 340 : 500,
	      display: compact ? 'block' : 'inline-block',
	      margin: (compact ? 20 : 0) + "px " + (compact ? 'auto' : '10px'),
	      verticalAlign: 'top',
	      flex: '1 1 auto'
	    });
	    plan_name_style = {
	      fontWeight: 800,
	      fontSize: 32,
	      textAlign: 'center'
	    };
	    plan_name_subtitle = {
	      fontStyle: 'italic',
	      fontSize: 16,
	      textAlign: 'center'
	    };
	    base_text = {
	      fontSize: 16,
	      fontWeight: 400
	    };
	    details_paragraph = _.extend({}, base_text, {
	      paddingBottom: 30,
	      textAlign: 'left'
	    });
	    plan_button_style = _.extend({}, big_button(), {
	      fontSize: 18,
	      fontWeight: 600,
	      padding: '10px 0',
	      width: '100%',
	      maxWidth: 300,
	      margin: 'auto',
	      textAlign: 'center',
	      display: 'block'
	    });
	    payment_container_style = {
	      paddingTop: 24,
	      textAlign: 'center'
	    };
	    money_style = {
	      fontSize: 75,
	      fontWeight: 800,
	      lineHeight: '75px',
	      position: 'relative'
	    };
	    dollar_style = {
	      fontSize: 32,
	      position: 'absolute',
	      top: 10,
	      left: -20,
	      fontWeight: 400
	    };
	    return UL({
	      style: css.crossbrowserify({
	        textAlign: 'center',
	        listStyle: 'none',
	        paddingTop: 60,
	        display: 'flex',
	        flexDirection: compact ? 'column' : void 0,
	        justifyContent: 'center'
	      })
	    }, LI({
	      style: plan_style
	    }, H2({
	      style: plan_name_style
	    }, 'Free Forum'), DIV({
	      style: plan_name_subtitle
	    }, 'Use for as long as you wish'), DIV({
	      style: _.extend({}, payment_container_style, {
	        display: compact ? 'none' : void 0
	      })
	    }, SPAN({
	      style: money_style
	    }, SPAN({
	      style: dollar_style
	    }, '$'), '0')), DIV({
	      style: {
	        paddingTop: 60,
	        paddingBottom: 60
	      }
	    }, A({
	      href: '/create_forum',
	      target: '_blank',
	      style: plan_button_style
	    }, 'Create Free Forum')), P({
	      style: details_paragraph
	    }, "Engage as many stakeholders about any number of issues for as long as you \nwish. Your forum can be public or private."), P({
	      style: _.extend({}, details_paragraph, {
	        fontStyle: 'italic'
	      })
	    }, SPAN({
	      style: {
	        fontWeight: 700,
	        fontStyle: 'normal'
	      }
	    }, "Limitation:"), " only the 25 most recent questions are visible on your forum’s homepage.")), LI({
	      style: plan_style
	    }, H2({
	      style: plan_name_style
	    }, 'Unlimited Forum'), DIV({
	      style: plan_name_subtitle
	    }, 'All opinions, beautifully visualized'), DIV({
	      style: _.extend({}, payment_container_style, {
	        paddingBottom: 26,
	        textAlign: 'center'
	      })
	    }, SPAN({
	      style: money_style
	    }, SPAN({
	      style: dollar_style
	    }, '$'), '1.25'), DIV({
	      style: _.extend({}, base_text, {
	        marginTop: -18,
	        paddingBottom: 8,
	        textAlign: 'center'
	      })
	    }, SPAN({
	      style: {
	        cursor: 'help'
	      },
	      onMouseEnter: show_opinion_tooltip,
	      onMouseLeave: hide_opinion_tooltip
	    }, 'per opinion', info())), DIV({
	      style: base_text
	    }, '+$250 one-time setup fee')), DIV({
	      style: {
	        paddingBottom: 60 - 26
	      }
	    }, A({
	      href: '/contact?form=upgrade_to_unlimited',
	      target: '_blank',
	      style: plan_button_style
	    }, 'Upgrade to Unlimited'), DIV({
	      style: {
	        fontSize: 12,
	        textAlign: 'center',
	        paddingTop: 12
	      }
	    }, "Special circumstance? ", A({
	      href: '/contact?form=discount',
	      style: {
	        textDecoration: 'underline'
	      }
	    }, "Apply for a discount"), ".")), P({
	      style: details_paragraph
	    }, "We build you a customized forum homepage tailored to your brand and goal, and modify it \nas your community grows. You also get:"), UL({
	      style: _.extend({}, details_paragraph, {
	        listStyle: 'outside',
	        paddingLeft: 18
	      })
	    }, (function() {
	      var i, len, ref, results;
	      ref = ['Data Export', 'Custom User Information', 'Content Moderation', 'Non-English Translation', 'Google Analytics integration', 'One hour training & setup call'];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        feature = ref[i];
	        results.push(LI({
	          style: {}
	        }, feature));
	      }
	      return results;
	    })()), P({
	      className: 'embedded',
	      style: details_paragraph,
	      dangerouslySetInnerHTML: {
	        __html: "After setup, you only <a href='#pay_per_opinion'>pay for the opinions you collect</a>. We can arrange a <a href='#pay_per_opinion'>monthly budget to cap your costs</a>."
	      }
	    })), LI({
	      style: plan_style
	    }, H2({
	      style: plan_name_style
	    }, 'Enterprise'), DIV({
	      style: plan_name_subtitle
	    }, 'Unite all of your Consider.it forums'), DIV({
	      style: _.extend({}, payment_container_style, {
	        paddingBottom: 26
	      })
	    }, SPAN({
	      style: money_style
	    }, SPAN({
	      style: dollar_style
	    }, '$'), '0.80'), DIV({
	      style: _.extend({}, base_text, {
	        marginTop: -18,
	        paddingBottom: 8,
	        textAlign: 'center'
	      })
	    }, SPAN({
	      onMouseEnter: show_opinion_tooltip,
	      onMouseLeave: hide_opinion_tooltip
	    }, 'per opinion', info())), DIV({
	      style: base_text
	    }, '+$1000 per month')), DIV({
	      style: {
	        paddingBottom: 60
	      }
	    }, A({
	      href: '/contact?form=start_enterprise',
	      target: '_blank',
	      style: plan_button_style
	    }, 'Contact Us')), P({
	      style: details_paragraph
	    }, "Create multiple Consider.it Unlimited Forums, optionally linked under a shared header customized for your \norganization."), P({
	      style: details_paragraph
	    }, "Three hours initial training and consulting package included. One hour per month thereafter."), P({
	      style: details_paragraph
	    }, "Access to dedicated community engagement specialist.")));
	  },
	  consulting: function() {
	    var plan_button_style, small_para_style;
	    small_para_style = {
	      fontSize: 16
	    };
	    plan_button_style = _.extend({}, big_button(), {
	      fontSize: 18,
	      fontWeight: 500,
	      padding: '10px 32px',
	      textAlign: 'center'
	    });
	    return DIV({
	      style: {
	        backgroundColor: 'white',
	        boxShadow: '0px -17px 27px 0px rgba(0,0,0,.14)',
	        position: 'relative',
	        zIndex: 1,
	        paddingTop: 50,
	        paddingBottom: 50
	      }
	    }, A({
	      name: 'consulting'
	    }), A({
	      name: 'testimonials'
	    }), DIV({
	      style: {
	        maxWidth: SAAS_PAGE_WIDTH(),
	        margin: '0 auto 40px auto'
	      }
	    }, H2({
	      style: _.extend({}, h1, {
	        color: '#303030',
	        fontSize: 50,
	        margin: '0 auto 40px auto',
	        maxWidth: 1100,
	        textAlign: 'center'
	      })
	    }, 'Need extra help facilitating a conversation? Hire us to help with your forum.'), DIV({
	      style: {
	        textAlign: 'center'
	      }
	    }, A({
	      href: '/contact?form=consulting_inquiry',
	      target: '_blank',
	      style: plan_button_style
	    }, 'Inquire about our consulting services'))), DIV({
	      style: {
	        marginTop: 20
	      }
	    }, TestimonialGrid({
	      testimonials: [testimonials.susie_pricing, testimonials.russ_pricing, testimonials.auryn_pricing]
	    })));
	  },
	  consultant_partnership: function() {
	    return DIV({
	      style: {
	        backgroundColor: '#F4F4F4',
	        borderTop: '1px solid #B1B1B1',
	        borderBottom: '1px solid #B1B1B1',
	        padding: '36px 0 44px 0'
	      }
	    }, A({
	      name: 'partnership'
	    }), H2({
	      style: {
	        fontWeight: 800,
	        color: 'black',
	        fontSize: 24,
	        textAlign: 'center',
	        color: '#303030',
	        marginBottom: 14
	      }
	    }, 'Consultant Partnership'), DIV({
	      style: {
	        fontSize: 16,
	        color: '#303030',
	        maxWidth: 500,
	        margin: 'auto'
	      }
	    }, "Are you a consultant? We ", SPAN({
	      style: {
	        color: '#EF3084'
	      }
	    }), SVG({
	      viewBox: "0 0 64 64",
	      width: 30,
	      height: 30,
	      style: {
	        verticalAlign: 'bottom'
	      }
	    }, G({
	      fill: "#ff5a79"
	    }, PATH({
	      d: "m28.3 32.2c1.3-7.9-11.5-20.7-22.3-10.3-12 11.7 7.2 37.1 8 40.1 2.6-.8 34.4-1.6 36-18.2 1.3-15.4-17.2-17.4-21.7-11.6"
	    }), PATH({
	      d: "m59.2 3.6c-6.8-5.1-13.1 3.1-11.7 7-3.3-2.9-13-.5-11.3 7.7 1.9 9.1 19.3 7.3 20.9 7.7.4-1.5 9.3-16.9 2.1-22.4"
	    }))), " consultants. We offer special training and support for \nconsultants looking to use Consider.it with their clients, as well as \naccess to pricing incentives you can pass onto clients. Please ", A({
	      href: '/contact?form=consultant_partnership',
	      style: {
	        textDecoration: 'underline'
	      }
	    }, "introduce yourself"), "."));
	  }
	});

	styles += ".embedded p {\n  margin-bottom: 12px;\n}\n\n.embedded emph {\n  font-style: italic;\n}\n\n.embedded strong {\n  font-weight: 700;\n}\n.embedded a {\n  text-decoration: underline;\n}\n\n.embedded ul { padding-top: 20px; padding-left: 18px; list-style: outside;}\n\n.embedded li { padding-bottom: 12px; }\n";

	FAQ = ReactiveComponent({
	  displayName: 'FAQ',
	  render: function() {
	    var compact, faq, header, question_set, set;
	    compact = browser.is_mobile || SAAS_PAGE_WIDTH() < 900;
	    return DIV({
	      style: {
	        backgroundColor: 'white',
	        padding: '80px 40px 40px 40px'
	      }
	    }, A({
	      name: 'faq'
	    }), DIV({
	      style: {
	        margin: 'auto',
	        maxWidth: 1100
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = [['Tech Questions', tech_qs], ['Pricing Questions', pricing_qs]];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        set = ref[i];
	        header = set[0];
	        question_set = set[1];
	        results.push(DIV({
	          style: {
	            display: compact ? 'block' : 'inline-block',
	            width: compact ? '100%' : '48%',
	            padding: '0 20px',
	            verticalAlign: 'top'
	          }
	        }, H1({
	          style: {
	            fontSize: 36,
	            fontWeight: 800,
	            marginBottom: 20
	          }
	        }, header), UL({
	          style: {
	            listStyle: 'none'
	          }
	        }, (function() {
	          var j, len1, results1;
	          results1 = [];
	          for (j = 0, len1 = question_set.length; j < len1; j++) {
	            faq = question_set[j];
	            results1.push(LI({
	              style: {
	                marginBottom: 20
	              }
	            }, faq.l ? A({
	              name: faq.l
	            }) : void 0, H2({
	              style: {
	                fontWeight: 700,
	                fontSize: 20,
	                marginBottom: 12
	              }
	            }, faq.q), DIV({
	              style: {
	                fontSize: 16,
	                color: '#303030',
	                fontWeight: 500
	              }
	            }, DIV({
	              className: 'embedded',
	              dangerouslySetInnerHTML: {
	                __html: faq.a
	              }
	            }))));
	          }
	          return results1;
	        })())));
	      }
	      return results;
	    })()));
	  }
	});

	tech_qs = [
	  {
	    l: 'customization',
	    q: "How can I brand my forum and give it my organization’s look and feel?",
	    a: "When you upgrade to an Unlimited or Enterprise plan, you have the option to work with us to create a customized look and feel. We cover that in the one hour setup call that comes with every Unlimited forum. See some <a href='/tour?feature=customization#features'>examples</a>."
	  }, {
	    l: 'civility',
	    q: "Can we moderate the forum and maintain civil discourse?",
	    a: "Yes. As a forum administrator, you have a number of options for hiding incivil and/or off-topic user posts. We’ve found an even more powerful mechanism though: a customizable user pledge that you can ask all participants in your forum to agree to when creating an account. It is amazing what setting expectations can do. Overall, we have found the structure of our forums lend themselves to more civil discourse. We have hosted city dialogues on very contentious issues without having to moderate a single comment. We also provide consulting services to help set best practices for facilitating civil, online discourse. "
	  }, {
	    l: 'access_control',
	    q: "Can I make my forum invite-only so only certain people can access it?",
	    a: "Yes. Once you create your forum you will be able to set the forum as private. Then only people who you invite can participate in the forum. You can set user roles to give people view-only access or the ability to respond. Furthermore, you can make specific questions invite-only."
	  }, {
	    l: 'profile_questions',
	    q: "I want to know more about participants in my forum so I can analyze the opinions. Can I ask about their age? If they’re a homeowner? If they’re a board member?",
	    a: "Yes, with an Unlimited forum. We can configure your forum to ask any number of specific questions when a participant creates a new account. This information can then be used to cross tabulate the results to explore the opinions of segments of your stakeholders. More info <a href='/tour?feature=profile_questions#features'>here</a>."
	  }, {
	    l: 'translation',
	    q: "Will my forum work in languages other than English?",
	    a: "Yes. First, Google Translate is enabled in the footer for all forums. This allows your participants to view your forum in any language that Google supports. It even supports multi-lingual forums. If you upgrade to Unlimited, we can make the Google Translate functionality more prominent. Second, we can translate the interface into a number of languages. This can provide a higher quality experience for communities whose members’ primary language isn’t English. The biggest language limitation is that our email notifications are currently not translated. "
	  }, {
	    l: 'traffic',
	    q: "How can I know what kind of traffic my forum is receiving?",
	    a: "At this time, we support integration with Google Analytics in our Unlimited Plan. All you do is set your Google Analytics tracking code. If you use a different analytics system, contact us and we can figure out if we can integrate with that system as well."
	  }, {
	    l: 'accessibility',
	    q: "Is Consider.it compliant with accessibility standards?",
	    a: "Yes, Consider.it is <a href='https://www.w3.org/WAI/intro/wcag.php'>WCAG</a> Level A compliant. <a href='/tour?feature=accessibility#features'>Learn more</a>."
	  }, {
	    l: 'vanity_url',
	    q: "Can I use a custom URL? Can I host the forum on my own server?",
	    a: "We can set up your forum to use a custom URL, but it will incur a monthly fee. At this time, we do not support self-hosting on your own server. "
	  }, {
	    l: 'saml',
	    q: "Do you support SAML single sign-on?",
	    a: "We have a rough implementation. If you have a strong need, we can develop it further for a fee."
	  }, {
	    l: 'mobile',
	    q: "Does Consider.it work on mobile?",
	    a: "Yes. The Consider.it website is responsive and works on most mobile devices. We do not currently offer a stand alone mobile app."
	  }, {
	    l: 'comparison',
	    q: "How is this different than a survey or a web forum?",
	    a: "<p>Some people think of a Consider.it forum as a combination of a survey and a forum. A survey is a one way flow of information. People respond in isolation and don’t interact with other survey takers. They don’t learn from each other. In a web forum, people interact with each other, but it’s hard to visualize the aggregate opinions of everyone on the forum. Standard web forums don’t provide focus to a conversation and can reward those who make the most contentious points. People can feel like their voice is being lost in the cacophony.</p><p>In a Consider.it forum, people can interact and discuss issues with structure <emph>and</emph> focus. Each person can quickly see the overall opinions of the group and consider pros and cons on each side of the argument. It’s hard to hijack a Consider.it conversation. The format encourages civil conversation. Give it a shot and see for yourself!</p>"
	  }
	];

	per_opinion = {
	  l: 'pay_per_opinion',
	  q: "What counts as an opinion? Why do you charge \"per opinion\" in the paid plans?",
	  a: "<p style='padding-bottom:8px'>An opinion is collected when someone slides and saves their position on a question in your forum. Pro/con points are not counted.</p> \n<div style='text-align:center'>\n  <img width='90%' src='" + (asset('product_page/opinions_count.png')) + "'>\n  <p style='padding-bottom:8px;font-style:italic'>27 opinions</p>\n</div>\n<p style='padding-bottom:8px'>We charge per opinion because it is fair to you \n– you pay only when you’re getting value from our service – \nand fair to us – we get compensated for a fraction of the value we provide you. \nSmall communities pay less. You don't pay during periods of inactivity.</p> \n<p>For comparison, the opinions collected at <a href='https://wsffn.consider.it' target='_blank'>https://wsffn.consider.it</a> that led to an adopted strategic plan cost $1200.</p>"
	};

	pricing_qs = [
	  {
	    l: 'free_forum',
	    q: "Can you explain how the Free Forum works?",
	    a: "You can <a href='/create_forum'>create a free forum</a> and use it for as long as you want. This forum is public by default, but you can make it invite-only. The forum comes with most of the standard features. The main limitation is that only the 25 most recent questions will be listed on the forum homepage. <a href='/contact?form=upgrade_to_unlimited'>Upgrade to the Unlimited Forum</a> if you want access to all the questions posted in your forum (or any of the other additional features with Unlimited, like a branded homepage)."
	  }, per_opinion, {
	    l: 'budget',
	    q: "How much can I expect to pay per month on the Unlimited plan? Can I set a monthly budget? ",
	    a: "Yes, we can work with you to set a monthly budget that makes sense for your use case if you need a hard cap. A monthly budget is the total amount you are willing to spend collecting opinions in a month. You will never be charged more than this monthly budget. You only pay for how much you use. For reference, a small non-profit engaging stakeholders for strategic planning might collect around 750 opinions over three months. A large city hosting a dialogue about an important topic may collect closer to 5000 opinions."
	  }, {
	    l: 'short_period',
	    q: "I only need the forum for a short period of time. How much will I pay?",
	    a: "For an Unlimited forum, you will pay a $250 setup fee to customize. Then you only pay for the opinions you collect. When you no longer need the forum, you can stop collecting opinions. You won’t pay anything while you’re not collecting opinions. "
	  }, {
	    l: 'consultant_partnership',
	    q: "I’m a consultant and want to set up forums for multiple clients. Can you help me? ",
	    a: "Yes. We work with consultants all the time. We can help you customize forums for each of your clients, or create a branded look for your consulting firm. <a href=\"/contact?form=consultant_partnership\">Get in touch</a> and we can talk. "
	  }, {
	    l: 'demo',
	    q: "Can I speak with someone about the plan options and get a demo?",
	    a: "Absolutely! We’re happy to <a href=\"/contact?form=request_demo\">set up a time to talk</a>."
	  }, {
	    l: 'discount',
	    q: "I want to use Consider.it for an innovative project that will benefit society but can’t afford the price. Can you offer a discount? ",
	    a: "Yes, we offer discounts for certain types of projects. We find that the free version meets most needs. We screen for projects that: (1) Can’t suffice with a free version and need an Unlimited plan; (2) Have some type of public benefit; and (3) Does not have a sponsoring organization with a budget that could afford our regular pricing. For reference, we find that even small nonprofit organizations can afford our pricing for most uses. Large open source projects without an anchoring company are a good example of a community to which we grant discounts. <a href=\"/contact?form=discount\">Apply here</a>."
	  }, {
	    l: 'cancelation',
	    q: "Can I cancel my plan at any time?",
	    a: "Yes. You can either close your forum and stop collecting opinions or contact us to delete your forum entirely. Either way, we don’t believe in locking customers into contracts. You only pay for the opinions you collect. "
	  }, {
	    l: 'downgrade',
	    q: "Can I switch my Unlimited plan to a free plan?",
	    a: "Yes, just <a href=\"/contact?form=general_inquiry\">contact us</a>. If you downgrade, the Free Forum’s 25 most recent question limitation will be applied to your forum, and you will lose access to the additional features. Any customizations will also be deactivated. If you later decide you want to switch back to Unlimited, you can do so at a 25% discount on the setup fee. "
	  }, {
	    l: 'refunds',
	    q: "What is your refund policy?",
	    a: "We don’t offer refunds on the setup fee or opinions you have collected. You can cancel your plan at anytime. If you feel we have made an error in billing or haven’t provided the service we promised, please let us know. "
	  }, {
	    l: 'invoice',
	    q: "Can you issue invoices and receive checks instead of a credit card? ",
	    a: "Yes, for customers spending more than $500 per month, we can issue invoices and receive checks."
	  }
	];


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	window.TestimonialGrid = ReactiveComponent({
	  displayName: 'TestimonialGrid',
	  render: function() {
	    var expanded, max_testimonials, min_pixels_per, odd, quote_row, the_testimonials, top, user_row, w;
	    w = Math.min(WINDOW_WIDTH(), this.props.maxWidth || 1100);
	    expanded = this.local.expanded;
	    if (this.props.top == null) {
	      top = true;
	    } else {
	      top = this.props.top;
	    }
	    the_testimonials = this.props.testimonials;
	    min_pixels_per = 350;
	    max_testimonials = w / min_pixels_per;
	    if (max_testimonials < the_testimonials.length) {
	      the_testimonials = the_testimonials.slice(0, +(max_testimonials - 1) + 1 || 9e9);
	    }
	    odd = the_testimonials.length % 2 === 1;
	    user_row = (function(_this) {
	      return function() {
	        var idx, t;
	        return DIV({
	          style: css.crossbrowserify({
	            display: 'flex'
	          })
	        }, (function() {
	          var i, len, results;
	          results = [];
	          for (idx = i = 0, len = the_testimonials.length; i < len; idx = ++i) {
	            t = the_testimonials[idx];
	            results.push(DIV({
	              style: css.crossbrowserify({
	                flex: 1,
	                padding: '0px 16px',
	                opacity: expanded && expanded !== t ? .1 : void 0
	              })
	            }, this.user_credentials({
	              testimonial: t,
	              left: odd || idx < the_testimonials.length / 2,
	              top: top,
	              bg_color: this.props.bubble_color || considerit_gray,
	              right_side: idx > the_testimonials.length / 2
	            })));
	          }
	          return results;
	        }).call(_this));
	      };
	    })(this);
	    quote_row = (function(_this) {
	      return function() {
	        var idx, t;
	        return DIV({
	          style: css.crossbrowserify({
	            display: 'flex'
	          })
	        }, (function() {
	          var i, len, results;
	          results = [];
	          for (idx = i = 0, len = the_testimonials.length; i < len; idx = ++i) {
	            t = the_testimonials[idx];
	            if (expanded && expanded !== t) {
	              continue;
	            }
	            results.push(this.quote_bubble({
	              key: this.local.key,
	              testimonial: t,
	              top: top,
	              bg_color: this.props.bubble_color || considerit_gray,
	              italic: this.props.italic
	            }));
	          }
	          return results;
	        }).call(_this));
	      };
	    })(this);
	    return DIV({
	      style: {
	        margin: 'auto',
	        maxWidth: w
	      }
	    }, top ? [user_row(), quote_row()] : [quote_row(), user_row()]);
	  },
	  user_credentials: function(opts) {
	    var avatar_and_mouth, expanded, left, mouth_dir_left, quote_img, t, top;
	    t = opts.testimonial;
	    expanded = this.local.expanded === t;
	    left = opts.left;
	    mouth_dir_left = left && !(expanded && opts.right_side);
	    top = opts.top;
	    quote_img = avatar_and_mouth = (function(_this) {
	      return function() {
	        var size;
	        size = 75;
	        return DIV({
	          style: {
	            display: 'inline-block'
	          }
	        }, IMG({
	          ref: "avatar-" + (t.name.replace(' ', '-')),
	          src: t.avatar,
	          style: {
	            height: size,
	            width: size,
	            verticalAlign: 'middle'
	          }
	        }), DIV({
	          style: css.crossbrowserify({
	            transform: !top ? "rotate(180deg) " + (mouth_dir_left ? 'scaleX(-1)' : '') : "" + (!mouth_dir_left ? 'scaleX(-1)' : ''),
	            position: 'absolute',
	            left: left ? size / 2 + (mouth_dir_left ? 20 : 0) : void 0,
	            right: !left ? size / 2 + 20 : void 0,
	            bottom: top ? -30 : void 0,
	            top: !top ? -30 : void 0,
	            zIndex: 2
	          })
	        }, Bubblemouth({
	          apex_xfrac: 0,
	          width: 30,
	          height: 30,
	          fill: opts.bg_color,
	          stroke: 'transparent',
	          stroke_width: 0,
	          box_shadow: {
	            dx: top ? -3 : 3,
	            dy: 0,
	            stdDeviation: top ? 1 : 2,
	            opacity: top ? .15 : .4
	          }
	        })));
	      };
	    })(this);
	    return DIV({
	      style: {
	        position: 'relative',
	        top: 20,
	        padding: '12px 20px',
	        float: !left ? 'right' : void 0,
	        whiteSpace: 'nowrap'
	      }
	    }, left && t.avatar ? avatar_and_mouth() : void 0, DIV({
	      style: {
	        display: 'inline-block',
	        padding: '0 16px',
	        verticalAlign: 'middle',
	        textAlign: !left ? 'right' : void 0
	      }
	    }, DIV({
	      style: {
	        fontSize: 20
	      }
	    }, t.name), t.organization ? DIV({
	      style: {
	        fontSize: 18
	      }
	    }, t.organization) : void 0, t.role ? DIV({
	      style: {
	        fontSize: 12
	      }
	    }, t.role) : void 0), !left && t.avatar ? avatar_and_mouth() : void 0);
	  },
	  quote_bubble: function(opts) {
	    var expanded, quote, t;
	    t = opts.testimonial;
	    expanded = this.local.expanded === t;
	    quote = expanded ? opts.long_quote || t.long_quote : opts.short_quote || t.short_quote;
	    return DIV({
	      style: css.crossbrowserify({
	        padding: '36px 50px',
	        position: 'relative',
	        backgroundColor: opts.bg_color,
	        boxShadow: '#b5b5b5 0 1px 1px 0px',
	        borderRadius: 64,
	        marginTop: top ? 20 + 24 : void 0,
	        marginBottom: !top ? 20 : 4,
	        flex: 1,
	        marginRight: 16,
	        marginLeft: 16
	      })
	    }, DIV({
	      className: 'embedded',
	      style: {
	        fontSize: expanded ? 18 : 16,
	        fontStyle: !expanded && opts.italic ? 'italic' : void 0
	      }
	    }, DIV({
	      dangerouslySetInnerHTML: {
	        __html: quote
	      }
	    })), t.long_quote && !this.props.hide_full ? this.readmore({
	      testimonial: t
	    }) : void 0);
	  },
	  readmore: function(opts) {
	    var onclick, t;
	    t = opts.testimonial;
	    onclick = (function(_this) {
	      return function() {
	        if (_this.local.expanded === t) {
	          _this.local.expanded = null;
	        } else {
	          _this.local.expanded = t;
	        }
	        return save(_this.local);
	      };
	    })(this);
	    return BUTTON({
	      style: {
	        backgroundColor: 'transparent',
	        border: 'none',
	        color: 'black',
	        textDecoration: 'underline',
	        paddingTop: 12,
	        paddingLeft: 0
	      },
	      onClick: onclick,
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 16 || e.which === 32) {
	            e.preventDefault();
	            return onclick();
	          }
	        };
	      })(this)
	    }, this.local.expanded === t ? "read less from " + (t.name.split(' ')[0]) : "read more from " + (t.name.split(' ')[0]));
	  },
	  componentDidMount: function() {
	    this.local.dummy = true;
	    return save(this.local);
	  }
	});

	window.testimonials = {
	  susie: {
	    name: 'Susie Philipsen',
	    role: "Senior Public Relations Specialist",
	    organization: "City of Seattle",
	    avatar: asset('product_page/susie.png'),
	    short_quote: "Working with the Consider.it team on <a href='https://hala.consider.it'>Seattle’s dialogue about Housing Affordability</a> has been a fantastic experience! We’ve created a great feedback loop with residents via Consider.it. Residents \nare acknowledging the information we are providing them, learning from it, and even thanking us. If you’re looking to create quality online dialogues, Consider.it is an excellent choice.",
	    long_quote: "<p>Working with the Consider.it team on <a href='https://hala.consider.it'>Seattle’s dialogue about Housing Affordability</a> has been a fantastic experience. They bring far more to the table than technical skills – they think deeply about how the tool is going to be received and help us build a better dialogue using that knowledge. Furthermore, the Consider.it team is very responsive - the back and forth communication has been very easy.</p> \n\n<p>Some of the ways the Consider.it team helped our team include:</p>\n\n<ul>\n<li><strong>Framing content for a general audience</strong>. We spent a lot of time writing technically correct questions, but the Consider.it team helped us recognize how difficult these questions are to understand. They helped us refine all the content. This included setting expectations about how residents’ feedback fits into the larger process. </li>\n\n<li><strong>Translating our needs into a good digital experience</strong>. Being new to online dialogue, the consider.it team helped us focus our goals for information gathering. We wanted to collect demographic information so we could assess outreach effectiveness. We collaborated to identify the minimal information to collect from residents to answer critical questions.</li>\n\n<li><strong>Outreach and recruitment</strong>. The consider.it team helps us understand which populations are providing feedback. I can then focus our online advertising on recruiting people from underrepresented neighborhoods and groups.</li>\n\n<li><strong>How to engage with residents</strong>. The team encouraged us to engage directly with residents by responding to questions and concerns online. This support made me more proactive in answering questions. When I don’t know the answer, I reach out to the technical experts and ask them to respond that day so we can keep the conversation going. Residents are acknowledging the information we are providing them, learning from it, and even thanking us.</li>\n\n</ul>\n<p>If you’re looking to create quality online dialogues, Consider.it is an excellent choice.</p>"
	  },
	  russ: {
	    name: 'Russ Lehman',
	    role: "Executive Director",
	    organization: "WSFFN",
	    avatar: asset('product_page/Russ.png'),
	    short_quote: "When we embarked on rebranding, I was daunted with the task of engaging\nconstituents across the state. As a small non-profit, we didn’t have the funds to\nreach everyone in-person. With Consider.it, we could engage far more people for a\ncost we could afford. Beyond the great tool, the Consider.it team was incredibly\nknowledgeable, creative, thoughtful, and available in helping craft an engagement strategy.",
	    long_quote: "<p>\n  The Consider.it team helped us structure a lightweight dialogue with all our stakeholders. We got legitimacy and momentum for \n  our new direction, without the hassle of bringing everyone together physically.</p> \n\n<p>Some of the ways the Consider.it team helped us include:</p>\n\n<ul>\n<li><strong>Creation of questions</strong> to yield the most valuable information.</li>\n\n<li><strong>Designing a multi-phase process</strong> that first used Consider.it to engage our statewide stakeholders, then to discuss results with our board and eventually leading to a board vote at our annual retreat.</li>\n\n<li><strong>Advice on how to interact with stakeholders</strong> to yield even more substantive results and maintain civil discourse.</li>\n\n<li><strong>Interpretation of responses</strong> to gain deeper insight and assist with reporting lessons back to our board and stakeholders.</li>\n\n</ul>"
	  },
	  pierre: {
	    name: 'Pierre-Elouan Réthoré',
	    role: 'Senior Wind Energy Researcher',
	    organization: "Danish Technical University",
	    avatar: asset('product_page/pierre.png'),
	    short_quote: "We had a nearly 50/50 deadlocked split in our housing community. After we started using Consider.it, \npeople could clearly express the reasons behind their opinions, and see other’s reasons. We were able \nto work out a compromise. That’s the first time where I felt like democracy was actually working."
	  },
	  auryn: {
	    name: 'Auryn Macmillan',
	    role: 'Cofounder',
	    organization: "DAOhub",
	    avatar: asset('product_page/auryn.png'),
	    short_quote: "Consider.it’s careful design choices were critical for not only aggregating \ncommunity opinions, but also in understanding the \nrationale. The ability to get a feel for both the gestalt and the \ngranular details of an issue within the one view is an incredible \nachievement and was a vital part of our community’s decision making \nprocess.",
	    long_quote: "\n<p>At DAOhub, a group of volunteers came together to create a home for the communities of a radical new form of human interaction, Decentralised Autonomous Organisations (or DAOs for short). We set up a <a href='http://discourse.org' target=\"_blank\">Discourse</a> forum to act as our base means of communication. However one of the major challenges we faced was effectively aggregating community sentiment on issues and proposals. This was vital for the DAO to function properly. The simple polls that ship with Discourse were somewhat limited and did not quite fulfill the need.</p>\n<p>Luckily, Consider.it beats the hell out of simple polls! It is a fantastic tool for gauging the opinion of a large number of users, while not losing sight of the individuals.</p>\n<p>If effectively gauging the opinion/sentiment of your community is something that is important or necessary for your business/product/community, then the team at Consider.it would be an invaluable partner. Their product and advice is second to none. Seriously, these guys are flat out awesome. Incredibly responsive and receptive to suggestions, and, as is evident by the nuance of their platform, they really have a fantastic grasp on the needs of web based and decentralised communities.</p>"
	  },
	  sheri: {
	    name: 'Sheri Richardson',
	    role: 'President',
	    organization: 'Guide Dog Users of WA State',
	    short_quote: 'I am blind and use assistive technology to read information on a computer screen. Consider.it works well with my screen reading software and allows me the opportunity to fully participate in my city’s decision making process in the same way all others can! I appreciate Consider.it’s hard work making their website fully accessible to me and other blind computer users.'
	  }
	};

	testimonials.susie_pricing = _.extend({}, testimonials.susie, {
	  short_quote: "They bring far more to the table than technical skills – their team thinks deeply about how Consider.it is going to be received and helped us build a better public dialogue using that knowledge, such as by:<ul><li>framing content for a general audience</li><li>teaching best practices for engaging residents</li><li>creating new features to support our use case</li></ul>"
	});

	testimonials.auryn_pricing = _.extend({}, testimonials.auryn, {
	  short_quote: "The Consider.it team is incredibly receptive to suggestions, and, as is evident by the nuance of their platform, they really have a fantastic grasp on the needs of web based and decentralised communities. They:<ul><li>helped restructure our organizational processes</li><li>designed a custom forum homepage</li><li>created a rich custom embed of consider.it</li></ul>"
	});

	testimonials.russ_pricing = _.extend({}, testimonials.russ, {
	  short_quote: "Beyond the great tool, the Consider.it team was extremely knowledgeable and available in helping craft an engagement strategy. They helped us:<ul><li>create clear, valuable questions</li><li>design a multi-phase engagement process</li><li>improve interactions with our network</li><li>interpret responses</li></ul>"
	});


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var Basics, Feature, Features, Research, paid_features, steps, tab_features;

	window.Tour = ReactiveComponent({
	  displayName: 'Tour',
	  render: function() {
	    var compact;
	    compact = browser.is_mobile || SAAS_PAGE_WIDTH() < 700;
	    return DIV(null, Basics(), DIV({
	      style: {
	        position: 'relative',
	        zIndex: 2,
	        backgroundColor: 'white',
	        boxShadow: '0px -17px 27px 0px rgba(0,0,0,.14)',
	        paddingTop: 30,
	        paddingBottom: 70
	      }
	    }, Features({
	      features: tab_features
	    }), Research()));
	  }
	});

	steps = [
	  {
	    header: 'Create a forum for your community',
	    beginning: "Your new Consider.it forum will \n     initially be empty and lonely! That’s ok, it will soon be humming \n     with activity. Think about who you’re seeking to engage. Then post questions or \nideas you’d like your community to think through. ",
	    desc: "Now you’re ready \nto invite your community! Just share the forum link with your community via email or social media. ",
	    movie: 'step1-produced',
	    browser_loc: '',
	    movie_caption: 'Creating your own forum'
	  }, {
	    header: 'Stakeholders express considered opinions',
	    beginning: 'Consider.it gets your community on the same page (literally). Areas of disagreement and agreement are clear, as well as the underlying rationale, so you can take more effective action.',
	    desc: "Consider.it helps each participant create a considered opinion that \nexpresses <b>what they believe</b> (on a sliding scale) and <b>why</b> (their \nmost critical pros and cons). Each pro or con point a participant \nadds contributes to future participants' understanding. \nYour community gets smarter together. ",
	    movie: 'step2-produced',
	    browser_loc: 'https://washington-policy-coalition.consider.it',
	    movie_caption: 'Community deliberation'
	  }, {
	    header: 'Slice & dice opinions for deep understanding',
	    beginning: 'Explore what your community thinks! For example, you can easily learn the reservations of those who oppose a proposal. Perhaps 80% of those whom oppose share two concerns that can be resolved, making the pathway to consensus clear!',
	    desc: "<p>Those are the basics! It is now up to you and your community to use this mutual understanding to make decisions and advance your mission.</p> \n<p><b>Perhaps you'd like to <a href=\"/create_forum\">start your own forum</a> now?</b></p> ",
	    movie: 'step3-produced',
	    browser_loc: 'https://washington-policy-coalition.consider.it',
	    movie_caption: 'Slicing & dicing opinions'
	  }
	];

	Basics = ReactiveComponent({
	  displayName: 'Basics',
	  render: function() {
	    var activate, asset_path, format, idx, inactivate, play_video, step;
	    if (this.local.current_step == null) {
	      this.local.current_step = 0;
	    }
	    return DIV({
	      style: {
	        width: SAAS_PAGE_WIDTH(),
	        margin: 'auto',
	        padding: '40px 12px 60px 12px',
	        minHeight: 870
	      }
	    }, A({
	      name: 'basics'
	    }), H1({
	      style: {
	        fontSize: 50,
	        fontWeight: 800,
	        color: 'white',
	        textAlign: 'center',
	        textShadow: '0px 2px 4px rgba(0,0,0,.2)'
	      }
	    }, "Let’s step through the basics"), DIV({
	      style: {
	        width: '100%',
	        zIndex: 2,
	        position: 'relative',
	        top: 2,
	        marginTop: 28,
	        marginBottom: 42
	      }
	    }, TABLE({
	      ref: 'tabs',
	      role: 'tablist',
	      style: {
	        width: SAAS_PAGE_WIDTH(),
	        maxWidth: 860,
	        margin: 'auto',
	        listStyle: 'none'
	      }
	    }, TBODY(null, TR(null, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = steps.length; i < len; idx = ++i) {
	        step = steps[idx];
	        results.push((function(_this) {
	          return function(step, idx) {
	            var current;
	            current = idx === _this.local.current_step;
	            return TD({
	              tabIndex: 0,
	              role: 'tab',
	              style: {
	                opacity: !current ? 0.4 : void 0,
	                fontSize: 25,
	                fontWeight: 700,
	                padding: '0px 16px',
	                color: 'white',
	                cursor: 'pointer',
	                fontStyle: 'oblique',
	                position: 'relative',
	                textDecoration: current ? 'underline' : void 0,
	                width: '33%',
	                position: 'relative'
	              },
	              'aria-controls': 'step',
	              'aria-selected': current,
	              onKeyDown: function(e) {
	                if (e.which === 13 || e.which === 32) {
	                  e.currentTarget.click();
	                  return e.preventDefault();
	                }
	              },
	              onClick: function() {
	                _this.local.current_step = idx;
	                _this.local.playing = null;
	                _this.local.finished = false;
	                save(_this.local);
	                return document.activeElement.blur();
	              }
	            }, DIV({
	              style: {
	                position: 'absolute',
	                left: 4
	              }
	            }, (idx + 1) + "."), DIV({
	              style: {
	                paddingLeft: 16
	              }
	            }, step.header));
	          };
	        })(this)(step, idx));
	      }
	      return results;
	    }).call(this))))), DIV({
	      id: 'step'
	    }, steps[this.local.current_step].beginning ? DIV({
	      className: 'embedded',
	      style: {
	        paddingBottom: 24,
	        fontSize: 22,
	        color: 'white',
	        maxWidth: 675,
	        margin: 'auto',
	        fontStyle: 'oblique'
	      },
	      dangerouslySetInnerHTML: {
	        __html: steps[this.local.current_step].beginning
	      }
	    }) : void 0, steps[this.local.current_step].img ? Webframe({
	      browser_loc: steps[this.local.current_step].browser_loc,
	      width: 675
	    }, DIV({
	      style: {
	        width: '90%',
	        margin: 'auto'
	      }
	    }, IMG({
	      src: asset(steps[this.local.current_step].img),
	      style: {
	        width: '100%'
	      }
	    }))) : steps[this.local.current_step].movie ? (activate = (function(_this) {
	      return function() {
	        _this.local.hovering = true;
	        return save(_this.local);
	      };
	    })(this), inactivate = (function(_this) {
	      return function() {
	        _this.local.hovering = false;
	        return save(_this.local);
	      };
	    })(this), Webframe({
	      browser_loc: steps[this.local.current_step].browser_loc,
	      width: 675,
	      dummy: this.local.hovering,
	      dummy2: this.local.current_step,
	      dummy3: this.local.playing,
	      key: this.local.current_step
	    }, DIV({
	      style: {
	        width: '100%',
	        margin: 'auto',
	        position: 'relative',
	        backgroundColor: 'black'
	      }
	    }, VIDEO({
	      key: this.local.current_step,
	      ref: 'video',
	      preload: true,
	      loop: false,
	      autoPlay: false,
	      controls: this.local.hovering && this.local.playing ? true : null,
	      style: _.extend({}, (!this.local.playing ? css.grayscale({}) : {}), {
	        position: 'relative',
	        width: '100%',
	        height: 3 / 7 * 675,
	        display: 'block',
	        opacity: !this.local.playing ? .4 : void 0,
	        backgroundColor: !this.local.playing ? 'black' : void 0
	      }),
	      onMouseEnter: activate,
	      onMouseLeave: inactivate,
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            if (_this.local.hovering) {
	              return inactivate();
	            } else {
	              return activate();
	            }
	          }
	        };
	      })(this)
	    }, (function() {
	      var i, len, ref, results;
	      ref = ['mp4', 'webm'];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        format = ref[i];
	        asset_path = asset("product_page/" + steps[this.local.current_step].movie + "." + format);
	        if ((asset_path != null ? asset_path.length : void 0) > 0) {
	          results.push(SOURCE({
	            key: format,
	            src: asset_path,
	            type: "video/" + format
	          }));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }).call(this), "Your browser does not support the video element."), !this.local.playing ? (play_video = (function(_this) {
	      return function() {
	        var e;
	        e = function() {
	          _this.local.playing = false;
	          _this.local.finished = true;
	          save(_this.local);
	          return _this.refs.video.getDOMNode().removeEventListener('ended', e);
	        };
	        _this.refs.video.getDOMNode().play();
	        _this.refs.video.getDOMNode().addEventListener('ended', e);
	        _this.local.playing = true;
	        _this.local.hovering = true;
	        _this.local.finished = false;
	        return save(_this.local);
	      };
	    })(this), DIV({
	      style: {
	        backgroundColor: 'rgb(162, 98, 162)',
	        borderRadius: 8,
	        boxShadow: '0px 2px 4px rgba(0,0,0,.4)',
	        position: 'absolute',
	        top: '35%',
	        left: '50%',
	        marginLeft: -326 / 2,
	        color: 'white',
	        cursor: 'pointer',
	        padding: '14px 22px'
	      },
	      onClick: play_video,
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            return play_video();
	          }
	        };
	      })(this)
	    }, !this.local.finished ? SVG({
	      width: 34,
	      height: 41,
	      viewBox: "25 25 34 41"
	    }, POLYGON({
	      stroke: "none",
	      fill: "#FFFFFF",
	      transform: "translate(42.000000, 45.500000) rotate(90.000000) translate(-42.000000, -45.500000) ",
	      points: "42 29 62 62 22 62"
	    })) : SPAN({
	      style: {
	        color: 'white',
	        fontSize: 50
	      }
	    }, '⟲'), DIV({
	      style: {
	        display: 'inline-block',
	        paddingLeft: 24
	      }
	    }, DIV({
	      style: {
	        fontWeight: 600,
	        fontSize: 16
	      }
	    }, this.local.finished ? 'Replay' : "Play (silent) video"), DIV({
	      style: {
	        fontSize: 20,
	        paddingTop: 2
	      }
	    }, steps[this.local.current_step].movie_caption)))) : void 0))) : void 0, DIV({
	      className: 'embedded',
	      style: {
	        paddingTop: 32,
	        fontSize: 22,
	        color: 'white',
	        maxWidth: 675,
	        margin: 'auto',
	        fontStyle: 'oblique'
	      },
	      dangerouslySetInnerHTML: {
	        __html: steps[this.local.current_step].desc
	      }
	    }), this.local.current_step < steps.length - 1 ? DIV({
	      style: {
	        textAlign: 'right',
	        maxWidth: 675,
	        margin: 'auto'
	      }
	    }, BUTTON({
	      style: {
	        backgroundColor: 'transparent',
	        border: 'none',
	        color: 'white',
	        fontSize: 28,
	        fontWeight: 800
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.current_step++;
	          _this.local.playing = null;
	          save(_this.local);
	          return $(_this.refs.tabs.getDOMNode()).ensureInView({
	            scroll: true
	          });
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            _this.local.current_step++;
	            _this.local.playing = null;
	            _this.local.finished = false;
	            save(_this.local);
	            $(_this.refs.tabs.getDOMNode()).ensureInView({
	              scroll: true
	            });
	            e.stopPropagation();
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, SPAN({
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'Next step'), ' >')) : void 0));
	  }
	});

	Features = ReactiveComponent({
	  displayName: 'Features',
	  render: function() {
	    var base, current_feature, f, feature, i, idx, len, loc, ref;
	    loc = fetch('location');
	    if ((base = loc.query_params).feature == null) {
	      base.feature = this.props.features[0].id;
	    }
	    ref = this.props.features;
	    for (i = 0, len = ref.length; i < len; i++) {
	      f = ref[i];
	      if (f.id === loc.query_params.feature) {
	        current_feature = f;
	      }
	    }
	    return DIV({
	      id: 'features',
	      style: {
	        minWidth: 600
	      }
	    }, H2({
	      style: {
	        fontSize: 42,
	        fontWeight: 800,
	        padding: '60px 20px 32px 20px',
	        fontStyle: 'oblique',
	        textAlign: 'center'
	      }
	    }, SAAS_PAGE_WIDTH() < 800 ? SPAN({
	      style: {
	        color: primary_color()
	      }
	    }, 'Does Consider.it offer...') : [
	      SPAN({
	        style: {
	          color: '#8D8E8D'
	        }
	      }, 'Ok, I get the basics,'), SPAN({
	        style: {
	          color: primary_color()
	        }
	      }, ' but does Consider.it offer...')
	    ]), TABLE({
	      style: {
	        marginLeft: 60
	      }
	    }, TBODY(null, TR(null, TD({
	      style: {
	        paddingLeft: 0,
	        paddingRight: 0
	      }
	    }, UL({
	      role: 'tablist',
	      style: {
	        listStyle: 'none'
	      }
	    }, (function() {
	      var j, len1, ref1, results;
	      ref1 = this.props.features;
	      results = [];
	      for (idx = j = 0, len1 = ref1.length; j < len1; idx = ++j) {
	        feature = ref1[idx];
	        results.push((function(_this) {
	          return function(feature, idx) {
	            var current;
	            current = feature === current_feature;
	            return LI({
	              tabIndex: 0,
	              role: 'tab',
	              style: {
	                display: 'block',
	                fontSize: 28,
	                fontWeight: 800,
	                padding: '12px 24px 12px 12px',
	                cursor: 'pointer',
	                fontStyle: 'oblique',
	                position: 'relative',
	                textAlign: 'right',
	                color: current ? primary_color() : '#d1d1d1',
	                textTransform: 'lowercase',
	                backgroundColor: current ? '#EFEFEF' : void 0
	              },
	              'aria-controls': 'features_cell',
	              'aria-selected': current,
	              onKeyDown: function(e) {
	                if (e.which === 13 || e.which === 32) {
	                  e.currentTarget.click();
	                  return e.preventDefault();
	                }
	              },
	              onClick: function(e) {
	                e.stopPropagation();
	                e.preventDefault();
	                loc.query_params.feature = feature.id;
	                save(loc);
	                return document.activeElement.blur();
	              }
	            }, feature.label + '?');
	          };
	        })(this)(feature, idx));
	      }
	      return results;
	    }).call(this))), TD({
	      id: 'features_cell',
	      style: {
	        backgroundColor: '#EFEFEF',
	        paddingTop: 24,
	        paddingBottom: 24
	      }
	    }, Feature({
	      key: current_feature.label,
	      feature: current_feature
	    }))))), DIV({
	      className: 'embedded',
	      style: {
	        fontSize: 18,
	        fontStyle: 'italic',
	        padding: '18px 60px',
	        color: '#777',
	        textAlign: 'center'
	      },
	      dangerouslySetInnerHTML: {
	        __html: "If you don’t \nsee a feature you need listed above, \n<a href='/contact'>reach out and ask</a> about it!"
	      }
	    }));
	  }
	});

	Feature = ReactiveComponent({
	  displayName: 'Feature',
	  render: function() {
	    var activate, asset_path, boxShadow, feature, format, has_media, inactivate, is_gif, sty;
	    feature = this.props.feature;
	    has_media = !!feature.img || !!feature.video || !!feature.testimonial;
	    activate = (function(_this) {
	      return function() {
	        _this.local.hovering = true;
	        return save(_this.local);
	      };
	    })(this);
	    inactivate = (function(_this) {
	      return function() {
	        _this.local.hovering = false;
	        return save(_this.local);
	      };
	    })(this);
	    return DIV({
	      className: 'feature',
	      'data-id': feature.id,
	      style: {
	        position: 'relative'
	      }
	    }, A({
	      name: feature.id
	    }), DIV({
	      style: {
	        maxWidth: 800,
	        margin: 'auto',
	        padding: '0 48px'
	      }
	    }, feature.html ? DIV({
	      className: 'embedded',
	      style: {
	        fontSize: 20,
	        color: '#666',
	        fontWeight: 500
	      },
	      dangerouslySetInnerHTML: {
	        __html: feature.html
	      }
	    }) : void 0, feature.paid ? DIV({
	      style: {
	        paddingTop: 18,
	        fontSize: 20,
	        color: primary_color(),
	        paddingBottom: 12
	      }
	    }, "Available in the ", A({
	      href: '/pricing',
	      style: {
	        textDecoration: 'underline',
	        fontWeight: 700
	      }
	    }, 'Unlimited or Enterprise plan')) : void 0, has_media ? (boxShadow = !feature.testimonial ? '0 1px 4px rgba(0,0,0,.25)' : null, DIV({
	      style: {
	        verticalAlign: 'top',
	        lineHeight: 0,
	        margin: '8px auto 20px auto'
	      }
	    }, feature.img ? (is_gif = feature.img.indexOf('.gif') > -1, sty = {
	      width: '100%',
	      backgroundColor: 'white',
	      transition: is_gif ? 'opacity 500ms' : void 0,
	      boxShadow: boxShadow,
	      transition: 'box-shadow 500ms'
	    }, IMG({
	      src: feature.img,
	      style: sty
	    })) : feature.video ? VIDEO({
	      ref: 'video',
	      preload: true,
	      loop: true,
	      autoPlay: true,
	      controls: this.local.hovering ? true : null,
	      style: {
	        position: 'relative',
	        width: Math.min(SAAS_PAGE_WIDTH() - 80, 800, this.local.video_height * 1920 / 1080),
	        height: Math.min(1080 / 1920 * (SAAS_PAGE_WIDTH() - 80), 800 * 1080 / 1920, this.local.video_height || 0),
	        boxShadow: boxShadow,
	        transition: 'box-shadow 500ms',
	        display: 'block'
	      },
	      onMouseEnter: activate,
	      onMouseLeave: inactivate,
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            if (_this.local.hovering) {
	              return inactivate();
	            } else {
	              return activate();
	            }
	          }
	        };
	      })(this)
	    }, (function() {
	      var i, len, ref, results;
	      ref = ['mp4', 'webm'];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        format = ref[i];
	        asset_path = asset("product_page/" + feature.video + "." + format);
	        if ((asset_path != null ? asset_path.length : void 0) > 0) {
	          results.push(SOURCE({
	            key: format,
	            src: asset_path,
	            type: "video/" + format
	          }));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    })(), "Your browser does not support the video element.") : feature.testimonial ? DIV({
	      style: {
	        marginTop: 32
	      }
	    }, DIV({
	      style: {
	        fontWeight: 400,
	        fontSize: 22,
	        fontStyle: 'italic',
	        color: '#666'
	      }
	    }, feature.testimonial.short_quote), DIV({
	      style: {
	        padding: '12px 16px',
	        verticalAlign: 'middle',
	        textAlign: 'right'
	      }
	    }, DIV({
	      style: {
	        fontSize: 20,
	        whiteSpace: 'nowrap'
	      }
	    }, feature.testimonial.name), DIV({
	      style: {
	        fontSize: 16,
	        whiteSpace: 'nowrap'
	      }
	    }, feature.testimonial.role, ', ', feature.testimonial.organization))) : void 0)) : void 0));
	  },
	  componentDidMount: function() {
	    if (this.refs.video && (this.local.video_height == null)) {
	      return this.local.video_height = this.refs.video.getDOMNode().parentNode.offsetWidth * 1080 / 1920;
	    }
	  }
	});

	tab_features = [
	  {
	    id: 'moderation',
	    label: 'Comment moderation',
	    html: "<p>As a forum administrator, you have a number of options for hiding incivil and/or off-topic user posts using our moderation interface.</p>\n<p>But explicit moderation is usually unnecessary. We’ve found an even more powerful mechanism: a civility pledge that you can ask all forum participants to agree to upon account creation. It is amazing what setting expectations can do!</p> \n<p>Moreover, <a href='#research'>academic studies</a> indicate that the structure of Consider.it forums lead to more civil discourse, so you may not have to worry. We have <a href='/examples'>hosted dialogues on very contentious issues</a> without having to moderate a single comment.</p> \n<p>If you are still apprehensive about civility, <a href='/contact?form=consulting_inquiry'>contact us</a> and we can help you work through how to facilitate civil online discourse in your forum.</p>",
	    img: asset('product_page/moderation.png'),
	    paid: true
	  }, {
	    id: 'customization',
	    label: 'Custom look & feel',
	    html: 'We can work with you to design and implement a forum with the look and feel that you want. Moreover, we have a number of homepage templates that can organize your community’s ideas to best meet your needs.',
	    img: asset('product_page/customize_homepage.gif'),
	    paid: true
	  }, {
	    id: 'private_forums',
	    label: 'Private forums',
	    html: "<p>By default, your Consider.it forum is public – anyone with a link can access your forum.\nWith Private Forums, you can lock down your forum to only those you invite via email.</p>",
	    img: asset('product_page/private_forum.png')
	  }, {
	    id: 'profile_questions',
	    label: 'Custom user info',
	    html: "<p>You can ask for additional information from your stakeholders when they create an account on your forum.</p>\n<p>For example, you can ask if they are a Donating Member of your organization. Or you can ask if they are a homeowner. Or you can ask demographic questions like age and race.</p>\n<p>This information can then be used in our <a href='/tour?feature=opinion_analytics#features'>opinion analytics</a> for understanding what specific stakeholder segments think and why.</p>\n<p>The information is also available in <a href='/tour?feature=data_export#features'>data exports</a>.</p>",
	    video: 'profile_questions',
	    paid: true
	  }, {
	    id: 'opinion_analytics',
	    label: 'Opinion analytics',
	    html: 'You may wish to filter opinions based upon user characteristics or some other differentiator. For example, you might want to learn what Board Members think of a proposal. Or perhaps you want to learn what renters think of a planning proposal, filtering out homeowners. We can configure your forum so you can understand what different stakeholder segments think and why.',
	    video: 'analytics',
	    paid: true
	  }, {
	    id: 'accessibility',
	    label: 'Disability accessibility',
	    html: "<p>It is important to make our technologies accessible for as many people as possible, so everyone can equitably participate.</p>\n<p>Consider.it is <strong>Level A compliant</strong> with the <a href=\"https://www.w3.org/WAI/intro/wcag.php\" target=\"_blank\" style=\"text-decoration: underline;\">Web Content Accessibility Guidelines (WCAG)</a>. Read our <a target=\"_blank\" href=\"https://docs.google.com/document/d/e/2PACX-1vS5-8UQlzGYY5Su38VDUXDbiAy2S72ZARfU8-Xmi-Nxo5vvXN9HkV_W6zXYF6o-2UM5cHuR4FvTdR1N/pub\">Accessibility Compliance Statement</a> for more information.</p>\n<p>Furthermore, Consider.it offers additional direct help for users of screenreaders. We help each of these folks individually to understand the proposals being discussed and input their opinions. </p>",
	    testimonial: testimonials.sheri
	  }, {
	    id: 'data_export',
	    label: 'Data export',
	    html: 'Export your forum data into CSV format. We can work with you if you have other data requirements.',
	    img: asset('product_page/data_export.png'),
	    paid: true
	  }, {
	    id: 'translation',
	    label: 'Language translation',
	    html: 'We offer interface translations for a number of languages, and can do additional translations with assistance. Furthermore, for multi-lingual websites, we offer Google Translate integration.',
	    img: asset('product_page/translation.gif'),
	    paid: true
	  }
	];

	paid_features = [
	  {
	    id: 'customization',
	    label: 'Customized Look, Feel, and Functionality',
	    html: 'We can work with you to design and implement a forum with the look and feel that you want for your brand. Moreover, we have a number of homepage templates that can organize your community’s ideas to best meet your needs.',
	    img: asset('product_page/customize_homepage.gif')
	  }, {
	    id: 'profile_questions',
	    label: 'Ask demographic and profile questions',
	    html: 'You can ask for additional information from stakeholders when they create an account on your forum. For example, you can ask if they are a Donating Member of your organization. Or you can ask if they are a homeowner. Or you can ask demographic questions like age and race. This information is available in data exports. It can also be used in our opinion analytics described below.',
	    video: 'profile_questions'
	  }, {
	    id: 'opinion_analytics',
	    label: 'Opinion Analytics for survey-like cross-tabs',
	    html: 'You may wish to filter opinions based upon user characteristics or some other differentiator. For example, you might want to learn what Board Members think of a proposal. Or perhaps you want to learn what renters think of a planning proposal, filtering out homeowners. We can help you understand the patterns of thoughts based on whatever segment you\'re interested in examining.',
	    video: 'analytics'
	  }, {
	    id: 'translation',
	    label: 'Multilingual forums & Google Translate',
	    html: 'We offer interface translations in a number of languages, and can do translations to other languages with help. Furthermore, for multi-lingual websites, we offer Google Translate integration.',
	    img: asset('product_page/translation.gif')
	  }, {
	    id: 'moderation',
	    label: 'Content Moderation',
	    html: 'You can choose to review content before it is publicly posted, or just enable moderation for review after posting. The moderation interface enables you to directly contact the author if you wish to ask them to revise a statement that violates community standards. Note that moderation is rarely burdonsome – even for contentious issues, Consider.it tends to foster civil interactions.'
	  }, {
	    id: 'data_export',
	    label: 'Data export',
	    html: 'Export your forum data into CSV format. We can work with you if you have other data requirements.',
	    img: ''
	  }, {
	    id: 'traffic_analytics',
	    label: 'Google Analytics integration',
	    html: 'Add Google Analytics to your forum to understand your forum’s traffic.',
	    img: ''
	  }
	];

	Research = ReactiveComponent({
	  displayName: 'Research',
	  render: function() {
	    var authors, idx, left, paper, papers, reveal, size;
	    authors = function(author_list) {
	      var author, idx;
	      return UL({
	        style: {
	          display: 'inline',
	          position: 'relative',
	          left: 20
	        }
	      }, (function() {
	        var i, len, results;
	        results = [];
	        for (idx = i = 0, len = author_list.length; i < len; idx = ++i) {
	          author = author_list[idx];
	          results.push(LI({
	            key: idx,
	            style: {
	              display: 'inline-block',
	              listStyle: 'none',
	              zIndex: 10 - idx,
	              position: 'absolute',
	              left: 40 * idx,
	              top: 4
	            }
	          }, Avatar({
	            key: "/user/" + author,
	            user: "/user/" + author,
	            img_size: 'large',
	            style: {
	              width: 50,
	              height: 50
	            }
	          })));
	        }
	        return results;
	      })());
	    };
	    papers = [
	      {
	        url: "http://www.sciencedirect.com/science/article/pii/S0747563215003891",
	        title: 'Facilitating Personal Deliberation Online: Effects of Two Consider.it Variations',
	        venue: 'Computers in Human Behavior, Volume 51, Part A',
	        quote: "...<b>working with Consider.it had significant and meaningful effects on \nparticipants’ deliberation and deliberative attitudes</b>. The application urged participants \nto reconsider and often change their original opinion, and the participants generally felt \ntheir knowledge and understanding of the subject-matter had changed.",
	        authors: [324679, 324678]
	      }, {
	        url: "https://dl.dropboxusercontent.com/u/3403211/papers/jitp.pdf",
	        title: 'Facilitating Diverse Political Engagement',
	        venue: 'Journal of Information Technology & Politics, Volume 9, Issue 3',
	        quote: "Citizens rely on group identity cues to direct their political attentions, which \ncan lead to the views of opposing groups being ignored. But many [Consider.it] users \ndid engage with the ideas of users who took stances opposite their own. Over \none-third (33.7%) of point-considering stances recognized points written by \ndissenting others and over half (56.4%) chose to read more about such points. \nTaken together, these metrics show <b>[Consider.it] users embraced political \ndiversity in terms of both arguments and the stances of other users</b>.",
	        authors: [324669, 323666, 324672, 324671, 324670]
	      }, {
	        url: "http://dub.washington.edu/djangosite/media/papers/kriplean-cscw2012.pdf",
	        title: 'Supporting Reflective Public Thought with Consider.it',
	        venue: 'ACM Conference on Computer Supported Cooperative Work',
	        quote: "…Given the partisan rancor of our political discourse, especially in online web forums, \none might expect few people participating in a public [Consider.it] online discussion \nduring a contentious election to acknowledge the importance of factors on both sides \nof the debate. However, we found 41.4% of all Consider.it opinions included \nboth a pro and a con.",
	        authors: [323666, 324672, 324669, 324670, 324671]
	      }, {
	        url: "http://homes.cs.washington.edu/~borning/papers/kriplean-cscw2014.pdf",
	        title: 'On-demand Fact-checking in Public Dialogue',
	        venue: 'ACM Conference on Computer Supported Cooperative Work',
	        authors: [324673, 323666, 324670, 324675, 324674]
	      }
	    ];
	    reveal = (function(_this) {
	      return function() {
	        _this.local.show = !_this.local.show;
	        document.activeElement.blur();
	        return save(_this.local);
	      };
	    })(this);
	    return DIV({
	      style: {
	        minWidth: 500,
	        maxWidth: 700,
	        margin: 'auto',
	        padding: '0px 16px'
	      }
	    }, A({
	      name: 'research'
	    }), H2({
	      style: {
	        fontSize: 42,
	        fontWeight: 800,
	        paddingTop: 60,
	        fontStyle: 'oblique'
	      }
	    }, SPAN({
	      style: {
	        color: '#8D8E8D'
	      }
	    }, 'How do you know Consider.it works?'), SPAN({
	      style: {
	        color: primary_color()
	      }
	    }, ' Has there been research?')), DIV({
	      className: 'embedded',
	      style: {
	        fontSize: 20,
	        maxWidth: 700,
	        margin: '12px auto',
	        paddingBottom: 12,
	        color: 'black'
	      },
	      dangerouslySetInnerHTML: {
	        __html: "<p>Yes! Consider.it was invented at the University of Washington as \n   part of the National Science Foundation funded <b>\n   <a href='" + (asset('product_page/dissertation.pdf')) + "'>doctoral research</a></b> of \n   Consider.it founder Travis Kriplean. Our research objective was to create \n   a method by which large groups of people could civily \n   deliberate together online and find common ground, even on contentious topics. The research was conducted in collaboration with colleagues \n   in Computer Science, Political Communication, Statistics, and \n   Human-centered Design.</p>"
	      }
	    }), this.local.show ? UL({
	      style: {
	        listStyle: 'none',
	        position: 'relative',
	        margin: '20px 0px',
	        paddingBottom: 40
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = papers.length; i < len; idx = ++i) {
	        paper = papers[idx];
	        left = false;
	        size = 20;
	        results.push(LI({
	          key: paper.title,
	          style: {
	            position: 'relative',
	            marginBottom: 30
	          }
	        }, DIV({
	          style: {
	            display: 'inline-block',
	            textAlign: 'left'
	          }
	        }, A({
	          style: {
	            color: '#303030',
	            fontSize: 28,
	            fontWeight: 700,
	            fontStyle: 'oblique',
	            lineHeight: 1.1,
	            textDecoration: 'underline'
	          },
	          href: paper.url
	        }, paper.title), DIV({
	          style: _.extend({}, small_text, {
	            paddingTop: 8,
	            lineHeight: 1.1
	          })
	        }, paper.venue), DIV({
	          style: {
	            display: 'inline',
	            fontSize: 24,
	            fontWeight: 800,
	            fontStyle: 'oblique',
	            color: '#9C9C9C',
	            position: 'relative',
	            top: 18
	          }
	        }, 'Authors: '), authors(paper.authors)), paper.quote ? DIV({
	          style: css.crossbrowserify({
	            padding: '36px 50px',
	            position: 'relative',
	            backgroundColor: considerit_gray,
	            boxShadow: '#b5b5b5 0 1px 1px 0px',
	            borderRadius: 64,
	            marginBottom: 40,
	            flex: 1,
	            marginLeft: 80,
	            marginTop: 70,
	            maxWidth: 600,
	            right: 0,
	            display: 'inline-block'
	          })
	        }, DIV({
	          style: css.crossbrowserify({
	            transform: "rotate(180deg) scale(-1,-1)",
	            position: 'absolute',
	            left: 56,
	            top: -30,
	            zIndex: 2
	          })
	        }, Bubblemouth({
	          apex_xfrac: 0,
	          width: 30,
	          height: 30,
	          fill: considerit_gray,
	          stroke: 'transparent',
	          stroke_width: 0,
	          box_shadow: {
	            dx: -3,
	            dy: 0,
	            stdDeviation: 2,
	            opacity: .1
	          }
	        })), DIV({
	          className: 'embedded',
	          style: {
	            fontSize: 16
	          }
	        }, DIV({
	          dangerouslySetInnerHTML: {
	            __html: paper.quote
	          }
	        }))) : void 0));
	      }
	      return results;
	    })()) : void 0, BUTTON({
	      style: {
	        border: 'none',
	        backgroundColor: '#eee',
	        fontSize: 22,
	        fontWeight: 600,
	        padding: '12px 24px',
	        margin: '12px auto',
	        color: '#303030',
	        display: 'block',
	        width: '100%'
	      },
	      onClick: reveal,
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 32 || e.which === 13) {
	            reveal();
	            e.stopPropagation();
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, (this.local.show ? 'Hide' : 'Show') + " research findings about Consider.it"));
	  }
	});


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var fn, i, len, lvar, ref, responsive, setResponsive;

	__webpack_require__(4);

	setResponsive = function() {
	  var body_width, content_width, decision_board_width, document_width, full_width, gutter, h, homepage_width, k, new_vals, point_font_size, point_width, portrait, proposal_histo_width, reasons_region_width, responsive, results, two_col, v, w, whitespace;
	  responsive = fetch('responsive_vars');
	  w = window.innerWidth;
	  h = window.innerHeight;
	  portrait = h > w;
	  two_col = w < 1080 || browser.is_mobile;
	  document_width = Math.max(900, w);
	  gutter = Math.max(80, w / 10);
	  content_width = document_width - 2 * gutter;
	  whitespace = Math.max(100, w / 10);
	  body_width = two_col ? content_width - 2 * gutter : content_width - 2 * gutter - 2 * whitespace;
	  body_width = Math.min(body_width, 700);
	  proposal_histo_width = 60 * Math.floor(body_width / 60);
	  decision_board_width = body_width + 4;
	  point_width = two_col ? body_width / 2 - 38 : decision_board_width / 2 - 30;
	  reasons_region_width = !two_col ? decision_board_width + 2 * point_width + 76 : decision_board_width;
	  point_font_size = 14;
	  homepage_width = Math.min(content_width, 900);
	  homepage_width = 60 * Math.floor(homepage_width / 60);
	  full_width = Math.max(550, Math.min(1120, w - 2 * 40));
	  if (browser.is_mobile && portrait) {
	    point_font_size += 4;
	  }
	  new_vals = {
	    DOCUMENT_WIDTH: document_width,
	    WINDOW_WIDTH: w,
	    GUTTER: gutter,
	    WHITESPACE: whitespace,
	    BODY_WIDTH: body_width,
	    AUTH_WIDTH: browser.is_mobile ? content_width : Math.max(decision_board_width, 680),
	    TWO_COL: two_col,
	    CONTENT_WIDTH: content_width,
	    PORTRAIT_MOBILE: portrait && browser.is_mobile,
	    LANDSCAPE_MOBILE: !portrait && browser.is_mobile,
	    HOMEPAGE_WIDTH: homepage_width,
	    SAAS_PAGE_WIDTH: full_width
	  };
	  results = [];
	  for (k in new_vals) {
	    v = new_vals[k];
	    if (responsive[k] !== v) {
	      _.extend(responsive, new_vals);
	      save(responsive);
	      break;
	    } else {
	      results.push(void 0);
	    }
	  }
	  return results;
	};

	setResponsive();

	$(window).on("resize.responsive_vars", setResponsive);

	responsive = fetch('responsive_vars');

	ref = _.keys(responsive);
	fn = function(lvar) {
	  return window[lvar] = function() {
	    return fetch('responsive_vars')[lvar];
	  };
	};
	for (i = 0, len = ref.length; i < len; i++) {
	  lvar = ref[i];
	  fn(lvar);
	}


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var dict;

	__webpack_require__(3);

	window.t = function(label, args) {
	  var dictionary, lang, subdomain;
	  subdomain = fetch('/subdomain');
	  lang = subdomain.lang || 'en';
	  if (dict[lang] == null) {
	    throw "Sorry, don't support language " + lang;
	  }
	  dictionary = dict[lang];
	  label = label.replace(/\ /g, '_').toLowerCase();
	  if (dictionary[label] == null) {
	    if (dict.en[label]) {
	      label = dict.en[label];
	    } else {
	      throw "Can't translate " + label + " for language " + lang;
	    }
	  }
	  if (typeof dictionary[label] === 'function') {
	    return dictionary[label](args);
	  } else {
	    return dictionary[label];
	  }
	};

	dict = {};

	dict.en = {
	  or: 'or',
	  and: 'and',
	  done: 'Done',
	  cancel: 'cancel',
	  edit: 'edit',
	  share: 'share',
	  "delete": 'delete',
	  close: 'close',
	  update: 'Update',
	  publish: 'Publish',
	  closed: 'closed',
	  add_new: 'add new'
	};

	dict.cs = {
	  or: 'nebo',
	  and: 'a',
	  done: 'Hotovo',
	  cancel: 'Smazat',
	  edit: 'Upravit',
	  share: 'Sdílet',
	  "delete": 'Smazat',
	  close: 'Zavřít',
	  update: 'Doplnit',
	  publish: 'Uveřejnit',
	  closed: 'Uzavřeno',
	  add_new: 'Přidat nový'
	};

	dict.es = {
	  or: 'ó',
	  and: 'y',
	  done: 'Hecho',
	  cancel: 'cancelar',
	  edit: 'editar',
	  share: 'compartir',
	  "delete": 'eliminar',
	  close: 'cerrar',
	  update: 'Actualizar',
	  publish: 'Publicar',
	  closed: 'cerrado',
	  add_new: 'crear nueva'
	};

	dict.pt = {
	  or: 'ou',
	  and: 'e',
	  done: 'Pronto',
	  cancel: 'cancelar',
	  edit: 'editar',
	  share: 'compartilhar',
	  "delete": 'apagar',
	  close: 'fechar',
	  update: 'Atualizar',
	  publish: 'Publicar',
	  closed: 'fechado',
	  add_new: 'criar novo'
	};

	dict.aeb = {
	  or: 'أو',
	  and: 'و',
	  done: 'منجز',
	  cancel: 'إلغاء',
	  edit: 'تعديل',
	  share: 'أنقل',
	  "delete": 'إحذف',
	  close: 'أغلق',
	  update: 'حدّث',
	  publish: 'أنشر',
	  closed: 'مغلق',
	  add_new: 'إضافة جديدة'
	};

	dict.fr = {
	  or: 'ou',
	  and: 'et',
	  done: 'terminé',
	  cancel: 'annuler',
	  edit: 'modifier',
	  share: 'partager',
	  "delete": 'effacer',
	  close: 'fermer',
	  update: 'mettre a jour',
	  publish: 'publier',
	  closed: 'fermé',
	  add_new: 'ajouter'
	};

	_.extend(dict.en, {
	  give_your_opinion: 'Give your Opinion',
	  update_your_opinion: 'Update your Opinion',
	  comment: 'comment',
	  comments: 'comments',
	  read_more: 'read more',
	  select_these_opinions: 'Select these opinions',
	  prev: 'prev',
	  next: 'next',
	  drag_from_left: function(args) {
	    return "Drag a " + args.noun + " from the left";
	  },
	  drag_from_right: function(args) {
	    return "Drag a " + args.noun + " from the right";
	  },
	  write_a_new_point: function(args) {
	    return "Write a new " + args.noun;
	  },
	  slide_your_overall_opinion: 'Slide Your Overall Opinion',
	  your_opinion: "Your opinion",
	  save_your_opinion: 'Save your opinion',
	  return_to_results: 'Return to results',
	  skip_to_results: 'or just skip to the results',
	  login_to_comment: 'Log in to write a comment',
	  login_to_add_new: 'Log in to share an idea',
	  login_to_save_opinion: 'Log in to save your opinion',
	  discuss_this_point: 'Discuss this Point',
	  save_comment: 'Save comment',
	  write_a_comment: 'Write a comment',
	  write_a_point: 'Write a point',
	  summary_placeholder: 'A succinct summary of your point.',
	  description_placeholder: 'Add background or evidence.',
	  sign_name: 'Sign your name',
	  tip_single: function(args) {
	    return "Make one single point. Add multiple " + args.noun + " if you have more.";
	  },
	  tip_direct: "Be direct. The summary is your main point.",
	  tip_review: "Review your language. Don’t be careless.",
	  tip_attacks: "No personal attacks.",
	  filter_to_watched: "Filter proposals to those you're watching"
	});

	_.extend(dict.cs, {
	  give_your_opinion: 'Přidat názor',
	  update_your_opinion: 'Doplnit názor',
	  comment: 'Komentář',
	  comments: 'Komentáře',
	  read_more: 'Číst více',
	  select_these_opinions: 'Vybrat tyto možnosti',
	  prev: 'předchozí',
	  next: 'další',
	  drag_from_left: function(args) {
	    return "Posunout zleva";
	  },
	  drag_from_right: function(args) {
	    return "Posunout zprava";
	  },
	  write_a_new_point: function(args) {
	    return "Napsat nový";
	  },
	  slide_your_overall_opinion: 'Posunout celkový názor',
	  your_opinion: "Váš názor",
	  save_your_opinion: 'Uložit názor',
	  return_to_results: 'Vrátit se na výsledky',
	  skip_to_results: 'přeskočit na výsledky',
	  login_to_comment: 'Přihlásit se a napsat komentář',
	  login_to_add_new: 'Přihlásit se a přidat nový',
	  login_to_save_opinion: 'Přihlásit se a uložit názor',
	  discuss_this_point: 'Diskutovat o názoru',
	  save_comment: 'Uložit komentář',
	  write_a_comment: 'Napsat komentář',
	  write_a_point: 'Napsat názor',
	  summary_placeholder: 'Stručné shrnutí názoru',
	  description_placeholder: 'Přidat detaily nebo důkazy',
	  sign_name: 'Napsat jméno',
	  tip_single: function(args) {
	    return "Vložte jeden komentář. Přidejte i více komentářů, pokud máte. ";
	  },
	  tip_direct: "Buďte struční. Shrnutí je váš hlavní cíl.",
	  tip_review: "Raději znovu zkontrolujte, co jste napsali.",
	  tip_attacks: "Žádné osobní útoky.",
	  filter_to_watched: "Filtrovat návrhy jen na ty, které sledujete"
	});

	_.extend(dict.es, {
	  give_your_opinion: 'Deja tu Opinion',
	  update_your_opinion: 'Actualizar tu Opinion',
	  comment: 'comentario',
	  comments: 'comentarios',
	  read_more: 'ver más',
	  select_these_opinions: 'Selecciona estas opiniones',
	  prev: 'anterior',
	  next: 'siguiente',
	  drag_from_left: function(args) {
	    return "Arrastra un " + args.noun + " de la izquierda";
	  },
	  drag_from_right: function(args) {
	    return "Arrastra un " + args.noun + " de la derecha";
	  },
	  write_a_new_point: function(args) {
	    return "Escribe un nuevo " + args.noun;
	  },
	  slide_your_overall_opinion: 'Desliza Tu Opinión General',
	  your_opinion: "Tu opinión",
	  save_your_opinion: 'Guarda tu opinión',
	  return_to_results: 'Volver a los resultados',
	  skip_to_results: 'o ir directamente a los resultados',
	  login_to_comment: 'Inicia sesión para comentar',
	  login_to_add_new: 'Inicia sesión para crear nueva',
	  login_to_save_opinion: 'Inicia sesión para guarda tu opinión',
	  discuss_this_point: 'Debatir este Punto',
	  save_comment: 'Guardar comentario',
	  write_a_comment: 'Escribir comentario',
	  write_a_point: 'Escribir un punto de vista',
	  summary_placeholder: 'Un breve resumen de tu punto de vista.',
	  description_placeholder: 'Añadir antecedentes o pruebas',
	  sign_name: 'Firmar con tu nombre',
	  tip_single: function(args) {
	    return "Escribe una única opinión. Añade multiples " + args.noun + " si tienes más.";
	  },
	  tip_direct: "Se directo. El resumen será tu punto de vista principal.",
	  tip_review: "Revisa tu lenguaje. No seas descuidado.",
	  tip_attacks: "No ataques personales.",
	  filter_to_watched: "Filtrar propuestas por las que estás observando"
	});

	_.extend(dict.pt, {
	  give_your_opinion: 'Dê sua opinião',
	  update_your_opinion: 'Atualizar sua opinião',
	  comment: 'comentar',
	  comments: 'comentários',
	  read_more: 'leia mais',
	  select_these_opinions: 'Selecione estas opiniões',
	  prev: 'ant',
	  next: 'prox',
	  drag_from_left: function(args) {
	    return "Arrastar uma " + args.noun + " da esquerda";
	  },
	  drag_from_right: function(args) {
	    return "Arrastar uma " + args.noun + " da direita";
	  },
	  write_a_new_point: function(args) {
	    return "Escrever uma nova " + args.noun;
	  },
	  slide_your_overall_opinion: 'Deslize e defina sua Opinião Geral',
	  your_opinion: "Sua opinião",
	  save_your_opinion: 'Salvar sua opinião',
	  return_to_results: 'Voltar para os resultados',
	  skip_to_results: 'ou vá direto para os resultados',
	  login_to_comment: 'Conecte-se para comentar',
	  login_to_add_new: 'Conecte-se para adicionar um novo',
	  login_to_save_opinion: 'Conecte-se para salvar sua opinião',
	  discuss_this_point: 'Discutir este Ponto',
	  save_comment: 'Salvar comentário',
	  write_a_comment: 'Escrever um comentário',
	  write_a_point: 'Escrever um ponto de vista',
	  summary_placeholder: 'Um breve resumo do seu Ponto de Vista.',
	  description_placeholder: 'Inclua seus argumentos e evidências.',
	  sign_name: 'Assinar',
	  tip_single: function(args) {
	    return "Escreve seu ponto de vista. Inclua multiplos " + args.noun + " se tiver mais.";
	  },
	  tip_direct: "Seja direto. O resumo é seu ponto de vista principal.",
	  tip_review: "Reveja sua linguagem. Não seja desleixado(a).",
	  tip_attacks: "Não faça ataques pessoais.",
	  filter_to_watched: "Filtrar propostas daqueles que está observando"
	});

	_.extend(dict.aeb, {
	  give_your_opinion: 'أبد رأيك',
	  update_your_opinion: 'بد رأيك من جديد',
	  comment: 'علّق',
	  comments: 'تعليقات',
	  read_more: 'اقرأ المزيد',
	  select_these_opinions: 'اختر هذه الآراء',
	  prev: 'السابق',
	  next: 'اللاحق',
	  drag_from_left: function(args) {
	    return "من اليسار " + args.noun + " اسحب";
	  },
	  drag_from_right: function(args) {
	    return "من اليمين " + args.noun + "اسحب";
	  },
	  write_a_new_point: function(args) {
	    return "(ة) جديد " + args.noun + "اكتب";
	  },
	  slide_your_overall_opinion: 'حدّد رأيك العامّ',
	  your_opinion: "رأيك",
	  save_your_opinion: 'احفظ رأيك',
	  return_to_results: 'العودة إلى النتائج',
	  skip_to_results: 'أو مر مباشرة إلى النتائج',
	  login_to_comment: 'سجّل لكتابة تعليق',
	  login_to_add_new: 'سجّل لإضافة الجديد',
	  login_to_save_opinion: 'سجل لحفظ رأيك',
	  discuss_this_point: 'ناقش هذه النقطة',
	  save_comment: 'احفظ التعليق',
	  write_a_comment: 'اكتب تعليق',
	  write_a_point: 'اكتب وجهة نظر',
	  summary_placeholder: 'تلخيص موجز لوجهة نظرك',
	  description_placeholder: '.أضف خلفيّات أو دلائل/ اثباتات',
	  sign_name: 'أدخل اسمك',
	  tip_single: function(args) {
	    return "أبد وجهة نظر واحدة. أضف إن كان لديك المزيد.";
	  },
	  tip_direct: "كن موجزا. الملخص هو وجهة نظرك الرئيسية",
	  tip_review: "راجع لغتك. لا تكن مهملا.",
	  tip_attacks: "الهجوم الشخصي ممنوع",
	  filter_to_watched: "إفرز مقترحات من تتابعهم."
	});

	_.extend(dict.fr, {
	  give_your_opinion: 'Donnez votre opinion',
	  update_your_opinion: 'modifiez votre opinion',
	  comment: 'commentez',
	  comments: 'commentaires',
	  read_more: 'Voir plus',
	  select_these_opinions: 'choisissez ces opinions',
	  prev: 'précédent',
	  next: 'suivant',
	  drag_from_left: function(args) {
	    return "glissez un " + args.noun + " de la gauche";
	  },
	  drag_from_right: function(args) {
	    return "glissez un " + args.noun + " de la droite";
	  },
	  write_a_new_point: function(args) {
	    return "ecrivez un nouvel argument " + args.noun;
	  },
	  slide_your_overall_opinion: 'ajustez votre sentiment général',
	  your_opinion: "votre opinion",
	  save_your_opinion: 'enregistrez votre opinion',
	  return_to_results: 'retour aux résultats',
	  skip_to_results: 'aller directement aux résultats',
	  login_to_comment: 'connectez-vous pour écrire un commentaire',
	  login_to_add_new: 'connectez-vous pour ajouter',
	  login_to_save_opinion: 'connectez-vous pour enregistrer votre opinion',
	  discuss_this_point: 'discutez ce point',
	  save_comment: 'enregistrer le commentaire',
	  write_a_comment: 'Ecrire un commentaire',
	  write_a_point: 'Ecrire un argument',
	  summary_placeholder: 'Un résumé bref de votre argument.',
	  description_placeholder: 'Ajouter du contexte ou des temoignages.',
	  sign_name: 'Signature',
	  tip_single: function(args) {
	    return "Un argument a la fois. Ajoutez plusieurs " + args.noun + " si vous en avez plus.";
	  },
	  tip_direct: "Soyez direct. le résumé est votre argument principal",
	  tip_review: "Soignez votre vocabulaire. Relisez vous.",
	  tip_attacks: "Evitez les attaques personnelles.",
	  filter_to_watched: "Visualiser uniquement les propositions que vous suivez"
	});

	_.extend(dict.en, {
	  create_new_proposal: 'Create new proposal',
	  error_free: "free of language errors",
	  unambiguous: 'unambiguous',
	  make_it: 'Make it',
	  url_instr: "Just letters, numbers, underscores, dashes.",
	  summary: 'Summary',
	  proposal_summary_instr: 'Clear and concise summary',
	  details: 'Details',
	  label: 'Label',
	  expandable_body_instr: 'Text that is shown when expanded',
	  add_expandable: "Add expandable description section",
	  category: 'Category',
	  optional: 'optional',
	  show_on_homepage: 'List on homepage?',
	  open_for_discussion: 'Open for discussion?',
	  permissions_and_invites: 'Permissions'
	});

	_.extend(dict.cs, {
	  create_new_proposal: 'Vytvořit nový návrh',
	  error_free: "bez gramatických chyb",
	  unambiguous: 'jednoznačný',
	  make_it: 'Provést',
	  url_instr: "Jen písmena, číslice, podtržítka, pomlčky.",
	  summary: 'Shrnutí',
	  proposal_summary_instr: 'Cílit na 3-8 slov, podstatných jmen a sloves.',
	  details: 'Detaily',
	  label: 'Štítek',
	  expandable_body_instr: 'Text, který se zobrazí po rozšíření',
	  add_expandable: "Přidat rozšířený popis",
	  category: 'Kategorie',
	  optional: 'Volitelné',
	  show_on_homepage: 'Seznam na homepage?',
	  open_for_discussion: 'Otevřeno pro diskusi?',
	  permissions_and_invites: 'Povolení'
	});

	_.extend(dict.es, {
	  create_new_proposal: 'Crear nueva propuesta',
	  error_free: "libre de errores ortográficos",
	  unambiguous: 'sin ambiguedades',
	  make_it: 'Hazlo',
	  url_instr: "Solo letras, numeros, subrayados, guiones.",
	  summary: 'Resumen',
	  proposal_summary_instr: 'Que sean 3-8 palabras con un verbo y un sustantivo.',
	  details: 'Detalles',
	  label: 'Etiqueta',
	  expandable_body_instr: 'Texto mostrado al expandir',
	  add_expandable: "Añadir una sección de descripción expandible",
	  category: 'Categoría',
	  optional: 'opcional',
	  show_on_homepage: '¿Mostrar en portada?',
	  open_for_discussion: '¿Abierta a debate?',
	  permissions_and_invites: 'Permisos'
	});

	_.extend(dict.pt, {
	  create_new_proposal: 'Criar nova proposta',
	  error_free: "livre de erros ortográficos",
	  unambiguous: 'sem ambiguidades',
	  make_it: 'Faça',
	  url_instr: "Apenas letras, números, underscores e traços.",
	  summary: 'Sumário',
	  proposal_summary_instr: 'Entre 3-8 palavras com um verbo e um substantivo.',
	  details: 'Detalhes',
	  label: 'Rótulo',
	  expandable_body_instr: 'Texto exibido quando expandido',
	  add_expandable: "Adicionar uma seção de descrição expandida",
	  category: 'Categoria',
	  optional: 'opcional',
	  show_on_homepage: 'Exibir na página inicial?',
	  open_for_discussion: 'Abrir para discussão?',
	  permissions_and_invites: 'Permissões'
	});

	_.extend(dict.aeb, {
	  create_new_proposal: 'إحدث مقترح جديد',
	  error_free: "خال من الأخطاء اللغويّة",
	  unambiguous: 'خال من الغموض',
	  make_it: 'أنجز',
	  url_instr: "مجرّد حروف وأرقام وأشرطة سفلية ومطّات",
	  summary: 'ملخص',
	  proposal_summary_instr: 'اهدف إلي 3-8 كلمات من بينها فعل واسم',
	  details: 'تفاصيل',
	  label: ' مسمّى',
	  expandable_body_instr: 'النص الذي يظهر عند التوسيع',
	  add_expandable: "أضف قسم مخصّص للوصف القابل للتوسيع",
	  category: 'فئة',
	  optional: 'اختياري',
	  show_on_homepage: 'أدرج على الصفحة الرئيسية؟',
	  open_for_discussion: 'إفتح للمناقشة؟',
	  permissions_and_invites: 'رخص ودعوات'
	});

	_.extend(dict.fr, {
	  create_new_proposal: 'Créer une nouvelle proposition',
	  error_free: "sans fautes de frappe",
	  unambiguous: 'sans ambiguité',
	  make_it: 'Allez y',
	  url_instr: "Lettres, chiffres, tirets uniquement.",
	  summary: 'Résumé',
	  proposal_summary_instr: 'Visez 3-8 mots avec un verbe et un complement.',
	  details: 'Détails',
	  label: 'Sous-titre',
	  expandable_body_instr: 'Le texte qui s’affiche dans la sous section',
	  add_expandable: "Ajouter une sous section a la description",
	  category: 'Catégorie',
	  optional: 'Optionnel',
	  show_on_homepage: 'Afficher en page principale?',
	  open_for_discussion: 'Ouvert a a discussion?',
	  permissions_and_invites: 'Permissions'
	});

	_.extend(dict.en, {
	  log_in: 'Log in',
	  create_an_account: 'Create an account',
	  create_new_account: 'Create account',
	  log_out: 'Log out',
	  edit_profile: 'Edit Profile',
	  email_settings: 'Email Settings',
	  introduce_yourself: 'Please introduce yourself',
	  complete_registration: 'Complete registration',
	  login_as: 'Your email',
	  password: 'Password',
	  name_prompt: 'Your name',
	  full_name: function(args) {
	    var ref, subdomain;
	    subdomain = fetch('/subdomain');
	    if ((ref = subdomain.name) === 'bitcoin' || ref === 'bitcoinclassic') {
	      return 'user name or company name';
	    } else {
	      return 'first and last name or pseudonym';
	    }
	  },
	  pic_prompt: 'Your picture',
	  your_profile: 'Update Your Profile',
	  updated_successfully: "Updated successfully",
	  reset_your_password: "Reset Your Password",
	  code: 'Code',
	  new_password: 'New password',
	  verification_sent: 'We just emailed you a verification code. Copy / paste it below.',
	  verify: 'Verify',
	  choose_password: "choose a new password",
	  code_from_email: 'verification code from email',
	  verify_your_email: 'Verify Your Email',
	  more_info: 'Please give some info',
	  forgot_password: 'Help! I forgot my password'
	});

	_.extend(dict.cs, {
	  log_in: 'Přihlásit se',
	  create_new_account: 'Vytvořit nový účet',
	  log_out: 'Odhlásit se',
	  edit_profile: 'Upravit profil',
	  email_settings: 'Nastavení e-mailu',
	  introduce_yourself: 'Představte se',
	  complete_registration: 'Dokončit registraci',
	  login_as: 'Ahoj, přihlašuji se jako',
	  password: 'Moje heslo',
	  name_prompt: 'Jmenuji se',
	  full_name: 'Moje jméno',
	  pic_prompt: 'Moje fotka',
	  your_profile: 'Váš profil',
	  updated_successfully: "úspěšně upraven",
	  reset_your_password: "Obnovit heslo",
	  code: 'Kód',
	  new_password: 'Nové heslo',
	  verification_sent: 'Poslali jsme vám ověřovací kód na e-mail. Zkopírujte jej níže.',
	  verify: 'Ověřit',
	  choose_password: "Zvolit nové heslo",
	  code_from_email: 'ověřovací kód z e-mailu',
	  verify_your_email: 'Ověřit e-mail',
	  more_info: 'Prosím doplňte více informací',
	  forgot_password: 'Zapomněl jsem heslo!'
	});

	_.extend(dict.es, {
	  log_in: 'Entrar',
	  create_new_account: 'Registrarse',
	  log_out: 'Salir',
	  edit_profile: 'Editar Perfil',
	  email_settings: 'Configuración de Email',
	  introduce_yourself: 'Descríbete',
	  complete_registration: 'Completar registro',
	  login_as: 'Hola, inicio sesión como',
	  password: 'contraseña',
	  name_prompt: 'Mi nombre es',
	  full_name: 'nombre completo',
	  pic_prompt: 'mi foto',
	  your_profile: 'Tu Perfil',
	  updated_successfully: "Actualizado correctamente",
	  reset_your_password: "Reestablecer Contraseña",
	  code: 'Codigo',
	  new_password: 'Nueva contraseña',
	  verification_sent: 'Te hemos enviado un código de verificación via email.',
	  verify: 'Verificar',
	  choose_password: "elige una nueva contraseña",
	  code_from_email: 'código de verificación recibido',
	  verify_your_email: 'Verifica Tu Email',
	  more_info: 'Por favor, proporciona alguna información',
	  forgot_password: '¡He olvidado mi contraseña!'
	});

	_.extend(dict.pt, {
	  log_in: 'Entrar',
	  create_new_account: 'Criar nova conta',
	  log_out: 'Sair',
	  edit_profile: 'Editar Perfil',
	  email_settings: 'Configurações de Email',
	  introduce_yourself: 'Identifique-se',
	  complete_registration: 'Completar registro',
	  login_as: 'Logar como',
	  password: 'senha',
	  name_prompt: 'Meu nome é',
	  full_name: function(args) {
	    var ref, subdomain;
	    subdomain = fetch('/subdomain');
	    if ((ref = subdomain.name) === 'bitcoin' || ref === 'bitcoinclassic') {
	      return 'nome de usuário ou nome da empresa';
	    } else {
	      return 'nome e sobrenome';
	    }
	  },
	  pic_prompt: 'Minha foto',
	  your_profile: 'Seu Perfil',
	  updated_successfully: "Atualizado com sucesso",
	  reset_your_password: "Criar nova senha",
	  code: 'Código',
	  new_password: 'Nova senha',
	  verification_sent: 'Enviamos um código de verificação para o seu email.',
	  verify: 'Verificar',
	  choose_password: "escolher uma nova senha",
	  code_from_email: 'código de verificação do email',
	  verify_your_email: 'Verifique seu Email',
	  more_info: 'Por favor, forneça algumas informações',
	  forgot_password: 'Esqueci minha senha!'
	});

	_.extend(dict.aeb, {
	  log_in: 'سجّل للخول',
	  create_new_account: 'إنشاء حساب جديد',
	  log_out: 'خروج',
	  edit_profile: 'تعديل البيانات الشخصية',
	  email_settings: 'إعدادات البريد الإلكتروني',
	  introduce_yourself: 'عرف بنفسك',
	  complete_registration: 'اكمل التسجيل',
	  login_as: 'مرحبا،أسجّل الدخول باسم',
	  password: 'كلمه السر',
	  name_prompt: 'اسمي',
	  full_name: 'إسم المستخدم',
	  pic_prompt: 'أنا أشبه',
	  your_profile: 'بياناتك الشخصية',
	  updated_successfully: "تم التحديث بنجاح",
	  reset_your_password: "إعادة تعيين كلمة السر",
	  code: '  رمز',
	  new_password: ' كلمة السر الجديدة',
	  verification_sent: 'لقد أرسلنا إليك رمز التحقق عبر البريد الإلكتروني. انسخ /ألصق أدناه.',
	  verify: 'تحقّق',
	  choose_password: "اختر كلمة سر جديدة",
	  code_from_email: 'رمز التحقق من البريد الإلكتروني',
	  verify_your_email: ' تحقق من البريد الإلكتروني الخاص بك',
	  more_info: 'الرجاء إعطاء بعض المعلومات',
	  forgot_password: 'لقد نسيت كلمة السر الخاصة بي'
	});

	_.extend(dict.fr, {
	  log_in: 'Connection',
	  create_new_account: 'Créez un nouveau compte',
	  log_out: 'Déconnection',
	  edit_profile: 'Editez votre profil',
	  email_settings: 'Réglages des courriels',
	  introduce_yourself: 'Présentez-vous',
	  complete_registration: 'Finalisez votre inscription',
	  login_as: 'Je me connecte avec',
	  password: 'Mon mot de passe est',
	  name_prompt: 'Je m’appelle',
	  full_name: 'Mon nom d’utilisateur est',
	  pic_prompt: 'Je ressemble à',
	  your_profile: 'Votre profil',
	  updated_successfully: "Mise a jour réussie",
	  reset_your_password: "Réinitalisez votre mot de passe",
	  code: 'Code',
	  new_password: 'Nouveau mot de passe',
	  verification_sent: 'Copiez et collez ci-dessous le code de vérification envoyé par courriel.',
	  verify: 'Verification',
	  choose_password: "Choisissez votre nouveau mot de passe",
	  code_from_email: 'code de vérification reçu par courriel',
	  verify_your_email: 'Verifiez votre e mail',
	  more_info: 'Veuillez fournir des informations',
	  forgot_password: 'mot de passe oublié'
	});

	_.extend(dict.en, {
	  send_email: 'Send me email summaries of activity',
	  email_digest_purpose: function(args) {
	    return "The emails summarize relevant new activity for you regarding " + args.project;
	  },
	  digest_timing: "Send email summaries at most",
	  daily: 'daily',
	  hourly: 'hourly',
	  weekly: 'weekly',
	  monthly: 'monthly',
	  notable_events: "Emails are only sent if a notable event occurred. Which events are notable to you?",
	  watched_proposals: 'The proposals you are watching for new activity',
	  unwatch: "Unwatch this proposal",
	  hide_notifications: 'Hide notifications',
	  show_notifications: 'Show notifications',
	  commented_on: "commented on",
	  your_point: 'your point',
	  edited_proposal: 'edited this proposal',
	  added_new_point: 'added a new point',
	  added_opinion: 'added their opinion'
	});

	_.extend(dict.cs, {
	  send_email: 'Posílejte mě novinky na e-mail',
	  email_digest_purpose: function(args) {
	    return "Novinky shrnují poslední aktivity";
	  },
	  digest_timing: "Posílat shrnutí",
	  daily: 'denně',
	  hourly: 'každou hodinu',
	  weekly: 'týdně',
	  monthly: 'měsíčně',
	  notable_events: "E-maily jsou rozesílány, pokud došlo k něčemu zajímavému. Co je pro vás zajímavé?",
	  watched_proposals: 'Návrhy, které sledujete:',
	  unwatch: "Přestat sledovat tento návrh",
	  hide_notifications: 'Skrýt oznámení',
	  show_notifications: 'Ukázat oznámení',
	  commented_on: "Vložen komentář na",
	  your_point: 'váš názor',
	  edited_proposal: 'upravený návrh',
	  added_new_point: 'přidán nový názor',
	  added_opinion: 'přidán jejich názor'
	});

	_.extend(dict.es, {
	  send_email: 'Envíame resúmenes por correo electrónico',
	  email_digest_purpose: function(args) {
	    return "Los resumenes proporcionan información de actividad sobre " + args.project;
	  },
	  digest_timing: "Envíame resúmenes como máximo",
	  daily: 'diariamente',
	  hourly: 'cada hora',
	  weekly: 'semanalmente',
	  monthly: 'mensualmente',
	  notable_events: "Los Emails únicamente se envían si ocurre algo importante. ¿Qué eventos son importantes para tí?",
	  watched_proposals: 'Las propuestas que estás observando:',
	  unwatch: "Dejar de seguir esta propuesta",
	  hide_notifications: 'Ocultar notificaciones',
	  show_notifications: 'Mostrar notificaciones',
	  commented_on: "comentado",
	  your_point: 'tu punto de vista',
	  edited_proposal: 'ha editado esta propuesta',
	  added_new_point: 'ha añadido un nuevo punto de vista',
	  added_opinion: 'ha añadido su opinión'
	});

	_.extend(dict.pt, {
	  send_email: 'Me envie notificações por email',
	  email_digest_purpose: function(args) {
	    return "As notificações resumem novas atividades sobre " + args.project;
	  },
	  digest_timing: "Envie resumos",
	  daily: 'diários',
	  hourly: 'por hora',
	  weekly: 'semanais',
	  monthly: 'mensais',
	  notable_events: "Emails só serão enviados para avisar eventos importantes. Quais eventos são importantes para você?",
	  watched_proposals: 'As propostas que você está seguindo:',
	  unwatch: "Deixar de seguir esta proposta",
	  hide_notifications: 'Ocultar notificações',
	  show_notifications: 'Mostrar notificações',
	  commented_on: "comentado em",
	  your_point: 'seu ponto de vista',
	  edited_proposal: 'editou esta proposta',
	  added_new_point: 'adicionou novo ponto de vista',
	  added_opinion: 'adicionou sua opinião'
	});

	_.extend(dict.aeb, {
	  send_email: 'أرسل لي ملخصات البريد الإلكتروني',
	  email_digest_purpose: function(args) {
	    return args.project + " ترصد الملخّصات الأنشطة الجديدة ذات الجدوى بالنسبة لك نظرا ل";
	  },
	  digest_timing: "أرسل الملخّص كل",
	  daily: 'يوم',
	  hourly: 'ساعة',
	  weekly: 'أسبوع',
	  monthly: 'شهر',
	  notable_events: "يتم إرسال رسائل البريد الإلكتروني إلا إذا وقع حدث بارز.  أي حدث يتمّ اعتباره بارزا بالنسبة لك؟",
	  watched_proposals: 'الاقتراحات التي تشاهدها لهذا النشاط الجديد',
	  unwatch: "عدم مشاهدة هذا الاقتراح",
	  hide_notifications: 'أخف التنبيهات',
	  show_notifications: 'اكشف التنبيهات',
	  commented_on: "علّق على",
	  your_point: 'وجهة نظرك',
	  edited_proposal: 'عدل هذا الاقتراح',
	  added_new_point: 'أضف وجهة نظر أخرى',
	  added_opinion: 'أضافوا أراءهم'
	});

	_.extend(dict.fr, {
	  send_email: 'Envoyez-moi des courriels récapitulaitfs',
	  email_digest_purpose: function(args) {
	    return "Les récapitulatifs résument l’activité nouvelle qui vous intéresse au sujet de " + args.project;
	  },
	  digest_timing: "Fréquence d’envoi maximale",
	  daily: 'quotidienne',
	  hourly: 'toutes les heures',
	  weekly: 'hebdomadaire',
	  monthly: 'mensuelle',
	  notable_events: "Choisissez les évenements qui déclenchent l’envoi d’un courriel recapitulatif?",
	  watched_proposals: 'Les propositions dont vous suivez l’activité:',
	  unwatch: "Ne plus suivre cette proposition",
	  hide_notifications: 'Masquer les notifications',
	  show_notifications: 'Montrer les notifications',
	  commented_on: "Commenté le",
	  your_point: 'votre argument',
	  edited_proposal: 'a edité cette proposition',
	  added_new_point: 'a ajouté un argument',
	  added_opinion: 'ont ajouté leur opinion'
	});

	_.defaults(dict.es, dict.en);

	_.defaults(dict.pt, dict.en);


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** product_page.97dbd79d68b3b1f0b4e5.js
 **/